import styled from '@emotion/styled'
import { SvgIconProps } from '@mui/material'
import { useTranslation } from 'react-i18next'

const SvgLogoIcon = styled('svg')(() => ({
  svg: {
    width: '100%',
    height: '100%',
    '@media (max-width: 1024px)': {
      width: '384px',
      height: '157px',
    },
  },
  marginLeft: '18px',
}))

export const ParticipantsImg = (props: SvgIconProps): JSX.Element => {
  const { t } = useTranslation('general')

  return (
    <SvgLogoIcon
      width="463"
      height="249"
      role="img"
      viewBox="0 0 463 249"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="iconTitleId iconDescId"
      {...props}>
      <title id="iconTitleId">{t('course_intro_image_title')}</title>
      <desc id="iconDescId">{t('course_intro_image_description')}</desc>
      <path
        d="M416.219 66.3418C413.533 66.3418 411.367 68.2372 411.367 70.5493V79.1725C411.367 81.5054 413.533 83.38 416.219 83.38C418.906 83.38 421.072 81.4846 421.072 79.1725V70.5493C421.072 68.2164 418.906 66.3418 416.219 66.3418Z"
        fill="#A3624D"
      />
      <path
        d="M435.564 80.2205L416.051 72.7428V72.7012H415.905H415.738V72.7428L396.871 80.2205C396.871 80.2205 399.328 118.567 399.266 123.753L415.447 139.167H416.447L433.086 123.503C433.023 118.317 435.543 80.2413 435.543 80.2413L435.564 80.2205Z"
        fill="#A3624D"
      />
      <mask
        id="mask0_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="411"
        y="66"
        width="11"
        height="18">
        <path
          d="M416.219 66.3418C413.533 66.3418 411.367 68.2372 411.367 70.5493V79.1725C411.367 81.5054 413.533 83.38 416.219 83.38C418.906 83.38 421.072 81.4846 421.072 79.1725V70.5493C421.072 68.2164 418.906 66.3418 416.219 66.3418Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3666_33194)">
        <path
          d="M416.239 51.218C416.239 51.218 416.302 51.218 416.364 51.218V51.2597C420.55 51.5096 423.715 54.4466 423.715 58.5082C423.715 58.9873 423.632 60.8203 423.611 61.4868C423.569 62.195 423.32 66.5066 423.32 66.5066C422.882 70.5266 420.154 72.318 416.905 72.7345C416.843 72.7345 416.78 72.7345 416.697 72.7345C416.697 72.7345 416.697 72.7345 416.676 72.7345H415.76C415.76 72.7345 415.614 72.7345 415.552 72.7137C412.303 72.2971 409.554 70.5266 409.117 66.4858C409.117 66.4858 408.867 62.1742 408.825 61.466C408.784 60.7786 408.721 58.9456 408.721 58.4874C408.721 54.4257 411.887 51.4888 416.072 51.2389C416.072 51.2389 416.072 51.2389 416.093 51.2389C416.135 51.2389 416.177 51.2389 416.239 51.2389M416.239 50.9264C416.239 50.9264 416.177 50.9264 416.135 50.9264C411.637 51.1764 408.43 54.3632 408.43 58.4666C408.43 58.9665 408.513 60.8411 408.534 61.466C408.575 62.1742 408.825 66.4858 408.825 66.4858C409.221 70.1726 411.595 72.4846 415.51 72.9845C415.593 72.9845 415.677 72.9845 415.76 72.9845H416.676C416.78 72.9845 416.864 72.9845 416.926 72.9845C420.841 72.4846 423.215 70.1725 423.611 66.5066C423.611 66.5066 423.882 62.1742 423.903 61.466C423.944 60.8411 424.007 58.9665 424.007 58.4666C424.007 54.3841 420.862 51.2389 416.489 50.9264C416.447 50.9056 416.406 50.8848 416.364 50.8848H416.239V50.9264Z"
          fill="#E5987D"
        />
      </g>
      <path
        d="M416.781 52.0534C416.781 52.0534 416.385 52.0117 416.218 52.0117C416.052 52.0117 415.656 52.0534 415.656 52.0534C411.616 52.47 408.617 55.3444 408.617 59.2603C408.617 59.7393 408.7 61.5723 408.721 62.2388C408.763 62.947 409.013 67.2586 409.013 67.2586C409.242 72.5492 411.699 73.0491 415.76 73.3824H416.635C420.696 73.0491 423.153 72.5492 423.382 67.2586C423.382 67.2586 423.653 62.947 423.674 62.2388C423.715 61.5515 423.778 59.7185 423.778 59.2603C423.778 55.3652 420.779 52.4908 416.739 52.0534H416.781Z"
        fill="#A3624D"
      />
      <path
        d="M417.238 66.761C417.342 66.761 417.426 66.6864 417.426 66.5944C417.426 66.5023 417.342 66.4277 417.238 66.4277C417.135 66.4277 417.051 66.5023 417.051 66.5944C417.051 66.6864 417.135 66.761 417.238 66.761Z"
        fill="#6A3221"
      />
      <path
        d="M409.055 66.9484C406.681 65.9277 406.806 63.2199 406.806 63.2199C407.077 61.3037 408.805 62.1993 408.805 62.1993L409.076 66.9275L409.055 66.9484ZM423.653 62.2201C423.653 62.2201 425.382 61.3036 425.652 63.2408C425.652 63.2408 425.777 65.9277 423.403 66.9692L423.674 62.241L423.653 62.2201Z"
        fill="#A6624D"
      />
      <path
        d="M422.652 66.9484C422.652 67.5524 423.173 68.0315 423.798 68.0315C424.422 68.0315 424.943 67.5524 424.943 66.9484C424.943 66.3443 424.527 65.9486 423.985 65.8652"
        stroke="#8FAE92"
        strokeWidth="0.14"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M401.704 215.878C401.058 219.565 389.771 224.168 387.918 224.793C387.501 224.939 387.168 225.272 387.105 225.689C387.105 225.751 387.105 225.793 387.105 225.855C387.105 226.501 387.647 227.022 388.334 227.022H401.371H406.847C408.284 227.022 409.451 225.918 409.451 224.564V216.149C409.451 216.149 409.68 212.316 405.411 212.316C401.62 212.316 401.725 215.899 401.725 215.899L401.704 215.878Z"
        fill="#A3624D"
      />
      <path
        d="M413.802 169.45C413.677 165.576 410.158 162.514 405.93 162.618C401.703 162.722 398.371 165.971 398.475 169.846C398.475 170.012 398.475 170.158 398.517 170.304L401.849 218.044C401.849 218.044 401.849 218.148 401.849 218.19C401.911 220.085 403.64 221.585 405.701 221.523C407.763 221.46 409.408 219.877 409.346 217.982C409.346 217.982 413.823 169.95 413.802 169.429V169.45Z"
        fill="#A3624D"
      />
      <path
        d="M416.614 126.332C416.468 121.354 413.449 117.604 408.034 117.75C403.245 117.875 399.35 121.145 398.621 125.332C398.621 125.332 394.686 140.183 398.476 169.698C398.746 173.593 402.12 176.801 406.347 176.697C410.575 176.592 413.574 173.551 413.803 169.469C413.803 169.469 416.635 126.623 416.635 126.353L416.614 126.332Z"
        fill="#A3624D"
      />
      <path
        d="M430.714 215.878C431.359 219.565 442.647 224.168 444.5 224.793C444.916 224.939 445.25 225.272 445.312 225.689C445.312 225.751 445.312 225.793 445.312 225.855C445.312 226.501 444.771 227.022 444.083 227.022H431.047H425.57C424.133 227.022 422.967 225.918 422.967 224.564V216.149C422.967 216.149 422.738 212.316 427.007 212.316C430.797 212.316 430.693 215.899 430.693 215.899L430.714 215.878Z"
        fill="#A3624D"
      />
      <path
        d="M418.633 169.45C418.758 165.576 422.277 162.514 426.505 162.618C430.732 162.722 434.064 165.971 433.96 169.846C433.96 170.012 433.96 170.158 433.918 170.304L430.586 218.044C430.586 218.044 430.586 218.148 430.586 218.19C430.524 220.085 428.795 221.585 426.734 221.523C424.672 221.46 423.027 219.877 423.089 217.982C423.089 217.982 418.612 169.95 418.633 169.429V169.45Z"
        fill="#A3624D"
      />
      <path
        d="M415.802 126.332C415.948 121.354 418.967 117.604 424.382 117.75C429.172 117.875 433.066 121.145 433.795 125.332C433.795 125.332 437.731 140.183 433.941 169.698C433.67 173.593 430.296 176.801 426.069 176.697C421.841 176.592 418.843 173.551 418.613 169.469C418.613 169.469 415.781 126.623 415.781 126.353L415.802 126.332Z"
        fill="#A3624D"
      />
      <path
        d="M438.04 106.542C440.81 106.063 443.517 107.563 444.121 109.896L449.577 134.682C450.16 137.015 449.952 138.557 447.182 139.036C444.413 139.515 443.142 138.39 442.434 136.078C441.872 134.245 434.104 111.645 434.104 111.645C433.521 109.313 435.27 107.021 438.04 106.542Z"
        fill="#A3624D"
      />
      <path
        d="M431.523 79.4877C434.293 79.0295 437 80.55 437.562 82.8829L444.122 109.877C444.684 112.21 442.914 114.481 440.145 114.96C437.375 115.439 434.668 113.897 434.105 111.565L427.546 84.5701C426.983 82.2372 428.753 79.9668 431.523 79.4877Z"
        fill="#A3624D"
      />
      <path
        d="M443.163 139.412C443.08 138.162 443.163 136.954 443.143 136.225L449.515 134.871C449.515 134.871 450.452 138.037 450.91 140.058L451.598 142.37L454.763 149.826C454.909 150.181 454.721 150.597 454.367 150.743C454.284 150.785 454.18 150.785 454.097 150.785L454.18 151.076C454.305 151.576 454.013 152.097 453.493 152.222C453.222 152.284 452.93 152.222 452.722 152.076C452.722 152.493 452.472 152.888 452.056 153.013C451.639 153.138 451.181 152.951 450.973 152.597C450.931 152.972 450.681 153.284 450.306 153.409C449.807 153.555 449.286 153.284 449.119 152.784L446.475 144.348C446.308 144.328 446.162 144.286 446.016 144.244L447.037 147.973C447.183 148.473 447.287 149.118 446.62 149.389C445.871 149.701 445.329 148.827 445.329 148.827C445.329 148.827 442.684 145.098 443.163 139.454V139.412Z"
        fill="#A3624D"
      />
      <mask
        id="mask1_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="443"
        y="134"
        width="12"
        height="20">
        <path
          d="M443.163 139.412C443.08 138.162 443.163 136.954 443.143 136.225L449.515 134.871C449.515 134.871 450.452 138.037 450.91 140.058L451.598 142.37L454.763 149.826C454.909 150.181 454.721 150.597 454.367 150.743C454.284 150.785 454.18 150.785 454.097 150.785L454.18 151.076C454.305 151.576 454.013 152.097 453.493 152.222C453.222 152.284 452.93 152.222 452.722 152.076C452.722 152.493 452.472 152.888 452.056 153.013C451.639 153.138 451.181 152.951 450.973 152.597C450.931 152.972 450.681 153.284 450.306 153.409C449.807 153.555 449.286 153.284 449.119 152.784L446.475 144.348C446.308 144.328 446.162 144.286 446.016 144.244L447.037 147.973C447.183 148.473 447.287 149.118 446.62 149.389C445.871 149.701 445.329 148.827 445.329 148.827C445.329 148.827 442.684 145.098 443.163 139.454V139.412Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_3666_33194)">
        <path
          d="M453.994 150.64L451.724 142.371M448.684 144.204L450.954 152.598M452.682 152.119L450.433 143.767"
          stroke="#6A3221"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M450.744 136.204L441.123 140.474L439.707 136.204L450.182 133.621L450.744 136.204Z" fill="#6A3221" />
      </g>
      <path
        d="M424.88 59.4704C424.88 59.0122 424.63 58.6164 424.234 58.3873C424.422 58.1582 424.547 57.8457 424.547 57.5333C424.547 56.9501 424.172 56.4502 423.63 56.2211C423.672 56.0961 423.693 55.9711 423.693 55.8253C423.693 55.0546 423.026 54.4089 422.214 54.4089C422.172 54.4089 422.11 54.4089 422.068 54.4089C422.11 54.2839 422.152 54.3464 422.152 54.2006C422.152 53.5341 421.589 53.0134 420.902 53.0134C420.86 53.0134 420.819 53.0134 420.777 53.0134C420.673 52.3468 420.069 51.8261 419.319 51.8261C418.965 51.8261 418.653 51.9511 418.403 52.1386C418.132 51.7636 417.695 51.5137 417.174 51.5137C416.8 51.5137 416.466 51.6386 416.196 51.8678C415.946 51.6386 415.592 51.5137 415.217 51.5137C414.696 51.5137 414.259 51.7636 413.988 52.1386C413.738 51.9511 413.426 51.8261 413.072 51.8261C412.343 51.8261 411.718 52.3468 411.614 53.0134C411.573 53.0134 411.531 53.0134 411.489 53.0134C410.802 53.0134 410.24 53.5549 410.24 54.2006C410.24 54.3464 410.261 54.2839 410.323 54.4089C410.281 54.4089 410.219 54.4089 410.177 54.4089C409.365 54.4089 408.699 55.0338 408.699 55.8253C408.699 55.9711 408.72 56.0961 408.761 56.2211C408.22 56.4294 407.845 56.9292 407.845 57.5333C407.845 57.8666 407.97 58.1582 408.157 58.3873C407.782 58.6164 407.512 59.0122 407.512 59.4704C407.512 59.9286 407.762 60.3036 408.116 60.5327C407.928 60.741 407.824 60.9909 407.824 61.2617C407.824 61.7824 408.199 62.2198 408.72 62.3656C408.782 63.3446 409.011 67.2605 409.011 67.2605C409.24 72.5511 411.698 73.051 415.758 73.3843H416.633C420.694 73.051 423.151 72.5511 423.38 67.2605C423.38 67.2605 423.63 63.3238 423.672 62.3656C424.172 62.2407 424.547 61.8033 424.547 61.2825C424.547 61.0118 424.442 60.741 424.255 60.5535C424.63 60.3244 424.859 59.9286 424.859 59.4912L424.88 59.4704ZM422.589 66.0524C422.256 68.302 420.569 68.2811 420.569 68.2811C417.758 67.323 416.217 67.4271 416.217 67.4271C416.217 67.4271 414.675 67.3022 411.864 68.2811C411.864 68.2811 410.177 68.2811 409.844 66.0524C409.511 63.8029 409.657 59.8245 409.657 59.8245C409.657 59.8245 409.469 57.6166 412.052 57.3667C414.259 57.1584 415.821 57.1167 416.217 57.1167C416.612 57.1167 418.174 57.1584 420.382 57.3667C422.964 57.6166 422.776 59.8245 422.776 59.8245C422.776 59.8245 422.922 63.8029 422.589 66.0524Z"
        fill="#C7C7C7"
      />
      <path
        d="M415.427 62.8438C415.364 63.2603 415.219 64.031 414.74 65.135C413.948 66.9471 416.468 66.6347 416.468 66.6347"
        stroke="#6A3221"
        strokeWidth="0.14"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M413.823 61.3631C412.886 61.3631 411.99 61.4464 411.074 61.6547C410.803 61.7172 410.553 61.5505 410.491 61.3214C410.429 61.0715 410.574 60.8215 410.824 60.7382C411.824 60.4674 412.803 60.3216 413.823 60.3008C414.115 60.3008 414.344 60.5091 414.323 60.8007C414.323 60.8423 414.323 60.8632 414.323 60.9256C414.302 61.1756 414.094 61.3839 413.823 61.3839V61.3631Z"
        fill="#C7C7C7"
      />
      <path
        d="M418.113 60.9061C418.113 60.9061 418.113 60.8436 418.113 60.7811C418.113 60.5104 418.322 60.2812 418.613 60.2812C419.634 60.3229 420.633 60.4687 421.612 60.7187C421.883 60.802 422.028 61.0519 421.945 61.3019C421.862 61.5518 421.612 61.6976 421.362 61.6351C420.446 61.4269 419.55 61.3435 418.613 61.3435C418.342 61.3435 418.134 61.1352 418.113 60.8853V60.9061Z"
        fill="#C7C7C7"
      />
      <path
        d="M416.197 68.7811C414.927 68.1978 413.906 68.8435 413.906 68.8435C414.156 69.3434 414.531 69.6767 414.927 69.9058C415.718 70.3641 416.697 70.3641 417.488 69.9058C417.884 69.6975 418.259 69.3643 418.509 68.8435C418.509 68.8435 417.467 68.1978 416.218 68.7811H416.197Z"
        fill="#9D4C46"
      />
      <path
        d="M414.404 62.8642C414.404 62.8642 413.217 61.427 411.238 62.6767C411.238 62.6767 412.717 64.2389 414.404 62.8642Z"
        fill="white"
      />
      <path
        d="M411.238 62.6354C413.092 61.469 414.341 62.8437 414.341 62.8437"
        stroke="#532413"
        strokeWidth="0.14"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M413.426 62.199C413.426 62.199 413.676 62.3657 413.697 62.4698C413.759 62.9281 413.447 63.3655 412.989 63.4279C412.53 63.4904 412.093 63.178 412.031 62.7197C412.01 62.5115 412.031 62.324 412.135 62.1574C412.135 62.1574 412.697 61.8866 413.447 62.1782L413.426 62.199Z"
        fill="#532413"
      />
      <path
        d="M418.027 62.8642C418.027 62.8642 419.214 61.427 421.193 62.6767C421.193 62.6767 419.714 64.2389 418.027 62.8642Z"
        fill="white"
      />
      <path
        d="M421.193 62.6354C419.339 61.469 418.09 62.8437 418.09 62.8437"
        stroke="#532413"
        strokeWidth="0.14"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M419.005 62.199C419.005 62.199 418.755 62.3657 418.735 62.4698C418.672 62.9281 418.984 63.3655 419.443 63.4279C419.901 63.4904 420.338 63.178 420.401 62.7197C420.421 62.5115 420.401 62.324 420.296 62.1574C420.296 62.1574 419.734 61.8866 418.984 62.1782L419.005 62.199Z"
        fill="#532413"
      />
      <mask
        id="mask2_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="407"
        y="51"
        width="18"
        height="23">
        <path
          d="M424.88 59.4704C424.88 59.0122 424.63 58.6164 424.234 58.3873C424.422 58.1582 424.547 57.8457 424.547 57.5333C424.547 56.9501 424.172 56.4502 423.63 56.2211C423.672 56.0961 423.693 55.9711 423.693 55.8253C423.693 55.0546 423.026 54.4089 422.214 54.4089C422.172 54.4089 422.11 54.4089 422.068 54.4089C422.11 54.2839 422.152 54.3464 422.152 54.2006C422.152 53.5341 421.589 53.0134 420.902 53.0134C420.86 53.0134 420.819 53.0134 420.777 53.0134C420.673 52.3468 420.069 51.8261 419.319 51.8261C418.965 51.8261 418.653 51.9511 418.403 52.1386C418.132 51.7636 417.695 51.5137 417.174 51.5137C416.8 51.5137 416.466 51.6386 416.196 51.8678C415.946 51.6386 415.592 51.5137 415.217 51.5137C414.696 51.5137 414.259 51.7636 413.988 52.1386C413.738 51.9511 413.426 51.8261 413.072 51.8261C412.343 51.8261 411.718 52.3468 411.614 53.0134C411.573 53.0134 411.531 53.0134 411.489 53.0134C410.802 53.0134 410.24 53.5549 410.24 54.2006C410.24 54.3464 410.261 54.2839 410.323 54.4089C410.281 54.4089 410.219 54.4089 410.177 54.4089C409.365 54.4089 408.699 55.0338 408.699 55.8253C408.699 55.9711 408.72 56.0961 408.761 56.2211C408.22 56.4294 407.845 56.9292 407.845 57.5333C407.845 57.8666 407.97 58.1582 408.157 58.3873C407.782 58.6164 407.512 59.0122 407.512 59.4704C407.512 59.9286 407.762 60.3036 408.116 60.5327C407.928 60.741 407.824 60.9909 407.824 61.2617C407.824 61.7824 408.199 62.2198 408.72 62.3656C408.782 63.3446 409.011 67.2605 409.011 67.2605C409.24 72.5511 411.698 73.051 415.758 73.3843H416.633C420.694 73.051 423.151 72.5511 423.38 67.2605C423.38 67.2605 423.63 63.3238 423.672 62.3656C424.172 62.2407 424.547 61.8033 424.547 61.2825C424.547 61.0118 424.442 60.741 424.255 60.5535C424.63 60.3244 424.859 59.9286 424.859 59.4912L424.88 59.4704ZM422.589 66.0524C422.256 68.302 420.569 68.2811 420.569 68.2811C417.758 67.323 416.217 67.4271 416.217 67.4271C416.217 67.4271 414.675 67.3022 411.864 68.2811C411.864 68.2811 410.177 68.2811 409.844 66.0524C409.511 63.8029 409.657 59.8245 409.657 59.8245C409.657 59.8245 409.469 57.6166 412.052 57.3667C414.259 57.1584 415.821 57.1167 416.217 57.1167C416.612 57.1167 418.174 57.1584 420.382 57.3667C422.964 57.6166 422.776 59.8245 422.776 59.8245C422.776 59.8245 422.922 63.8029 422.589 66.0524Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_3666_33194)">
        <path
          d="M421.443 54.3671C420.673 54.2005 419.861 54.1172 419.069 54.1172H413.363C412.572 54.1172 411.76 54.2005 410.989 54.3671C409.511 54.7004 408.115 55.2836 406.949 56.1584C407.178 56.4084 407.407 56.6792 407.636 56.9291C408.719 56.1168 409.99 55.6169 411.322 55.3253C412.01 55.1795 412.697 55.117 413.405 55.117H419.069C419.777 55.117 420.465 55.1795 421.152 55.3253C422.485 55.6169 423.755 56.1168 424.838 56.9291C425.067 56.6792 425.296 56.4084 425.525 56.1584C424.359 55.2836 422.964 54.7004 421.485 54.3671H421.443Z"
          fill="#3A3988"
        />
      </g>
      <path
        d="M449.64 133.663C450.681 132.892 451.222 131.538 450.889 130.205L440.956 86.0056C440.31 83.2354 438.353 80.965 435.729 79.8819L423.421 75.4453L422.692 74.0706C422.567 73.8206 422.276 73.6956 422.005 73.7581C421.11 73.9664 418.985 74.4038 416.216 74.5288C413.446 74.4038 411.322 73.9664 410.426 73.7581C410.156 73.6956 409.864 73.8206 409.739 74.0706L409.01 75.4453L396.599 79.8819C393.975 80.965 392.017 83.2562 391.372 86.0056L383.916 102.232C383.604 103.585 388.664 112.438 389.143 110.876L397.265 100.19C397.265 100.19 394.016 110.876 396.245 115.604C397.307 117.833 399.035 118.499 399.035 118.499L398.848 121.519H433.605V118.499L434 118.291L438.415 133.35C438.894 134.933 440.435 135.912 442.039 135.725L442.601 137.953C442.622 138.078 442.747 138.141 442.872 138.12L450.098 136.329C450.223 136.308 450.285 136.183 450.264 136.058L449.681 133.704L449.64 133.663Z"
        fill="#B3CDB1"
      />
      <path
        d="M382.46 75.5936C382.46 75.5936 382.377 77.0516 382.314 77.7598C382.314 77.7598 382.189 79.4262 379.628 80.0719C378.024 80.4676 376.442 78.6972 376.442 78.6972C376.442 78.6972 374.484 77.3016 373.797 71.6361L372.464 64.7416C372.277 63.9293 372.547 63.4919 372.86 63.3252C373.235 63.117 373.526 63.2836 373.609 63.3044L373.547 63.0336C373.464 62.5546 373.797 62.0963 374.276 62.0338C374.547 61.9922 374.796 62.0755 374.984 62.2421C375.005 61.8464 375.275 61.5339 375.671 61.4298C376.504 61.2423 376.691 62.138 376.858 62.4921C376.921 62.1588 377.191 61.8672 377.545 61.8047H377.712C378.149 61.8464 378.503 62.1588 378.587 62.5754C379.024 64.7416 379.94 69.8864 379.94 69.8864H380.273L379.794 66.5954C379.711 66.0955 379.69 65.4707 380.357 65.304C381.106 65.0957 381.523 65.9914 381.523 65.9914C381.523 65.9914 383.314 73.0733 382.418 75.6144L382.46 75.5936Z"
        fill="#A3624D"
      />
      <mask
        id="mask3_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="372"
        y="61"
        width="11"
        height="20">
        <path
          d="M382.46 75.5936C382.46 75.5936 382.377 77.0516 382.314 77.7598C382.314 77.7598 382.189 79.4262 379.628 80.0719C378.024 80.4676 376.442 78.6972 376.442 78.6972C376.442 78.6972 374.484 77.3016 373.797 71.6361L372.464 64.7416C372.277 63.9293 372.547 63.4919 372.86 63.3252C373.235 63.117 373.526 63.2836 373.609 63.3044L373.547 63.0336C373.464 62.5546 373.797 62.0963 374.276 62.0338C374.547 61.9922 374.796 62.0755 374.984 62.2421C375.005 61.8464 375.275 61.5339 375.671 61.4298C376.504 61.2423 376.691 62.138 376.858 62.4921C376.921 62.1588 377.191 61.8672 377.545 61.8047H377.712C378.149 61.8464 378.503 62.1588 378.587 62.5754C379.024 64.7416 379.94 69.8864 379.94 69.8864H380.273L379.794 66.5954C379.711 66.0955 379.69 65.4707 380.357 65.304C381.106 65.0957 381.523 65.9914 381.523 65.9914C381.523 65.9914 383.314 73.0733 382.418 75.6144L382.46 75.5936Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_3666_33194)">
        <path
          d="M375.275 70.6802L373.672 63.4316"
          stroke="#6A3221"
          strokeWidth="0.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M378.189 69.8461L376.648 61.9102"
          stroke="#6A3221"
          strokeWidth="0.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M376.628 70.1182L375.004 62.2031"
          stroke="#6A3221"
          strokeWidth="0.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M374.754 71.0767C374.754 71.0767 376.232 69.8269 379.335 69.9102"
          stroke="#6A3221"
          strokeWidth="0.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M378.672 74.8241C378.672 74.8241 378.672 72.762 381.983 71.1582"
        stroke="#6A3221"
        strokeWidth="0.15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M387.5 111.793C387.5 111.793 387.334 111.918 387.146 111.98C386.688 112.147 385.001 112.272 384.71 112.209C383.398 112.001 380.67 111.314 379.982 109.981C379.441 109.022 376.921 96.6082 374.693 86.1104C374.047 83.111 372.256 79.82 375.484 78.6952L375.297 77.4038C375.234 77.0497 375.547 76.7164 375.984 76.6748L381.919 75.7166C382.356 75.6541 382.731 75.9041 382.794 76.2582L382.96 77.3205L383.002 77.4871C384.501 77.4871 385.48 77.4871 386.459 81.5488C387.938 87.6309 389.208 97.3789 391.124 103.232C391.769 105.19 391.749 106.565 391.207 107.731C390.832 108.543 389.77 111.105 387.521 111.772L387.5 111.793Z"
        fill="#B3CDB1"
      />
      <mask
        id="mask4_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="373"
        y="73"
        width="78"
        height="66">
        <path
          d="M449.641 133.666C450.682 132.896 451.223 131.542 450.89 130.209L440.957 86.0093C440.311 83.2391 438.354 80.9687 435.73 79.8856L423.422 75.449L422.693 74.0743C422.568 73.8243 422.277 73.6785 422.006 73.7618C421.111 73.9701 418.986 74.4075 416.196 74.5325C413.405 74.4075 411.281 73.9701 410.386 73.7618C410.115 73.6993 409.824 73.8243 409.699 74.0743L408.97 75.449L396.558 79.8856C393.934 80.9687 391.977 83.2599 391.331 86.0093L388.582 91.9665C388.27 93.3204 385.896 79.1357 384.979 78.2192C384.313 77.5527 382.959 77.5527 382.959 77.5527C382.959 77.5527 382.959 77.0945 382.501 75.9697L375.233 77.2819L375.483 78.8233C375.483 78.8233 373.505 78.6775 373.859 81.7394C374.65 88.8629 380.023 110.005 380.023 110.005C381.627 110.192 387.437 113.379 387.916 111.817L397.162 100.548L399.015 118.503L398.828 121.523H433.585V118.503L433.98 118.294L438.395 133.354C438.874 134.937 440.415 135.916 442.019 135.728L442.581 137.957C442.602 138.082 442.727 138.145 442.852 138.124L450.078 136.333C450.203 136.312 450.266 136.187 450.245 136.062L449.662 133.708L449.641 133.666Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask4_3666_33194)">
        <path
          d="M429.876 87.5098C429.751 87.5514 429.606 87.6139 429.481 87.6764C429.731 87.968 430.168 88.5929 430.418 89.551C430.522 89.926 430.564 90.3634 430.564 90.8216C430.564 90.9049 430.564 91.0091 430.543 91.0924C430.543 91.0091 430.543 90.9049 430.543 90.8216C430.501 90.2384 430.314 89.7176 430.043 89.2802C429.689 88.7179 429.231 88.3013 428.898 88.0513C428.793 88.1346 428.689 88.218 428.585 88.3221C428.814 88.4887 429.127 88.7595 429.397 89.0928C429.772 89.551 430.105 90.1342 430.147 90.8424C430.147 91.0924 430.147 91.3215 430.085 91.4881C430.105 91.2798 430.085 91.0507 430.043 90.8008C429.897 90.0301 429.335 89.5094 428.773 89.1553C428.544 89.0095 428.335 88.9053 428.148 88.822C428.065 88.9262 428.002 89.0511 427.94 89.1761C428.065 89.2178 428.19 89.2802 428.335 89.3636C428.877 89.6552 429.522 90.1551 429.668 90.8841C429.731 91.1965 429.731 91.4465 429.668 91.6548C429.668 91.0507 429.293 90.53 428.606 90.1551C428.335 90.0093 428.065 89.9051 427.856 89.8426C427.794 89.8426 427.752 89.801 427.711 89.801C427.669 89.9259 427.648 90.0509 427.606 90.1967C427.606 90.1967 427.648 90.1967 427.669 90.1967C428.106 90.3217 429.272 90.7383 429.272 91.6964C429.272 92.0713 429.002 92.1755 428.419 92.1755H426.711V92.5712H429.272C430.21 92.5712 431.001 91.7797 431.001 90.8216C431.001 89.1553 430.314 88.0305 429.918 87.5306L429.876 87.5098Z"
          fill="#5046B5"
        />
        <path
          d="M431.398 91.7578C431.148 91.7578 430.961 91.9245 430.961 92.1536C430.961 92.3827 431.148 92.5493 431.398 92.5493C431.648 92.5493 431.815 92.3827 431.815 92.1536C431.815 91.9245 431.627 91.7578 431.398 91.7578Z"
          fill="#5046B5"
        />
        <path d="M457.199 81.6367H370.672" stroke="#C5DFC3" strokeWidth="0.14" strokeMiterlimit="10" />
        <path d="M457.199 127.836H370.672" stroke="#C5DFC3" strokeWidth="0.14" strokeMiterlimit="10" />
        <path
          d="M413.945 -12.3672C413.945 81.6347 370.691 81.6555 370.691 81.6555"
          stroke="#C5DFC3"
          strokeWidth="0.14"
          strokeMiterlimit="10"
        />
        <path
          d="M435.582 34.6445C435.582 127.855 370.691 127.813 370.691 127.813"
          stroke="#C5DFC3"
          strokeWidth="0.14"
          strokeMiterlimit="10"
        />
        <path
          d="M457.199 81.6523C457.199 81.6523 457.199 163.698 370.672 163.698"
          stroke="#C5DFC3"
          strokeWidth="0.14"
          strokeMiterlimit="10"
        />
        <path d="M413.945 175.678V-12.3672" stroke="#C5DFC3" strokeWidth="0.14" strokeMiterlimit="10" />
        <path d="M435.582 101.172V-12.3672" stroke="#C5DFC3" strokeWidth="0.14" strokeMiterlimit="10" />
        <path
          d="M450.993 133.437L439.122 136.436M399.034 118.461H433.999C433.999 118.461 437.206 116.878 436.79 110.004C436.582 106.734 433.958 92.6536 433.958 92.6536M374.461 78.7398L385.811 76.9277M435.811 57.4733C435.811 68.3044 427.044 77.0735 416.215 77.0735C405.386 77.0735 396.619 68.3044 396.619 57.4733C396.619 46.6421 405.386 37.873 416.215 37.873C427.044 37.873 435.811 46.6421 435.811 57.4733Z"
          stroke="#6F8A71"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M403.764 76.9492L404.617 79.7403C404.93 80.7818 404.159 81.8649 403.055 81.8649H388.895L403.764 76.9492ZM428.67 76.9492L427.816 79.7403C427.504 80.7818 428.274 81.8649 429.378 81.8649H443.539L428.67 76.9492Z"
          fill="#7D9C80"
        />
      </g>
      <path
        d="M433.459 121.211H398.973C398.973 121.211 394.037 132.542 397.39 162.203C398.869 175.179 401.263 214.255 401.263 214.255H411.197L415.924 139.728C415.945 139.395 416.466 139.395 416.486 139.728L421.214 214.255H431.147C431.147 214.255 433.542 175.179 435.021 162.203C438.373 132.542 433.438 121.211 433.438 121.211H433.459Z"
        fill="#3A3988"
      />
      <mask
        id="mask5_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="396"
        y="121"
        width="41"
        height="94">
        <path
          d="M433.459 121.211H398.973C398.973 121.211 394.037 132.542 397.39 162.203C398.869 175.179 401.263 214.255 401.263 214.255H411.197L415.924 139.728C415.945 139.395 416.466 139.395 416.486 139.728L421.214 214.255H431.147C431.147 214.255 433.542 175.179 435.021 162.203C438.373 132.542 433.438 121.211 433.438 121.211H433.459Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask5_3666_33194)">
        <path
          d="M416.464 140.394V113.337M409.488 115.607C409.488 125.001 402.053 132.625 392.89 132.625C383.727 132.625 376.293 125.001 376.293 115.607C376.293 106.213 383.727 98.5898 392.89 98.5898C402.053 98.5898 409.488 106.213 409.488 115.607ZM439.538 98.5898C430.375 98.5898 422.941 106.213 422.941 115.607C422.941 125.001 430.375 132.625 439.538 132.625C448.701 132.625 456.136 125.001 456.136 115.607C456.136 106.213 448.701 98.5898 439.538 98.5898ZM416.464 120.398H413.424V130.167C413.424 131.521 414.507 132.604 415.86 132.604H416.464V120.398Z"
          stroke="#6455E4"
          strokeWidth="0.14"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M416.945 54.9738V54.0156H422.443V54.9738C422.276 55.7653 421.11 56.3693 419.715 56.3693C418.32 56.3693 417.154 55.7653 416.987 54.9738H416.945Z"
        fill="#3A3988"
      />
      <path
        d="M419.694 55.5781C421.212 55.5781 422.443 54.8694 422.443 53.9951C422.443 53.1209 421.212 52.4121 419.694 52.4121C418.176 52.4121 416.945 53.1209 416.945 53.9951C416.945 54.8694 418.176 55.5781 419.694 55.5781Z"
        fill="#6455E4"
      />
      <path
        d="M419.693 54.8466C420.682 54.8466 421.484 54.3803 421.484 53.8051C421.484 53.2299 420.682 52.7637 419.693 52.7637C418.704 52.7637 417.902 53.2299 417.902 53.8051C417.902 54.3803 418.704 54.8466 419.693 54.8466Z"
        fill="#8A80EC"
      />
      <path
        d="M415.467 54.9738V54.0156H409.969V54.9738C410.135 55.7653 411.302 56.3693 412.697 56.3693C414.092 56.3693 415.258 55.7653 415.425 54.9738H415.467Z"
        fill="#3A3988"
      />
      <path
        d="M412.737 55.5781C414.255 55.5781 415.486 54.8694 415.486 53.9951C415.486 53.1209 414.255 52.4121 412.737 52.4121C411.219 52.4121 409.988 53.1209 409.988 53.9951C409.988 54.8694 411.219 55.5781 412.737 55.5781Z"
        fill="#6455E4"
      />
      <path
        d="M412.736 54.8466C413.725 54.8466 414.527 54.3803 414.527 53.8051C414.527 53.2299 413.725 52.7637 412.736 52.7637C411.747 52.7637 410.945 53.2299 410.945 53.8051C410.945 54.3803 411.747 54.8466 412.736 54.8466Z"
        fill="#8A80EC"
      />
      <path
        d="M411.574 211.671C411.574 211.671 412.449 208.589 413.49 209.442C414.635 210.38 411.574 211.671 411.574 211.671Z"
        stroke="#3A3988"
        strokeWidth="0.14"
        strokeMiterlimit="10"
      />
      <path
        d="M387.561 223.71C390.164 221.315 400.473 219.42 400.244 211.692C400.244 211.505 400.431 211.38 400.598 211.442C401.326 211.713 402.909 212.567 403.888 214.171H409.073C409.073 214.171 409.719 212.421 411.385 211.525C411.572 211.421 411.801 211.567 411.781 211.775C411.697 212.421 411.635 213.629 412.03 214.837C413.926 220.586 413.28 225.856 413.197 227.897C413.197 228.251 412.863 228.543 412.489 228.543H407.865C407.553 228.543 407.303 228.314 407.303 228.022V227.293C405.387 227.189 403.95 227.855 402.826 228.543H385.895C385.645 227.46 385.583 225.502 387.54 223.69L387.561 223.71Z"
        fill="#8A80EC"
      />
      <mask
        id="mask6_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="385"
        y="211"
        width="29"
        height="18">
        <path
          d="M387.561 223.71C390.164 221.315 400.473 219.42 400.244 211.692C400.244 211.505 400.431 211.38 400.598 211.442C401.326 211.713 402.909 212.567 403.888 214.171H409.073C409.073 214.171 409.719 212.421 411.385 211.525C411.572 211.421 411.801 211.567 411.781 211.775C411.697 212.421 411.635 213.629 412.03 214.837C413.926 220.586 413.28 225.856 413.197 227.897C413.197 228.251 412.863 228.543 412.489 228.543H407.865C407.553 228.543 407.303 228.314 407.303 228.022V227.293C405.387 227.189 403.95 227.855 402.826 228.543H385.895C385.645 227.46 385.583 225.502 387.54 223.69L387.561 223.71Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask6_3666_33194)">
        <path
          d="M414.239 225.23C408.887 223.855 402.494 225.855 402.494 225.855H384.918M406.555 222.064H406.43C405.118 222.064 404.056 221.002 404.056 219.689V212.92H408.929V219.689C408.929 221.002 407.867 222.064 406.555 222.064Z"
          stroke="#3A3988"
          strokeWidth="0.14"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M420.86 211.671C420.86 211.671 419.985 208.589 418.944 209.442C417.799 210.38 420.86 211.671 420.86 211.671Z"
        stroke="#3A3988"
        strokeWidth="0.14"
        strokeMiterlimit="10"
      />
      <path
        d="M444.871 223.71C442.268 221.315 431.959 219.42 432.188 211.692C432.188 211.505 432.001 211.38 431.834 211.442C431.105 211.713 429.523 212.567 428.544 214.171H423.359C423.359 214.171 422.713 212.421 421.047 211.525C420.86 211.421 420.63 211.567 420.651 211.775C420.735 212.421 420.797 213.629 420.401 214.837C418.506 220.586 419.152 225.856 419.235 227.897C419.235 228.251 419.568 228.543 419.943 228.543H424.566C424.879 228.543 425.129 228.314 425.129 228.022V227.293C427.045 227.189 428.481 227.855 429.606 228.543H446.537C446.787 227.46 446.849 225.502 444.892 223.69L444.871 223.71Z"
        fill="#8A80EC"
      />
      <mask
        id="mask7_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="419"
        y="211"
        width="28"
        height="18">
        <path
          d="M444.871 223.71C442.268 221.315 431.959 219.42 432.188 211.692C432.188 211.505 432.001 211.38 431.834 211.442C431.105 211.713 429.523 212.567 428.544 214.171H423.359C423.359 214.171 422.713 212.421 421.047 211.525C420.86 211.421 420.63 211.567 420.651 211.775C420.735 212.421 420.797 213.629 420.401 214.837C418.506 220.586 419.152 225.856 419.235 227.897C419.235 228.251 419.568 228.543 419.943 228.543H424.566C424.879 228.543 425.129 228.314 425.129 228.022V227.293C427.045 227.189 428.481 227.855 429.606 228.543H446.537C446.787 227.46 446.849 225.502 444.892 223.69L444.871 223.71Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask7_3666_33194)">
        <path
          d="M447.517 225.855H429.941C429.941 225.855 423.547 223.855 418.195 225.23M426.005 222.064H425.88C424.568 222.064 423.506 221.002 423.506 219.689V212.92H428.379V219.689C428.379 221.002 427.317 222.064 426.005 222.064Z"
          stroke="#3A3988"
          strokeWidth="0.14"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M332.294 70.2422C329.899 70.2422 327.941 72.0127 327.941 74.1997V82.3231C327.941 84.5101 329.878 86.2806 332.294 86.2806C334.71 86.2806 336.646 84.5101 336.646 82.3231V74.1997C336.646 72.0127 334.71 70.2422 332.294 70.2422Z"
        fill="#FCD1BA"
      />
      <path
        d="M347.664 122.376C346.893 119.106 346.789 113.357 347.185 110.004L350.496 82.6133L332.441 76.2604V76.2188H332.316H332.149V76.2604L314.094 82.6133L317.405 110.004C317.801 113.357 317.717 119.085 316.926 122.376C315.551 128.187 315.885 133.936 315.843 138.81H348.746C348.684 133.936 349.038 128.187 347.664 122.376Z"
        fill="#FCD1BA"
      />
      <path
        d="M311.572 108.357C308.948 108.066 306.47 109.628 306.054 111.857L302.347 135.456C301.93 137.685 302.222 139.122 304.846 139.413C307.47 139.705 308.594 138.58 309.136 136.372C309.552 134.623 315.57 112.94 315.57 112.94C315.987 110.711 314.217 108.67 311.593 108.357H311.572Z"
        fill="#FCD1BA"
      />
      <path
        d="M316.154 82.5695C313.53 82.2988 311.073 83.8609 310.677 86.1105L306.054 111.855C305.659 114.084 307.47 116.125 310.094 116.396C312.718 116.667 315.176 115.084 315.571 112.855L320.194 87.1103C320.59 84.8816 318.778 82.8403 316.154 82.5695Z"
        fill="#FCD1BA"
      />
      <path
        d="M308.638 139.539C308.638 138.352 308.492 137.227 308.471 136.54L302.411 135.623C302.411 135.623 301.724 138.643 301.391 140.58L300.891 142.788L298.329 149.974C298.225 150.328 298.413 150.703 298.767 150.807C298.85 150.828 298.954 150.849 299.037 150.828L298.975 151.099C298.892 151.578 299.204 152.036 299.683 152.141C299.954 152.182 300.204 152.12 300.412 151.953C300.412 152.349 300.683 152.703 301.078 152.786C301.495 152.89 301.89 152.682 302.078 152.328C302.14 152.661 302.39 152.974 302.744 153.057C303.223 153.182 303.702 152.89 303.806 152.411L305.806 144.33C305.951 144.288 306.097 144.246 306.243 144.205L305.493 147.766C305.368 148.246 305.327 148.85 305.972 149.079C306.701 149.329 307.159 148.475 307.159 148.475C307.159 148.475 309.429 144.809 308.659 139.539H308.638Z"
        fill="#FCD1BA"
      />
      <mask
        id="mask8_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="298"
        y="135"
        width="11"
        height="19">
        <path
          d="M308.638 139.539C308.638 138.352 308.492 137.227 308.471 136.54L302.411 135.623C302.411 135.623 301.724 138.643 301.391 140.58L300.891 142.788L298.329 149.974C298.225 150.328 298.413 150.703 298.767 150.807C298.85 150.828 298.954 150.849 299.037 150.828L298.975 151.099C298.892 151.578 299.204 152.036 299.683 152.141C299.954 152.182 300.204 152.12 300.412 151.953C300.412 152.349 300.683 152.703 301.078 152.786C301.495 152.89 301.89 152.682 302.078 152.328C302.14 152.661 302.39 152.974 302.744 153.057C303.223 153.182 303.702 152.89 303.806 152.411L305.806 144.33C305.951 144.288 306.097 144.246 306.243 144.205L305.493 147.766C305.368 148.246 305.327 148.85 305.972 149.079C306.701 149.329 307.159 148.475 307.159 148.475C307.159 148.475 309.429 144.809 308.659 139.539H308.638Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask8_3666_33194)">
        <path
          d="M300.766 142.785L299.121 150.7M302.057 152.346L303.723 144.327M302.037 143.993L300.412 151.971"
          stroke="#E5987D"
          strokeWidth="0.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M301.348 136.954L310.615 140.412L311.718 136.308L301.722 134.496L301.348 136.954Z" fill="#E5987D" />
      </g>
      <mask
        id="mask9_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="327"
        y="70"
        width="10"
        height="17">
        <path
          d="M332.294 70.2422C329.899 70.2422 327.941 72.0127 327.941 74.1997V82.3231C327.941 84.5101 329.878 86.2806 332.294 86.2806C334.71 86.2806 336.646 84.5101 336.646 82.3231V74.1997C336.646 72.0127 334.71 70.2422 332.294 70.2422Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask9_3666_33194)">
        <path
          d="M336.644 68.4705C336.644 66.2418 334.874 64.4297 332.688 64.4297V76.5522H336.644V68.4705Z"
          fill="#E5987D"
        />
        <path
          d="M332.314 56.0149C332.314 56.0149 332.376 56.0149 332.418 56.0149C336.166 56.2649 338.998 59.056 338.998 62.8677C338.998 63.3051 338.936 65.0339 338.894 65.6796C338.853 66.3462 338.624 70.4078 338.624 70.4078C338.249 74.1988 335.791 75.8651 332.876 76.2608C332.813 76.2608 332.751 76.2608 332.688 76.2608C332.688 76.2608 332.688 76.2608 332.668 76.2608H331.855C331.855 76.2608 331.73 76.2608 331.668 76.24C328.752 75.8443 326.295 74.1779 325.92 70.387C325.92 70.387 325.691 66.3253 325.65 65.6588C325.629 65.0131 325.545 63.2843 325.545 62.8469C325.545 59.0352 328.378 56.2649 332.126 56.0357C332.168 56.0357 332.209 56.0357 332.251 56.0357M332.251 55.7441C332.251 55.7441 332.189 55.7441 332.168 55.7441C328.128 55.9941 325.254 58.9727 325.254 62.8469C325.254 63.3051 325.316 65.0756 325.358 65.6796C325.4 66.3462 325.629 70.4078 325.629 70.4078C325.983 73.8863 328.107 76.0525 331.626 76.5316C331.71 76.5316 331.772 76.5316 331.855 76.5316H332.668C332.772 76.5316 332.834 76.5316 332.897 76.5316C336.416 76.0525 338.54 73.8863 338.894 70.4287C338.894 70.4287 339.123 66.367 339.165 65.7005C339.186 65.1172 339.269 63.3468 339.269 62.8677C339.269 59.0351 336.437 56.0774 332.543 55.7858C332.501 55.765 332.459 55.7441 332.418 55.7441H332.314H332.251Z"
          fill="#E5987D"
        />
      </g>
      <path
        d="M332.42 56.0358L332.316 55.9941C332.316 55.9941 332.233 55.9941 332.191 55.9941C328.36 56.2233 325.465 58.9935 325.465 62.8053C325.465 63.2427 325.527 64.9715 325.569 65.6172C325.611 66.2837 325.84 70.3454 325.84 70.3454C326.235 74.1363 328.734 75.8026 331.712 76.1984C331.733 76.1984 332.004 76.2192 332.275 76.2192C332.587 76.2192 332.92 76.2192 332.941 76.2192C335.919 75.8235 338.418 74.1571 338.814 70.3662C338.814 70.3662 339.043 66.3046 339.084 65.638C339.105 64.9923 339.189 63.2635 339.189 62.8261C339.189 59.0144 336.294 56.2441 332.462 56.015L332.42 56.0358Z"
        fill="#FCD1BA"
      />
      <path
        d="M330.982 67.4512C330.982 67.4512 331.128 68.201 330.899 69.4924C330.669 70.7838 332.19 70.6589 332.19 70.6589"
        stroke="#E5987D"
        strokeWidth="0.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M332.732 70.7389C332.812 70.7389 332.877 70.6736 332.877 70.5931C332.877 70.5126 332.812 70.4473 332.732 70.4473C332.651 70.4473 332.586 70.5126 332.586 70.5931C332.586 70.6736 332.651 70.7389 332.732 70.7389Z"
        fill="#E5987D"
      />
      <path
        d="M330.443 67.366C330.443 67.366 329.401 65.6163 327.277 66.6995C327.277 66.6995 328.36 68.7615 330.443 67.366Z"
        fill="white"
      />
      <path
        d="M327.297 66.6772C329.421 65.6149 330.462 67.3437 330.462 67.3437"
        stroke="#3A3988"
        strokeWidth="0.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M329.63 66.5334C329.734 66.5959 329.879 66.7417 329.9 66.8667C329.921 67.3874 329.525 67.8248 329.026 67.8456C328.526 67.8664 328.068 67.4707 328.047 66.9708C328.047 66.7417 328.109 66.5334 328.234 66.3667C328.234 66.3667 328.88 66.1376 329.65 66.5334H329.63Z"
        fill="#3A3988"
      />
      <path
        d="M334.148 67.366C334.148 67.366 335.19 65.6163 337.314 66.6995C337.314 66.6995 336.231 68.7615 334.148 67.366Z"
        fill="white"
      />
      <path
        d="M337.314 66.6772C335.19 65.6149 334.148 67.3437 334.148 67.3437"
        stroke="#3A3988"
        strokeWidth="0.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M334.959 66.5334C334.855 66.5959 334.709 66.7417 334.688 66.8667C334.667 67.3874 335.063 67.8248 335.563 67.8456C336.063 67.8664 336.521 67.4707 336.542 66.9708C336.542 66.7417 336.479 66.5334 336.354 66.3667C336.354 66.3667 335.709 66.1376 334.938 66.5334H334.959Z"
        fill="#3A3988"
      />
      <path
        d="M332.295 71.9902C331.733 71.9902 331.191 72.2194 330.879 72.3652C330.879 72.3652 331.566 72.6151 332.295 72.5943C333.024 72.5943 333.711 72.3652 333.711 72.3652C333.399 72.2402 332.857 71.9902 332.295 71.9902Z"
        fill="#E5987D"
      />
      <path
        d="M334.377 72.1973C333.398 72.8013 331.129 72.7805 330.254 72.2598"
        stroke="#E77453"
        strokeWidth="0.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M332.773 73.3438C332.627 73.3854 332.461 73.4062 332.294 73.4062C332.127 73.4062 331.961 73.3854 331.836 73.3438"
        stroke="#E5987D"
        strokeWidth="0.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M329.92 65.3441C329.462 65.3024 328.463 65.1983 327.338 65.1358C327.192 65.1358 327.067 64.99 327.088 64.8025C327.088 64.6567 327.213 64.5317 327.338 64.5109C328.692 64.3443 329.608 64.4692 330.025 64.5734C330.17 64.5942 330.254 64.74 330.233 64.9066V65.0733C330.191 65.2399 330.066 65.3649 329.92 65.3441ZM334.669 65.3441C335.127 65.3024 336.126 65.1983 337.251 65.1358C337.397 65.1358 337.522 64.99 337.501 64.8025C337.501 64.6567 337.376 64.5317 337.251 64.5109C335.897 64.3443 334.981 64.4692 334.564 64.5734C334.419 64.5942 334.335 64.74 334.356 64.9066V65.0733C334.398 65.2399 334.523 65.3649 334.669 65.3441Z"
        fill="#D06148"
      />
      <path
        d="M325.818 70.366C323.694 69.4078 324.068 66.9083 324.068 66.9083C324.298 65.4503 325.568 65.8877 325.568 65.8877L325.818 70.366ZM338.792 70.366C340.916 69.4078 340.541 66.9083 340.541 66.9083C340.312 65.4503 339.042 65.8877 339.042 65.8877L338.792 70.366Z"
        fill="#FCD1BA"
      />
      <mask
        id="mask10_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="324"
        y="55"
        width="17"
        height="22">
        <path
          d="M340.541 66.9086C340.312 65.4506 339.042 65.888 339.042 65.888C339.042 65.888 339.042 65.8047 339.042 65.6589C339.062 65.0132 339.146 63.2843 339.146 62.8469C339.146 59.0352 336.251 56.2649 332.419 56.0358L332.315 55.9941C332.315 55.9941 332.232 55.9941 332.19 55.9941C328.358 56.2233 325.464 58.9935 325.464 62.8053C325.464 63.2427 325.526 64.9715 325.568 65.6172C325.568 65.6797 325.568 65.763 325.568 65.8671C325.568 65.8671 324.298 65.4297 324.068 66.8878C324.068 66.8878 323.694 69.3873 325.818 70.3454C326.213 74.1363 328.712 75.8026 331.69 76.1984C331.711 76.1984 331.982 76.2192 332.253 76.2192C332.565 76.2192 332.898 76.2192 332.919 76.2192C335.897 75.8235 338.396 74.1571 338.792 70.3662C340.916 69.3873 340.541 66.8878 340.541 66.8878V66.9086Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask10_3666_33194)">
        <path
          d="M338.833 71.6797L339.25 65.2227M325.776 71.6797L325.359 65.2227"
          stroke="#E5987D"
          strokeWidth="0.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M318.405 215.583C317.801 219.228 305.723 223.811 303.974 224.436C303.578 224.581 303.266 224.915 303.203 225.331C303.203 225.394 303.203 225.435 303.203 225.498C303.203 226.144 303.724 226.644 304.348 226.644H318.072H323.237C324.59 226.644 325.694 225.54 325.694 224.186V215.833C325.694 215.833 325.902 212.042 321.883 212.021C318.301 212.021 318.405 215.562 318.405 215.562V215.583Z"
        fill="#FCD1BA"
      />
      <path
        d="M330.151 169.492C330.068 165.638 326.778 162.577 322.8 162.66C318.823 162.743 315.657 165.93 315.72 169.783C315.72 169.929 315.72 170.096 315.74 170.242L318.489 217.649C318.489 217.649 318.489 217.753 318.489 217.795C318.531 219.69 320.135 221.19 322.092 221.148C324.05 221.106 325.591 219.544 325.549 217.67C325.549 217.67 330.151 170.033 330.151 169.492Z"
        fill="#FCD1BA"
      />
      <path
        d="M332.087 126.834C331.982 121.897 330.275 118.023 325.173 118.127C320.654 118.21 316.968 121.418 316.239 125.584C316.239 125.584 313.948 134.207 315.739 169.617C315.947 173.47 319.113 176.699 323.09 176.615C327.068 176.532 329.9 173.553 330.171 169.492C330.171 169.492 332.087 127.104 332.087 126.834Z"
        fill="#FCD1BA"
      />
      <path
        d="M333.608 151.35C333.087 139.81 332.504 126.979 332.504 126.834C332.608 121.897 334.316 118.023 339.418 118.127C343.937 118.21 347.623 121.418 348.352 125.584C348.352 125.584 349.809 131.083 349.497 151.35"
        fill="#FCD1BA"
      />
      <path
        d="M324.921 65.8255L324.816 62.5969L327.253 62.2012V62.472C327.253 62.472 326.545 63.0343 326.357 64.3258C326.295 64.7215 326.128 65.638 325.545 65.8879C325.545 65.8879 325.379 65.8255 324.921 65.8255ZM339.685 65.8255L339.79 62.5969L337.353 62.2012V62.472C337.353 62.472 338.061 63.0343 338.248 64.3258C338.311 64.7215 338.478 65.638 339.061 65.8879C339.061 65.8879 339.227 65.8255 339.685 65.8255Z"
        fill="#D06148"
      />
      <path
        d="M325.047 65.5494L326.567 66.3409M338 66.3409L339.52 65.5494M333.564 67.5282C333.169 67.3615 332.731 67.2782 332.273 67.2782C331.815 67.2782 331.399 67.3615 331.024 67.5282M331.003 67.5073C331.003 68.8196 329.941 69.8819 328.629 69.8819C327.317 69.8819 326.255 68.8196 326.255 67.5073C326.255 66.1951 327.317 65.1328 328.629 65.1328C329.941 65.1328 331.003 66.1951 331.003 67.5073ZM335.938 65.1328C337.25 65.1328 338.312 66.1951 338.312 67.5073C338.312 68.8196 337.25 69.8819 335.938 69.8819C334.626 69.8819 333.564 68.8196 333.564 67.5073C333.564 66.1951 334.626 65.1328 335.938 65.1328Z"
        stroke="#C9765B"
        strokeWidth="0.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M343.686 168.014H340.375V216.733H343.686V168.014Z" fill="#8FAE92" />
      <path
        d="M342.957 212.336H341.124C340.666 212.336 340.228 212.461 339.833 212.69C338.604 213.44 337.792 214.835 337.834 216.398C337.896 218.647 339.77 220.48 342.019 220.48C344.268 220.48 346.226 218.606 346.226 216.273C346.226 214.794 345.456 213.482 344.289 212.732C343.894 212.482 343.415 212.336 342.936 212.336H342.957Z"
        fill="#B3CDB1"
      />
      <path d="M326.774 213.961H319.152V217.439H326.774V213.961Z" fill="#464EBA" />
      <path
        d="M327.774 215.209C327.42 214.688 326.712 214.563 326.212 214.959C325.025 215.896 322.589 217.354 320.569 215.855C318.986 214.688 318.049 213.626 317.361 214.063C310.697 218.188 305.512 219.104 302.846 221.708C301.18 223.312 301.347 226.748 301.472 227.936C301.514 228.29 301.805 228.561 302.18 228.561H305.595C306.074 227.936 306.824 227.519 307.678 227.519C308.532 227.519 309.281 227.936 309.76 228.561H313.53C314.009 227.936 314.758 227.519 315.612 227.519C316.466 227.519 317.216 227.936 317.695 228.561H321.464C321.943 227.936 322.693 227.519 323.546 227.519C324.4 227.519 325.15 227.936 325.629 228.561H328.482C328.857 228.561 329.169 228.269 329.19 227.873C329.273 225.707 329.898 218.271 327.816 215.188L327.774 215.209Z"
        fill="#6455E4"
      />
      <mask
        id="mask11_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="301"
        y="213"
        width="29"
        height="16">
        <path
          d="M302.159 228.558H328.44C328.815 228.558 329.128 228.266 329.148 227.871C329.232 225.704 329.856 218.268 327.774 215.186C327.42 214.665 326.712 214.54 326.212 214.936C325.025 215.873 322.589 217.331 320.569 215.831C318.986 214.665 318.049 213.603 317.361 214.04C310.697 218.164 305.512 219.081 302.846 221.684C301.18 223.288 301.347 226.725 301.472 227.912C301.514 228.266 301.805 228.537 302.18 228.537L302.159 228.558Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask11_3666_33194)">
        <path
          d="M322.066 212.125C322.066 217.061 318.046 221.081 313.111 221.081C308.175 221.081 304.156 217.061 304.156 212.125C304.156 207.188 308.175 203.168 313.111 203.168C318.046 203.168 322.066 207.188 322.066 212.125ZM330.125 223.914L330.396 218.644C330.104 218.602 329.792 218.582 329.479 218.582C326.147 218.582 323.357 220.831 322.524 223.893H330.125V223.914Z"
          fill="#8A80EC"
        />
        <path
          d="M301.512 224.038H331.208M310.175 215.873L312.445 218.643M312.091 214.498L314.548 217.518"
          stroke="#AFADF2"
          strokeWidth="0.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M312.34 215.189L329.312 218.646V214.793L312.34 215.189Z" fill="#5046B5" />
      </g>
      <path
        d="M361.739 221.689C359.073 219.085 353.888 218.19 347.224 214.045C346.537 213.628 345.6 214.67 344.017 215.836C341.997 217.336 339.56 215.857 338.373 214.94C337.874 214.566 337.166 214.67 336.812 215.19C334.729 218.273 335.354 225.688 335.437 227.875C335.437 228.25 335.77 228.563 336.145 228.563H339.227C339.706 227.938 340.456 227.521 341.31 227.521C342.164 227.521 342.913 227.938 343.392 228.563H347.162C347.641 227.938 348.39 227.521 349.244 227.521C350.098 227.521 350.848 227.938 351.327 228.563H355.096C355.575 227.938 356.325 227.521 357.178 227.521C358.032 227.521 358.782 227.938 359.261 228.563H362.426C362.78 228.563 363.093 228.292 363.134 227.938C363.259 226.73 363.405 223.314 361.76 221.71L361.739 221.689Z"
        fill="#6455E4"
      />
      <mask
        id="mask12_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="335"
        y="213"
        width="29"
        height="16">
        <path
          d="M362.426 228.558H336.145C335.77 228.558 335.458 228.266 335.437 227.871C335.354 225.704 334.729 218.268 336.812 215.186C337.166 214.665 337.874 214.54 338.373 214.936C339.56 215.873 341.997 217.331 344.017 215.831C345.6 214.665 346.537 213.603 347.224 214.04C353.888 218.164 359.073 219.081 361.739 221.684C363.405 223.288 363.238 226.725 363.113 227.912C363.072 228.266 362.78 228.537 362.405 228.537L362.426 228.558Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask12_3666_33194)">
        <path
          d="M351.329 203.168C356.264 203.168 360.284 207.188 360.284 212.125C360.284 217.061 356.264 221.081 351.329 221.081C346.393 221.081 342.374 217.061 342.374 212.125C342.374 207.188 346.393 203.168 351.329 203.168ZM341.895 223.893C341.062 220.831 338.272 218.582 334.94 218.582C334.627 218.582 334.336 218.582 334.023 218.644L334.294 223.914H341.895V223.893Z"
          fill="#8A80EC"
        />
        <path
          d="M333.355 224.039H363.052M352.119 218.644L354.389 215.874M350.015 217.499L352.473 214.479"
          stroke="#AFADF2"
          strokeWidth="0.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M347.663 120.729H316.925C312.24 146.14 313.218 162.637 313.239 215.272H330.378L331.773 138.808H332.815L333.044 151.347H351.057C350.599 140.495 349.62 131.393 347.663 120.729Z"
        fill="#8A80EC"
      />
      <mask
        id="mask13_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="313"
        y="120"
        width="39"
        height="96">
        <path
          d="M347.663 120.729H316.925C312.24 146.14 313.218 162.637 313.239 215.272H330.378L331.773 138.808H332.815L333.044 151.347H351.057C350.599 140.495 349.62 131.393 347.663 120.729Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask13_3666_33194)">
        <path
          d="M315.738 124.499H349.537M327.9 138.454H336.688M312.219 211.044H331.253M321.902 124.478V120.77M323.235 124.478V120.77M341.332 124.478V120.77M342.665 124.478V120.77M329.024 120.77V135.496C329.024 137.121 330.336 138.433 331.961 138.433H332.273M334.106 124.478C335.147 124.478 335.98 123.645 335.98 122.603C335.98 121.562 335.147 120.729 334.106 120.729"
          stroke="#6455E4"
          strokeWidth="0.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M360.43 94.7369L355.245 86.9884C354.641 84.4473 352.704 82.4269 350.184 81.6978L337.835 78.1152L332.296 83.3642L326.756 78.1152L314.407 81.6978C311.866 82.4269 309.93 84.4473 309.347 86.9884L308.16 91.9874L300.246 136.458L310.846 138.478L316.927 112.587V120.794H347.664L350.372 100.777L358.41 112.837L364.449 108.817L360.43 94.7369Z"
        fill="#3A3988"
      />
      <mask
        id="mask14_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="300"
        y="78"
        width="67"
        height="61">
        <path
          d="M356.432 91.9679L355.245 86.9689C354.641 84.4277 352.704 82.4073 350.184 81.6783L337.835 78.0957L332.296 83.3446L326.756 78.0957L314.407 81.6783C311.866 82.4073 309.93 84.4277 309.347 86.9689L308.16 91.9679L300.246 136.438L310.846 138.459L316.927 112.568V120.775H347.664L350.372 100.758L355.745 114.318L366.449 110.797L356.411 91.9471L356.432 91.9679Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask14_3666_33194)">
        <path
          d="M318.362 80.2422L319.174 82.8875C319.486 83.8873 318.736 84.8871 317.695 84.8871H304.367L318.362 80.263V80.2422ZM346.246 80.2422L345.434 82.8875C345.122 83.8873 345.871 84.8871 346.913 84.8871H360.24L346.246 80.263V80.2422Z"
          fill="#6455E4"
        />
        <path
          d="M318.279 94.1564H325.568M300.266 132.524L312.032 134.627M321.924 78.8262L329.421 86.6996L332.294 83.3669M364.323 132.544L352.557 134.648M342.665 78.847L335.168 86.7204L332.294 83.3878V120.818M335.418 91.5944C335.418 92.136 334.981 92.5734 334.439 92.5734C333.898 92.5734 333.461 92.136 333.461 91.5944C333.461 91.0529 333.898 90.6155 334.439 90.6155C334.981 90.6155 335.418 91.0529 335.418 91.5944ZM334.439 101.009C333.898 101.009 333.461 101.447 333.461 101.988C333.461 102.53 333.898 102.967 334.439 102.967C334.981 102.967 335.418 102.53 335.418 101.988C335.418 101.447 334.981 101.009 334.439 101.009ZM334.439 111.382C333.898 111.382 333.461 111.82 333.461 112.361C333.461 112.903 333.898 113.34 334.439 113.34C334.981 113.34 335.418 112.903 335.418 112.361C335.418 111.82 334.981 111.382 334.439 111.382Z"
          stroke="#8A80EC"
          strokeWidth="0.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M314.094 94.9043L316.926 112.567"
          stroke="#262A5A"
          strokeWidth="0.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M343.665 90.1562C343.541 90.1979 343.416 90.2396 343.311 90.3021C343.541 90.5728 343.957 91.1769 344.186 92.0725C344.269 92.4266 344.332 92.8224 344.332 93.2806C344.332 93.3639 344.332 93.4472 344.311 93.5306C344.311 93.4472 344.311 93.3639 344.311 93.2806C344.29 92.7182 344.082 92.2392 343.832 91.8434C343.499 91.3018 343.062 90.9269 342.749 90.677C342.645 90.7603 342.541 90.8436 342.458 90.9269C342.666 91.0936 342.957 91.3227 343.228 91.6559C343.582 92.0725 343.895 92.6349 343.915 93.3014C343.915 93.5514 343.915 93.7389 343.853 93.9055C343.874 93.718 343.853 93.5097 343.811 93.2598C343.686 92.5308 343.145 92.0309 342.624 91.7184C342.416 91.5935 342.208 91.4893 342.041 91.406C341.979 91.5101 341.895 91.6143 341.833 91.7393C341.937 91.7809 342.062 91.8434 342.187 91.9059C342.707 92.1767 343.311 92.6557 343.436 93.3431C343.499 93.6347 343.478 93.8847 343.436 94.0721C343.436 93.5097 343.082 93.0098 342.437 92.6557C342.187 92.5099 341.916 92.4266 341.729 92.3641C341.666 92.3641 341.625 92.3433 341.583 92.3225C341.541 92.4474 341.521 92.5724 341.5 92.6974C341.5 92.6974 341.541 92.6974 341.562 92.6974C341.958 92.8224 343.062 93.1973 343.062 94.1138C343.062 94.4679 342.812 94.5512 342.249 94.5512H340.625V94.9261H343.041C343.936 94.9261 344.665 94.1971 344.665 93.2806C344.665 91.6976 344.019 90.6561 343.645 90.1771L343.665 90.1562Z"
          fill="#6455E4"
        />
        <path
          d="M345.103 94.1562C344.874 94.1562 344.707 94.3229 344.707 94.5312C344.707 94.7395 344.874 94.9061 345.103 94.9061C345.332 94.9061 345.498 94.7395 345.498 94.5312C345.498 94.3229 345.332 94.1562 345.103 94.1562Z"
          fill="#6455E4"
        />
      </g>
      <path
        d="M324.59 61.7826C325.402 58.2833 328.547 55.6797 332.295 55.6797C336.044 55.6797 339.251 58.3458 340.021 61.9076L324.59 61.7826Z"
        fill="#8A80EC"
      />
      <path
        d="M340.29 62.3047L340.144 60.5967C340.144 60.3676 339.978 60.201 339.749 60.1385C339.186 60.0135 335.792 59.2637 332.273 59.2637C328.753 59.2637 325.359 60.0135 324.796 60.1385C324.588 60.1801 324.422 60.3676 324.401 60.5967L324.255 62.3047C324.234 62.638 324.526 62.9088 324.859 62.8463C325.192 62.7838 328.753 62.1173 332.252 62.1173C335.75 62.1173 339.311 62.763 339.645 62.8463C339.978 62.9088 340.269 62.638 340.248 62.3047H340.29Z"
        fill="#8A80EC"
      />
      <mask
        id="mask15_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="324"
        y="55"
        width="17"
        height="7">
        <path
          d="M324.59 61.7826C325.402 58.2833 328.547 55.6797 332.295 55.6797C336.044 55.6797 339.251 58.3458 340.021 61.9076L324.59 61.7826Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask15_3666_33194)">
        <path
          d="M332.314 59.261C335.813 59.261 339.207 59.99 339.77 60.1358C339.978 60.1775 340.145 60.365 340.165 60.5941L340.311 62.3021C340.332 62.5937 340.103 62.8436 339.811 62.8436C339.77 62.8436 339.749 62.8436 339.707 62.8436C339.353 62.7811 335.875 62.1146 332.314 62.1146C328.816 62.1146 325.255 62.7603 324.922 62.8436C324.88 62.8436 324.859 62.8436 324.817 62.8436C324.526 62.8436 324.297 62.5937 324.318 62.3021L324.463 60.5941C324.463 60.365 324.63 60.1983 324.859 60.1358C325.4 60.0109 328.92 59.261 332.335 59.261M332.335 58.9902C328.628 58.9902 324.838 59.8651 324.797 59.8651C324.463 59.9484 324.213 60.2192 324.193 60.5733L324.047 62.2812C324.047 62.4895 324.109 62.7187 324.255 62.8853C324.401 63.0519 324.609 63.1352 324.838 63.1352C324.88 63.1352 324.942 63.1352 324.984 63.1352C325.026 63.1352 328.712 62.427 332.335 62.427C335.959 62.427 339.541 63.1144 339.686 63.1352C339.728 63.1352 339.791 63.1352 339.832 63.1352C340.04 63.1352 340.27 63.0519 340.415 62.8853C340.561 62.7187 340.644 62.5104 340.624 62.2812L340.478 60.5733C340.457 60.24 340.207 59.9484 339.874 59.8651C339.478 59.7818 335.98 58.9902 332.356 58.9902H332.335Z"
          fill="#A9AEF3"
        />
      </g>
      <path
        d="M342.395 169.949H341.687C336.897 169.949 333.023 166.075 333.023 161.284V151.328H351.058V161.284C351.058 166.075 347.184 169.949 342.395 169.949ZM335.606 175.261C334.71 180.739 333.669 192.674 337.876 207.359C338.396 209.129 340.021 210.358 341.853 210.358C344.04 210.358 345.852 208.65 345.997 206.463L347.809 176.115C347.934 173.907 346.185 172.032 343.957 172.032H339.396C337.501 172.032 335.897 173.407 335.585 175.261H335.606Z"
        fill="#B3CDB1"
      />
      <path
        d="M363.178 77.9702C363.178 77.9702 363.407 79.4075 363.532 80.0948C363.532 80.0948 363.845 81.7195 366.427 82.0944C368.051 82.3235 369.426 80.4073 369.426 80.4073C369.426 80.4073 371.217 78.8242 371.321 73.1795L371.925 66.2434C372.029 65.4103 371.716 65.0145 371.383 64.8895C370.988 64.7229 370.738 64.9104 370.654 64.9312V64.6604C370.696 64.1814 370.342 63.7648 369.863 63.744C369.592 63.744 369.363 63.8273 369.176 64.0147C369.113 63.6398 368.801 63.3482 368.405 63.2857C367.551 63.1816 367.489 64.0772 367.343 64.4521C367.239 64.1189 366.968 63.8689 366.593 63.8273H366.427C366.01 63.9314 365.677 64.2647 365.636 64.7021C365.427 66.8683 365.052 72.0339 365.052 72.0339L364.719 72.0756L364.844 68.7846C364.886 68.2847 364.844 67.6806 364.157 67.5557C363.386 67.4307 363.074 68.368 363.074 68.368C363.074 68.368 362.033 75.5332 363.178 77.9494V77.9702Z"
        fill="#FCD1BA"
      />
      <mask
        id="mask16_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="362"
        y="63"
        width="10"
        height="20">
        <path
          d="M363.178 77.9702C363.178 77.9702 363.407 79.4075 363.532 80.0948C363.532 80.0948 363.845 81.7195 366.427 82.0944C368.051 82.3235 369.426 80.4073 369.426 80.4073C369.426 80.4073 371.217 78.8242 371.321 73.1795L371.925 66.2434C372.029 65.4103 371.716 65.0145 371.383 64.8895C370.988 64.7229 370.738 64.9104 370.654 64.9312V64.6604C370.696 64.1814 370.342 63.7648 369.863 63.744C369.592 63.744 369.363 63.8273 369.176 64.0147C369.113 63.6398 368.801 63.3482 368.405 63.2857C367.551 63.1816 367.489 64.0772 367.343 64.4521C367.239 64.1189 366.968 63.8689 366.593 63.8273H366.427C366.01 63.9314 365.677 64.2647 365.636 64.7021C365.427 66.8683 365.052 72.0339 365.052 72.0339L364.719 72.0756L364.844 68.7846C364.886 68.2847 364.844 67.6806 364.157 67.5557C363.386 67.4307 363.074 68.368 363.074 68.368C363.074 68.368 362.033 75.5332 363.178 77.9494V77.9702Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask16_3666_33194)">
        <path
          d="M369.758 72.3664L370.591 65.0762"
          stroke="#E5987D"
          strokeWidth="0.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M366.801 71.8656L367.509 63.8672"
          stroke="#E5987D"
          strokeWidth="0.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M368.363 71.9717L369.175 63.9941"
          stroke="#E5987D"
          strokeWidth="0.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M370.3 72.7197C370.3 72.7197 368.718 71.6365 365.656 72.0323"
          stroke="#E5987D"
          strokeWidth="0.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M362.827 108.917C365.742 109.146 366.471 108.188 366.658 105.751L369.657 79.1105C369.845 76.6735 369.865 75.1738 366.95 74.9446C364.034 74.7155 363.93 75.2154 363.618 77.6316C363.368 79.5479 359.224 103.897 359.224 103.897C359.036 106.334 359.89 108.688 362.806 108.917H362.827Z"
        fill="#FCD1BA"
      />
      <path
        d="M361.97 114.687C365.135 114.937 367.884 112.834 368.113 109.98L371.945 79.5695L361.387 78.7988L356.597 108.501C356.368 111.355 358.825 114.437 361.99 114.687H361.97Z"
        fill="#3A3988"
      />
      <path
        d="M366.844 76.8014C366.844 76.8014 366.635 74.7602 363.199 73.5312"
        stroke="#E5987D"
        strokeWidth="0.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M360.887 81.8398L371.549 82.6314"
        stroke="#8A80EC"
        strokeWidth="0.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.1952 73.2167L63.2569 75.7995L64.4439 75.2163L56.8636 63.3228C53.8648 57.5323 50.5953 56.5117 50.5953 56.5117L39.808 65.2391C39.5789 73.1542 44.8685 84.7144 44.8685 84.7144L56.0098 79.2988L55.4684 76.716C55.4684 76.716 55.4892 76.6743 55.51 76.6951L57.2801 78.6947L62.3614 76.2369L61.1536 73.2375C61.1536 73.2375 61.1744 73.1958 61.1952 73.2167Z"
        fill="#E8BC72"
      />
      <path
        d="M33.1831 217.232C32.6 220.398 21.4795 224.126 19.8343 224.668C19.4595 224.793 19.1679 225.084 19.1055 225.438C19.1055 225.48 19.1055 225.543 19.1055 225.584C19.1055 226.126 19.5844 226.584 20.1884 226.584H33.1831H38.077C39.3473 226.584 40.3886 225.626 40.3886 224.459V217.211C40.3886 217.211 40.5968 213.92 36.7858 213.92C33.3914 213.92 33.1831 217.211 33.1831 217.211V217.232Z"
        fill="#FFDFC5"
      />
      <path
        d="M43.6596 170.674C43.4722 166.967 40.036 164.092 35.9752 164.259C31.9143 164.425 28.7698 167.571 28.9572 171.299C28.9572 171.445 28.978 171.591 28.9988 171.737L33.1013 217.373C33.1013 217.373 33.1013 217.477 33.1013 217.519C33.1846 219.331 34.8715 220.747 36.8707 220.664C38.8698 220.581 40.3901 219.039 40.3068 217.227C40.3068 217.227 43.6804 171.195 43.6596 170.674Z"
        fill="#FFDFC5"
      />
      <path
        d="M46.9916 129.476C46.7625 124.727 42.3477 121.04 37.1414 121.249C32.5391 121.436 28.8531 124.623 28.2284 128.643C28.2284 128.643 26.125 136.995 28.9364 171.114C29.2696 174.821 32.5599 177.862 36.6208 177.696C40.6817 177.529 43.493 174.592 43.6388 170.655L47.0124 130.247H46.9708C46.9708 129.997 46.9708 129.726 46.9708 129.476H46.9916Z"
        fill="#FFDFC5"
      />
      <path
        d="M61.1528 217.232C61.7359 220.398 72.8564 224.126 74.5015 224.668C74.8764 224.793 75.1679 225.084 75.2304 225.438C75.2304 225.48 75.2304 225.543 75.2304 225.584C75.2304 226.126 74.7514 226.584 74.1475 226.584H61.1528H56.2589C54.9886 226.584 53.9473 225.626 53.9473 224.459V217.211C53.9473 217.211 53.7391 213.92 57.55 213.92C60.9445 213.92 61.1528 217.211 61.1528 217.211V217.232Z"
        fill="#FFDFC5"
      />
      <path
        d="M50.6759 170.674C50.8633 166.967 54.2994 164.092 58.3603 164.259C62.4211 164.425 65.5657 167.571 65.3783 171.299C65.3783 171.445 65.3575 171.591 65.3366 171.737L61.2341 217.373C61.2341 217.373 61.2341 217.477 61.2341 217.519C61.1508 219.331 59.464 220.747 57.4648 220.664C55.4656 220.581 53.9454 219.039 54.0287 217.227C54.0287 217.227 50.6551 171.195 50.6759 170.674Z"
        fill="#FFDFC5"
      />
      <path
        d="M47.345 129.476C47.5741 124.727 51.989 121.04 57.1952 121.249C61.7976 121.436 65.4836 124.623 66.1083 128.643C66.1083 128.643 68.2116 136.995 65.4003 171.114C65.0671 174.821 61.7767 177.862 57.7159 177.696C53.655 177.529 50.8436 174.592 50.6979 170.655L47.3242 130.247H47.3659C47.3659 129.997 47.3659 129.726 47.3659 129.476H47.345Z"
        fill="#FFDFC5"
      />
      <path
        d="M61.6114 112.564C60.945 110.502 60.7784 108.335 61.1532 106.211L65.1933 83.0697L47.1381 76.9043L29.2286 83.1322L33.1437 106.211C33.5186 108.335 33.3728 110.502 32.6856 112.564C32.6856 112.564 28.2082 126.144 27.875 130.768H66.4011C65.6931 124.061 61.5697 112.585 61.5697 112.585L61.6114 112.564Z"
        fill="#FFE1C8"
      />
      <path
        d="M47.1781 69.5742C44.929 69.5742 43.1172 71.3655 43.1172 73.5526V81.6968C43.1172 83.9047 44.929 85.6751 47.1781 85.6751C49.4271 85.6751 51.2389 83.8838 51.2389 81.6968V73.5526C51.2389 71.3447 49.4271 69.5742 47.1781 69.5742Z"
        fill="#FFDFC5"
      />
      <path
        d="M72.231 139.142C72.231 137.997 72.3768 136.872 72.3976 136.206L78.3119 135.039C78.3119 135.039 79.0199 138.247 79.3323 140.142L79.8321 142.308L82.3311 149.349C82.4352 149.682 82.2478 150.057 81.9146 150.161C81.8313 150.182 81.748 150.203 81.6647 150.182L81.7272 150.453C81.8105 150.932 81.5189 151.369 81.0399 151.473C80.7692 151.515 80.5193 151.452 80.3319 151.307C80.3319 151.682 80.0612 152.036 79.6655 152.119C79.2698 152.223 78.8741 152.015 78.6867 151.661C78.6451 151.994 78.3952 152.286 78.0411 152.369C77.583 152.494 77.104 152.202 76.9999 151.744L75.0424 143.829C74.8966 143.787 74.7508 143.766 74.6259 143.704L75.3547 147.182C75.4797 147.641 75.5213 148.245 74.8966 148.453C74.1885 148.703 73.7304 147.87 73.7304 147.87C73.7304 147.87 71.5021 144.287 72.2518 139.122L72.231 139.142Z"
        fill="#FFDFC5"
      />
      <mask
        id="mask17_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="72"
        y="135"
        width="11"
        height="18">
        <path
          d="M72.231 139.142C72.231 137.997 72.3768 136.872 72.3976 136.206L78.3119 135.039C78.3119 135.039 79.0199 138.247 79.3323 140.142L79.8321 142.308L82.3311 149.349C82.4352 149.682 82.2478 150.057 81.9146 150.161C81.8313 150.182 81.748 150.203 81.6647 150.182L81.7272 150.453C81.8105 150.932 81.5189 151.369 81.0399 151.473C80.7692 151.515 80.5193 151.452 80.3319 151.307C80.3319 151.682 80.0612 152.036 79.6655 152.119C79.2698 152.223 78.8741 152.015 78.6867 151.661C78.6451 151.994 78.3952 152.286 78.0411 152.369C77.583 152.494 77.104 152.202 76.9999 151.744L75.0424 143.829C74.8966 143.787 74.7508 143.766 74.6259 143.704L75.3547 147.182C75.4797 147.641 75.5213 148.245 74.8966 148.453C74.1885 148.703 73.7304 147.87 73.7304 147.87C73.7304 147.87 71.5021 144.287 72.2518 139.122L72.231 139.142Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask17_3666_33194)">
        <path
          d="M79.9533 142.312L81.5776 150.061M78.6829 151.665L77.0586 143.812M78.7246 143.5L80.3281 151.311"
          stroke="#FBC5AC"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path d="M79.4347 135.977L70.355 139.352L69.293 135.353L79.0599 133.582L79.4347 135.977Z" fill="#FBC5AC" />
      </g>
      <path
        d="M53.7368 65.9289C54.0492 65.6789 54.6948 65.2623 55.3195 65.8039C55.9235 66.3246 56.0276 68.1993 53.362 69.9697L53.7577 65.9289H53.7368ZM40.5963 65.9289C40.2839 65.6789 39.6384 65.2623 39.0136 65.8039C38.4097 66.3246 38.3056 68.1993 40.9712 69.9697L40.5755 65.9289H40.5963Z"
        fill="#FFDFC5"
      />
      <mask
        id="mask18_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="43"
        y="69"
        width="9"
        height="17">
        <path
          d="M47.1781 69.5742C44.929 69.5742 43.1172 71.3655 43.1172 73.5526V81.6968C43.1172 83.9047 44.929 85.6751 47.1781 85.6751C49.4271 85.6751 51.2389 83.8838 51.2389 81.6968V73.5526C51.2389 71.3447 49.4271 69.5742 47.1781 69.5742Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask18_3666_33194)">
        <path
          d="M52.5903 68.035C52.5903 65.8271 50.1537 64.0566 47.1758 64.0566V75.9917H52.5903V68.035Z"
          fill="#FBC5AC"
        />
        <path
          d="M47.3853 55.7239C51.0088 56.0571 53.7369 58.7233 53.7369 62.4517C53.7369 62.8891 53.7785 64.9095 53.7369 65.5552C53.7369 65.6386 53.7369 65.7635 53.7369 65.9093L53.3412 69.9502C52.5915 74.0952 50.1134 75.6365 47.2187 75.6782C47.2187 75.6782 47.177 75.6782 47.1562 75.6782C47.1562 75.6782 47.1146 75.6782 47.0937 75.6782C44.1991 75.6365 41.7209 74.0952 40.9712 69.9502L40.5755 65.9093C40.5755 65.7635 40.5755 65.6386 40.5755 65.5552C40.5547 64.9095 40.5755 62.8891 40.5755 62.4517C40.5755 58.7233 43.3036 56.0571 46.9271 55.7239H47.3436M47.3436 55.4323H46.9063C42.9704 55.8072 40.2632 58.6816 40.2632 62.4517C40.2632 62.5767 40.2632 62.8474 40.2632 63.1599C40.2632 63.9722 40.2423 65.097 40.2632 65.5552V65.9093L40.6797 69.9502C41.5335 74.6367 44.4073 75.8032 46.8022 75.9281H47.0937L47.177 75.6365V75.9281H47.4686C49.8635 75.8032 52.7581 74.6576 53.6119 69.9502L54.0076 65.8885V65.5136C54.0493 65.0553 54.0284 63.9306 54.0076 63.1182C54.0076 62.785 54.0076 62.535 54.0076 62.41C54.0076 58.64 51.2796 55.7447 47.3853 55.3906L47.3436 55.4323Z"
          fill="#FBC5AC"
        />
      </g>
      <path
        d="M41.8283 69.9691C41.8283 70.719 41.2244 71.323 40.4747 71.323C39.725 71.323 39.1211 70.719 39.1211 69.9691C39.1211 69.2818 39.6209 68.7194 40.2665 68.6152"
        stroke="#8A80EC"
        strokeWidth="0.14"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M52.5117 69.9691C52.5117 70.719 53.1156 71.323 53.8653 71.323C54.615 71.323 55.219 70.719 55.219 69.9691C55.219 69.2818 54.7192 68.7194 54.0736 68.6152"
        stroke="#8A80EC"
        strokeWidth="0.14"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <mask
        id="mask19_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="38"
        y="65"
        width="18"
        height="5">
        <path
          d="M53.7368 65.9289C54.0492 65.6789 54.6948 65.2623 55.3195 65.8039C55.9235 66.3246 56.0276 68.1993 53.362 69.9697L53.7577 65.9289H53.7368ZM40.5963 65.9289C40.2839 65.6789 39.6384 65.2623 39.0136 65.8039C38.4097 66.3246 38.3056 68.1993 40.9712 69.9697L40.5755 65.9289H40.5963Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask19_3666_33194)">
        <path
          d="M40.8266 70.3258C40.8266 70.3258 40.4518 67.9097 40.3477 65.4102M53.509 70.3258C53.509 70.3258 53.8839 67.9097 53.988 65.4102"
          stroke="#FBC5AC"
          strokeWidth="0.14"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M53.7398 65.9296C53.7398 65.7838 53.7398 65.6588 53.7398 65.5755C53.7606 64.9298 53.7398 62.9094 53.7398 62.472C53.7398 58.7435 51.0117 56.0774 47.3882 55.7441H46.9717C43.3481 56.0774 40.6201 58.7435 40.6201 62.472C40.6201 62.9094 40.5784 64.9298 40.6201 65.5755C40.6201 65.6588 40.6201 65.7838 40.6201 65.9296L41.0157 69.9704C41.7654 74.1154 44.2436 75.6568 47.1383 75.6984C47.1383 75.6984 47.1799 75.6984 47.2008 75.6984C47.2008 75.6984 47.2424 75.6984 47.2632 75.6984C50.1579 75.6568 52.6361 74.1154 53.3858 69.9704L53.7814 65.9296H53.7398Z"
        fill="#FFDFC5"
      />
      <mask
        id="mask20_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="40"
        y="55"
        width="14"
        height="21">
        <path
          d="M53.7593 62.472C53.7593 58.7435 51.0312 56.0774 47.4077 55.7441H46.9912C43.3677 56.0774 40.6396 58.7435 40.6396 62.472C40.6396 62.9094 40.598 64.9298 40.6396 65.5755C40.6813 66.242 40.827 68.4499 40.952 69.3664C41.5559 73.9696 44.1382 75.6568 47.1578 75.6984C47.1578 75.6984 47.1995 75.6984 47.2203 75.6984C47.2203 75.6984 47.2619 75.6984 47.2828 75.6984C50.3024 75.6568 52.8847 73.9696 53.4886 69.3664C53.6135 68.4499 53.7801 66.242 53.801 65.5755C53.8218 64.9298 53.801 62.9094 53.801 62.472H53.7593Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask20_3666_33194)">
        <path
          d="M40.889 71.366L40.0977 65.4297"
          stroke="#DC8D74"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M53.4688 71.366L54.2601 65.4297"
          stroke="#DC8D74"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.4286 66.1152C46.4286 66.1152 46.6577 67.0109 46.3245 68.8855C46.0954 70.1144 47.0533 69.9686 47.0533 69.9686"
          stroke="#FBC5AC"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M47.595 70.1334C47.6755 70.1334 47.7408 70.0681 47.7408 69.9876C47.7408 69.9071 47.6755 69.8418 47.595 69.8418C47.5145 69.8418 47.4492 69.9071 47.4492 69.9876C47.4492 70.0681 47.5145 70.1334 47.595 70.1334Z"
          fill="#FBC5AC"
        />
        <path
          d="M45.5533 66.6372C45.5533 66.6372 44.2413 65.2625 42.1172 66.3456C42.1172 66.3456 43.3667 67.637 45.5533 66.6372Z"
          fill="white"
        />
        <mask
          id="mask21_3666_33194"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="42"
          y="65"
          width="4"
          height="3">
          <path
            d="M45.5533 66.6372C45.5533 66.6372 44.2413 65.2625 42.1172 66.3456C42.1172 66.3456 43.3875 67.6578 45.5533 66.6372Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask21_3666_33194)">
          <path
            d="M44.6777 65.9522C44.6777 65.9522 44.761 66.1605 44.761 66.2854C44.7818 66.7645 44.407 67.1811 43.928 67.2019C43.449 67.2228 43.0325 66.8478 43.0117 66.3688C43.0117 66.1605 43.0742 65.973 43.1783 65.8064C43.1783 65.8064 43.9488 65.5564 44.6777 65.9522Z"
            fill="#3A3988"
          />
        </g>
        <path
          d="M42.0547 66.2405C44.1164 65.1157 45.5741 66.5738 45.5741 66.5738"
          stroke="#3A3988"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M48.7812 66.6372C48.7812 66.6372 50.0932 65.2625 52.2174 66.3456C52.2174 66.3456 50.9679 67.637 48.7812 66.6372Z"
          fill="white"
        />
        <mask
          id="mask22_3666_33194"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="48"
          y="65"
          width="5"
          height="3">
          <path
            d="M48.7812 66.6372C48.7812 66.6372 50.0932 65.2625 52.2174 66.3456C52.2174 66.3456 50.947 67.6578 48.7812 66.6372Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask22_3666_33194)">
          <path
            d="M49.6544 65.9522C49.6544 65.9522 49.5711 66.1605 49.5711 66.2854C49.5503 66.7645 49.9252 67.1811 50.4041 67.2019C50.8831 67.2228 51.2996 66.8478 51.3204 66.3688C51.3204 66.1605 51.258 65.973 51.1538 65.8064C51.1538 65.8064 50.3833 65.5564 49.6544 65.9522Z"
            fill="#3A3988"
          />
        </g>
        <path
          d="M52.2811 66.2405C50.2195 65.1157 48.7617 66.5738 48.7617 66.5738"
          stroke="#3A3988"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.1789 71.1152C46.3459 71.1152 45.8461 71.4901 45.1172 71.6568C45.1172 71.6568 46.1168 72.0109 47.1789 71.9901C48.2409 71.9901 49.2405 71.6568 49.2405 71.6568C48.595 71.5943 47.991 71.1152 47.1789 71.1152Z"
          fill="#FF9577"
        />
        <path
          d="M47.1789 71.968L45.1172 71.6348C45.1172 71.6348 45.8669 72.9678 47.1789 72.9678C48.5741 72.9678 49.2405 71.6348 49.2405 71.6348L47.1789 71.968Z"
          fill="#FF9577"
        />
        <path
          d="M49.6373 71.4492C49.1584 71.6783 48.1796 71.9908 47.18 71.9908C46.1804 71.9908 45.2016 71.6992 44.7227 71.4492"
          stroke="#E77453"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <path
        d="M49.158 61.5544L51.303 64.533H55.2389L51.7195 59.0341C51.7195 59.0341 48.3875 56.847 46.8464 56.9095C45.3054 56.972 42.4524 58.2426 41.8276 58.9508C41.2029 59.659 40.5781 64.533 40.5781 64.533H49.6578L48.9914 61.6377C48.9706 61.5336 49.0955 61.4711 49.1788 61.5544H49.158Z"
        fill="#E8BC72"
      />
      <path
        d="M47.1805 55.6797C42.9947 55.6797 39.6211 59.1998 39.6211 63.5531C39.6211 64.2405 39.7044 64.8862 39.8502 65.511L40.5999 65.9276C40.5582 65.4902 40.4749 58.0959 47.1805 57.6793C53.8862 58.0959 53.7821 65.4902 53.7612 65.9276L54.5109 65.511C54.6567 64.8862 54.74 64.2196 54.74 63.5531C54.74 59.1998 51.3455 55.6797 47.1805 55.6797Z"
        fill="#6455E4"
      />
      <path
        d="M51.5553 59.5332C52.9922 60.8038 55.2413 64.5114 55.2413 64.5114H51.2845L49.7852 62.3868L51.5553 59.5332Z"
        fill="#E8BC72"
      />
      <path
        d="M70.8361 136.728L78.7704 135.02L68.6912 86.926C68.233 84.7598 66.6503 82.9893 64.547 82.3019L52.4477 78.3652L47.179 90.0504L41.9103 78.3652L29.811 82.3019C27.7077 82.9893 26.125 84.7598 25.6669 86.926L16.4414 105.818L22.7305 110.005L31.1022 99.5276C31.4354 100.465 32.9972 106.318 32.9972 106.318C32.9972 109.796 31.0605 113.837 28.6656 122.606C26.2499 131.375 26.833 141.394 26.833 141.394L27.8951 216.004H44.3676L47.0749 133.208C47.0749 133.042 47.3248 133.042 47.3248 133.208L50.032 216.004H66.5045L67.5666 141.394C67.5666 141.394 68.1497 131.375 65.734 122.606C63.3183 113.837 61.4024 109.796 61.4024 106.318C61.4024 106.318 61.5274 105.131 61.8814 104.193L70.8778 136.708L70.8361 136.728Z"
        fill="#AFADF2"
      />
      <path
        d="M18.5882 228.564H42.0996C42.4328 228.564 42.7243 228.294 42.7243 227.96C42.8076 225.794 43.4948 217.775 40.7459 215.838H30.979C27.3972 219.066 21.2746 220.129 19.1921 222.42C17.8177 223.961 17.8593 226.919 17.9635 228.002C18.0051 228.315 18.2758 228.564 18.5882 228.564Z"
        fill="#8FAE92"
      />
      <mask
        id="mask23_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="17"
        y="215"
        width="26"
        height="14">
        <path
          d="M18.5882 228.564H42.0996C42.4328 228.564 42.7243 228.294 42.7243 227.96C42.8076 225.794 43.4948 217.775 40.7459 215.838H30.979C27.3972 219.066 21.2746 220.129 19.1921 222.42C17.8177 223.961 17.8593 226.919 17.9635 228.002C18.0051 228.315 18.2758 228.564 18.5882 228.564Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask23_3666_33194)">
        <path
          d="M27.1685 221.903C31.792 221.903 35.5401 218.154 35.5401 213.53C35.5401 208.905 31.792 205.156 27.1685 205.156C22.545 205.156 18.7969 208.905 18.7969 213.53C18.7969 218.154 22.545 221.903 27.1685 221.903Z"
          fill="#B3CDB1"
        />
        <path
          d="M35.9805 224.55C36.751 221.676 39.3749 219.572 42.4779 219.572C42.7694 219.572 43.0401 219.572 43.3317 219.635L43.0818 224.571H35.9805V224.55Z"
          fill="#B3CDB1"
        />
        <path
          d="M17.5273 224.528H44.1M25.295 218.134L27.3151 220.612M27.0027 216.905L29.0227 219.383M28.6687 215.801L30.6887 218.279"
          stroke="#C5DFC3"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M26.7734 215.903L44.433 219.527V215.486L26.7734 215.903Z" fill="#7D9C80" />
      </g>
      <path
        d="M75.7529 228.564H52.2415C51.9083 228.564 51.6168 228.294 51.6168 227.96C51.5335 225.794 50.8463 217.775 53.5951 215.838H63.362C66.9439 219.066 73.0665 220.129 75.149 222.42C76.5234 223.961 76.4817 226.919 76.3776 228.002C76.336 228.315 76.0653 228.564 75.7529 228.564Z"
        fill="#8FAE92"
      />
      <mask
        id="mask24_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="51"
        y="215"
        width="26"
        height="14">
        <path
          d="M75.7529 228.564H52.2415C51.9083 228.564 51.6168 228.294 51.6168 227.96C51.5335 225.794 50.8463 217.775 53.5951 215.838H63.362C66.9439 219.066 73.0665 220.129 75.149 222.42C76.5234 223.961 76.4817 226.919 76.3776 228.002C76.336 228.315 76.0653 228.564 75.7529 228.564Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask24_3666_33194)">
        <path
          d="M67.1724 221.903C71.7959 221.903 75.544 218.154 75.544 213.53C75.544 208.905 71.7959 205.156 67.1724 205.156C62.5489 205.156 58.8008 208.905 58.8008 213.53C58.8008 218.154 62.5489 221.903 67.1724 221.903Z"
          fill="#B3CDB1"
        />
        <path
          d="M58.3668 224.55C57.5963 221.676 54.9724 219.572 51.8694 219.572C51.5779 219.572 51.3072 219.572 51.0156 219.635L51.1406 224.509L58.3668 224.55Z"
          fill="#B3CDB1"
        />
        <path
          d="M50.2422 224.529H76.8148M67.0271 220.614L69.0471 218.135M65.2986 219.364L67.3186 216.885M63.6118 218.26L65.6318 215.781"
          stroke="#C5DFC3"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M67.5697 215.903L49.9102 219.527V215.486L67.5697 215.903Z" fill="#7D9C80" />
      </g>
      <mask
        id="mask25_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="26"
        y="109"
        width="42"
        height="108">
        <path
          d="M32.4385 109.549C32.4385 113.027 31.0432 113.86 28.6483 122.63C26.2326 131.399 26.8157 141.417 26.8157 141.417L27.8778 216.027H44.3503L47.0576 133.232C47.0576 133.065 47.3075 133.065 47.3075 133.232L50.0147 216.027H66.4872L67.5493 141.417C67.5493 141.417 68.1324 131.399 65.7167 122.63C63.301 113.86 61.6975 113.09 61.6975 109.632L32.4385 109.549Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask25_3666_33194)">
        <path
          d="M77.3801 131.398H-0.484375"
          stroke="#C5DFC3"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M77.3801 172.973H-0.484375"
          stroke="#C5DFC3"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.457 46.8105C38.457 131.398 -0.464844 131.418 -0.464844 131.418"
          stroke="#C5DFC3"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M57.9087 89.1133C57.9087 172.992 -0.484375 172.951 -0.484375 172.951"
          stroke="#C5DFC3"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M77.3801 131.422C77.3801 131.422 77.3801 205.261 -0.484375 205.261"
          stroke="#C5DFC3"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-0.484375 205.258H77.3801"
          stroke="#C5DFC3"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.457 216.006V46.8105"
          stroke="#C5DFC3"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M57.9102 216.006V46.8105"
          stroke="#C5DFC3"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <mask
        id="mask26_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="18"
        y="78"
        width="61"
        height="139">
        <path
          d="M70.8357 136.728L78.77 135.02L68.6907 86.926C68.2326 84.7598 66.6499 82.9893 64.5466 82.3019L52.4473 78.3652L47.1786 90.0504L41.9098 78.3652L29.8106 82.3019C27.7072 82.9893 26.1245 84.7598 25.6664 86.926L18.5234 105.818L21.4181 111.567L31.0809 99.5276C31.4141 100.465 32.9759 106.318 32.9759 106.318C32.9759 109.796 31.0392 113.837 28.6444 122.606C26.2287 131.375 26.8118 141.394 26.8118 141.394L27.8738 216.004H44.3464L47.1577 134.937L49.9691 216.004H66.4416L67.5037 141.394C67.5037 141.394 68.0868 131.375 65.6711 122.606C63.2554 113.837 61.3395 109.796 61.3395 106.318C61.3395 106.318 61.4645 105.131 61.8185 104.193L70.8149 136.708L70.8357 136.728Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask26_3666_33194)">
        <path d="M63.9032 113.029H30.4375L32.4783 106.01H61.9665L63.9032 113.029Z" fill="#6455E4" />
        <path
          d="M32.6231 90.2832C31.6235 93.1368 29.7076 94.7615 32.7064 105.322"
          stroke="#8A80EC"
          strokeWidth="0.14"
          strokeMiterlimit="10"
        />
        <path
          d="M61.7161 90.2832C62.7157 93.1368 64.6316 94.7615 61.6328 105.322"
          stroke="#8A80EC"
          strokeWidth="0.14"
          strokeMiterlimit="10"
        />
        <path
          d="M56.5104 79.4922C57.0311 80.0129 57.1352 80.5961 57.1352 81.2418C57.1352 82.4499 56.2814 83.533 54.6987 84.1996C54.6987 84.1996 56.0315 88.9278 47.1392 90.0734H47.16C38.2678 88.907 39.6006 84.1996 39.6006 84.1996C38.0179 83.533 37.1641 82.4499 37.1641 81.2418C37.1641 80.5961 37.2682 80.0337 37.7888 79.4922"
          stroke="#8A80EC"
          strokeWidth="0.14"
          strokeMiterlimit="10"
        />
        <path
          d="M34.8922 80.4922L35.6002 82.825C35.8709 83.6999 35.2045 84.5747 34.3091 84.5747H22.543L34.8922 80.4922ZM59.5072 80.4922L58.7992 82.825C58.5285 83.6999 59.1949 84.5747 60.0903 84.5747H71.8564L59.5072 80.4922Z"
          fill="#6455E4"
        />
      </g>
      <path
        d="M50.1987 113.38H44.1386C43.2224 113.38 42.4727 112.63 42.4727 111.714V107.381C42.4727 106.465 43.2224 105.715 44.1386 105.715H50.1987C51.115 105.715 51.8647 106.465 51.8647 107.381V111.714C51.8647 112.63 51.115 113.38 50.1987 113.38ZM50.1987 111.464V107.61C50.1987 107.298 49.9488 107.048 49.6364 107.048H44.6593C44.3469 107.048 44.097 107.298 44.097 107.61V111.464C44.097 111.776 44.3469 112.026 44.6593 112.026H49.6364C49.9488 112.026 50.1987 111.776 50.1987 111.464Z"
        fill="#B3CDB1"
      />
      <path
        d="M57.4493 90.3444C57.3244 90.386 57.1994 90.4277 57.0745 90.4902C57.3035 90.761 57.7408 91.365 57.9491 92.2607C58.0324 92.6148 58.0949 93.0105 58.0949 93.4688C58.0949 93.5521 58.0949 93.6354 58.0741 93.7187C58.0741 93.6354 58.0741 93.5521 58.0741 93.4688C58.0532 92.9064 57.845 92.4273 57.5951 92.0107C57.2619 91.4692 56.8246 91.0734 56.5122 90.8443C56.4081 90.9276 56.3039 91.0109 56.2206 91.0942C56.4289 91.2609 56.7204 91.5108 56.9912 91.8233C57.3452 92.2398 57.6576 92.8022 57.6992 93.4688C57.6992 93.7187 57.6992 93.9062 57.6367 94.0728C57.6576 93.8853 57.6367 93.6562 57.5951 93.4271C57.4493 92.6981 56.9287 92.1982 56.4081 91.8649C56.1998 91.7399 55.9916 91.6358 55.825 91.5525C55.7625 91.6566 55.6792 91.7608 55.6167 91.8857C55.7208 91.9274 55.8458 91.9899 55.9916 92.0524C56.5122 92.3232 57.1161 92.8022 57.2411 93.4896C57.3035 93.7812 57.2827 94.0311 57.2411 94.2186C57.2411 93.6562 56.887 93.1563 56.2415 92.8022C55.9916 92.6564 55.7208 92.5731 55.5334 92.5106C55.4709 92.5106 55.4293 92.4898 55.3876 92.469C55.346 92.5939 55.3252 92.7189 55.3043 92.8439C55.3043 92.8439 55.346 92.8439 55.3668 92.8439C55.7625 92.9688 56.8662 93.3646 56.8662 94.2603C56.8662 94.6144 56.6163 94.6977 56.054 94.6977H54.4297V95.0726H56.8454C57.7409 95.0726 58.4697 94.3436 58.4697 93.4271C58.4697 91.8441 57.8241 90.8026 57.4285 90.3027L57.4493 90.3444Z"
        fill="#6455E4"
      />
      <path
        d="M58.8853 94.3438C58.6562 94.3438 58.4688 94.5104 58.4688 94.7187C58.4688 94.927 58.6354 95.0936 58.8853 95.0936C59.1351 95.0936 59.2809 94.927 59.2809 94.7187C59.2809 94.5104 59.1143 94.3438 58.8853 94.3438Z"
        fill="#6455E4"
      />
      <path
        d="M19.4192 78.2804C19.4192 78.2804 19.3359 79.676 19.2734 80.3633C19.2734 80.3633 19.1276 81.9672 16.6703 82.5712C15.1293 82.9462 13.609 81.2173 13.609 81.2173C13.609 81.2173 11.7348 79.8426 11.11 74.4062L9.88138 67.7617C9.71478 66.9702 9.96468 66.5536 10.277 66.4078C10.6519 66.2204 10.9018 66.3662 10.9851 66.4078L10.9434 66.1579C10.881 65.6996 11.1933 65.2622 11.6515 65.1997C11.9014 65.1581 12.1513 65.2414 12.3387 65.408C12.3595 65.0331 12.6303 64.7207 13.0051 64.6374C13.8173 64.4499 13.9631 65.3247 14.1297 65.6788C14.1921 65.3455 14.442 65.0748 14.7961 65.0123H14.9627C15.3792 65.0539 15.7332 65.3664 15.8165 65.7621C16.233 67.845 17.066 72.7815 17.066 72.7815H17.3992L16.9619 69.6155C16.8786 69.1364 16.8786 68.5324 17.5241 68.3658C18.253 68.1783 18.6487 69.0323 18.6487 69.0323C18.6487 69.0323 20.3355 75.8434 19.44 78.3013L19.4192 78.2804Z"
        fill="#FFDFC5"
      />
      <mask
        id="mask27_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="9"
        y="64"
        width="11"
        height="19">
        <path
          d="M19.4192 78.2804C19.4192 78.2804 19.3359 79.676 19.2734 80.3633C19.2734 80.3633 19.1276 81.9672 16.6703 82.5712C15.1293 82.9462 13.609 81.2173 13.609 81.2173C13.609 81.2173 11.7348 79.8426 11.11 74.4062L9.88138 67.7617C9.71478 66.9702 9.96468 66.5536 10.277 66.4078C10.6519 66.2204 10.9018 66.3662 10.9851 66.4078L10.9434 66.1579C10.881 65.6996 11.1933 65.2622 11.6515 65.1997C11.9014 65.1581 12.1513 65.2414 12.3387 65.408C12.3595 65.0331 12.6303 64.7207 13.0051 64.6374C13.8173 64.4499 13.9631 65.3247 14.1297 65.6788C14.1921 65.3455 14.442 65.0748 14.7961 65.0123H14.9627C15.3792 65.0539 15.7332 65.3664 15.8165 65.7621C16.233 67.845 17.066 72.7815 17.066 72.7815H17.3992L16.9619 69.6155C16.8786 69.1364 16.8786 68.5324 17.5241 68.3658C18.253 68.1783 18.6487 69.0323 18.6487 69.0323C18.6487 69.0323 20.3355 75.8434 19.44 78.3013L19.4192 78.2804Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask27_3666_33194)">
        <path
          d="M12.5489 73.4901L11.0703 66.5332"
          stroke="#FBC5AC"
          strokeWidth="0.13"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M15.3614 72.7413L13.9453 65.0762"
          stroke="#FBC5AC"
          strokeWidth="0.13"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M13.8601 72.9692L12.3398 65.3457"
          stroke="#FBC5AC"
          strokeWidth="0.13"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M15.7773 77.511C15.7773 77.511 15.7773 75.5322 19.0052 74.0117"
          stroke="#FBC5AC"
          strokeWidth="0.13"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M12.0703 73.8884C12.0703 73.8884 13.4864 72.7012 16.4852 72.8053"
          stroke="#FBC5AC"
          strokeWidth="0.13"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <path
        d="M20.6076 108.943C22.8984 108.526 24.4186 106.339 24.0021 104.048L18.9416 79.9901C18.5251 77.6989 17.7754 76.3866 15.5055 76.8032C13.2356 77.2198 12.6733 78.6362 12.9857 80.9482C13.2356 82.7812 15.568 105.131 15.568 105.131C15.9845 107.422 18.3377 109.359 20.6284 108.943H20.6076Z"
        fill="#FFDFC5"
      />
      <path
        d="M24.7914 105.068L21.0429 79.5527L11.2969 81.0524C11.2969 81.0524 14.2957 106.256 14.3165 106.485C14.3165 106.485 16.4198 112.775 21.0429 111.067C24.3749 109.838 24.7914 105.068 24.7914 105.068Z"
        fill="#AFADF2"
      />
      <path
        d="M103.466 217.276C102.925 220.4 92.6788 224.108 91.1586 224.629C90.8046 224.754 90.5547 225.045 90.4922 225.399C90.4922 225.441 90.4922 225.504 90.4922 225.545C90.4922 226.087 90.9503 226.524 91.4918 226.524H103.466H107.964C109.151 226.524 110.109 225.587 110.109 224.42V217.255C110.109 217.255 110.297 214.006 106.798 214.006C103.674 214.006 103.487 217.255 103.487 217.255L103.466 217.276Z"
        fill="#EAAF97"
      />
      <path
        d="M113.13 171.247C112.964 167.581 109.777 164.727 106.05 164.894C102.322 165.06 99.4066 168.185 99.5732 171.851C99.5732 171.996 99.5732 172.142 99.6149 172.288L103.405 217.425C103.405 217.425 103.405 217.529 103.405 217.571C103.488 219.362 105.05 220.757 106.883 220.674C108.715 220.591 110.131 219.07 110.048 217.279C110.048 217.279 113.172 171.767 113.151 171.267L113.13 171.247Z"
        fill="#EAAF97"
      />
      <path
        d="M116.189 130.526C115.981 125.819 111.92 122.174 107.109 122.403C102.861 122.59 99.4665 125.735 98.9043 129.714C98.9043 129.714 96.9675 137.983 99.5498 171.705C99.8414 175.371 102.903 178.371 106.63 178.204C110.358 178.037 112.961 175.142 113.107 171.247L116.21 131.297H116.168C116.168 131.047 116.168 130.776 116.168 130.526H116.189Z"
        fill="#EAAF97"
      />
      <path
        d="M129.141 217.276C129.682 220.4 139.928 224.108 141.449 224.629C141.803 224.754 142.052 225.045 142.115 225.399C142.115 225.441 142.115 225.504 142.115 225.545C142.115 226.087 141.657 226.524 141.115 226.524H129.141H124.643C123.456 226.524 122.498 225.587 122.498 224.42V217.255C122.498 217.255 122.31 214.006 125.809 214.006C128.933 214.006 129.12 217.255 129.12 217.255L129.141 217.276Z"
        fill="#EAAF97"
      />
      <path
        d="M119.482 171.247C119.648 167.581 122.835 164.727 126.562 164.894C130.29 165.06 133.206 168.185 133.039 171.851C133.039 171.996 133.039 172.142 132.997 172.288L129.207 217.425C129.207 217.425 129.207 217.529 129.207 217.571C129.124 219.362 127.562 220.757 125.729 220.674C123.897 220.591 122.481 219.07 122.564 217.279C122.564 217.279 119.44 171.767 119.461 171.267L119.482 171.247Z"
        fill="#EAAF97"
      />
      <path
        d="M116.419 130.526C116.628 125.819 120.688 122.174 125.499 122.403C129.747 122.59 133.142 125.735 133.704 129.714C133.704 129.714 135.641 137.983 133.058 171.705C132.767 175.371 129.706 178.371 125.978 178.204C122.25 178.037 119.647 175.142 119.501 171.247L116.398 131.297H116.44C116.44 131.047 116.44 130.776 116.44 130.526H116.419Z"
        fill="#EAAF97"
      />
      <path
        d="M129.54 113.797C128.915 111.756 128.79 109.61 129.123 107.527L134.225 84.8861L116.274 78.5332L98.3438 84.8653L103.446 107.507C103.779 109.61 103.654 111.735 103.029 113.776C103.029 113.776 98.9269 127.211 98.6145 131.772H133.996C133.35 125.149 129.56 113.797 129.56 113.797H129.54Z"
        fill="#EDB29A"
      />
      <path
        d="M116.297 69.3672C114.047 69.3672 112.215 71.1377 112.215 73.3039V80.2608C112.215 82.4271 114.047 84.1975 116.297 84.1975C118.546 84.1975 120.378 82.4271 120.378 80.2608V73.3039C120.378 71.1377 118.546 69.3672 116.297 69.3672Z"
        fill="#EAAF97"
      />
      <path
        d="M92.617 135.833C92.6586 137.665 93.7415 142.81 89.4099 143.081C87.5357 143.206 85.6406 141.665 85.9322 139.832C86.2237 137.999 86.9318 134.979 86.9318 134.979L92.5962 135.812L92.617 135.833Z"
        fill="#F8C2A9"
      />
      <path
        d="M96.5304 108.692C94.3646 108.213 92.2196 109.525 91.7198 111.65L87.1175 134.187C86.6177 136.312 86.7843 137.728 88.9293 138.207C91.0742 138.686 92.1155 137.686 92.6986 135.583C93.1567 133.916 99.55 113.4 99.55 113.4C100.05 111.275 98.6962 109.171 96.5304 108.672V108.692Z"
        fill="#EAAF97"
      />
      <path
        d="M101.926 84.3226C99.76 83.8643 97.615 85.1974 97.136 87.322L91.6382 111.88C91.1593 114.004 92.5337 116.108 94.6995 116.566C96.8653 117.024 99.0103 115.691 99.4892 113.567L104.987 89.0091C105.466 86.8845 104.092 84.7808 101.926 84.3226Z"
        fill="#EAAF97"
      />
      <path
        d="M92.7841 138.602C92.7841 137.519 92.6384 136.478 92.6384 135.853L86.974 135.02C86.974 135.02 86.3284 137.79 86.016 139.56L85.5371 141.581L83.1422 148.184C83.0381 148.496 83.2255 148.85 83.5379 148.954C83.6212 148.975 83.7045 148.996 83.7878 148.975L83.7253 149.225C83.642 149.662 83.9335 150.1 84.3917 150.183C84.6416 150.225 84.8915 150.162 85.0581 150.017C85.0581 150.371 85.308 150.704 85.6828 150.787C86.0577 150.871 86.4534 150.704 86.62 150.371C86.6616 150.683 86.9115 150.954 87.2447 151.037C87.682 151.141 88.1402 150.871 88.2443 150.433L90.0977 143.018C90.2435 142.997 90.3685 142.955 90.4934 142.914L89.7854 146.184C89.6812 146.621 89.6396 147.184 90.2227 147.392C90.9099 147.621 91.3264 146.83 91.3264 146.83C91.3264 146.83 93.4505 143.476 92.7217 138.623L92.7841 138.602Z"
        fill="#EAAF97"
      />
      <mask
        id="mask28_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="83"
        y="135"
        width="10"
        height="17">
        <path
          d="M92.7841 138.602C92.7841 137.519 92.6384 136.478 92.6384 135.853L86.974 135.02C86.974 135.02 86.3284 137.79 86.016 139.56L85.5371 141.581L83.1422 148.184C83.0381 148.496 83.2255 148.85 83.5379 148.954C83.6212 148.975 83.7045 148.996 83.7878 148.975L83.7253 149.225C83.642 149.662 83.9335 150.1 84.3917 150.183C84.6416 150.225 84.8915 150.162 85.0581 150.017C85.0581 150.371 85.308 150.704 85.6828 150.787C86.0577 150.871 86.4534 150.704 86.62 150.371C86.6616 150.683 86.9115 150.954 87.2447 151.037C87.682 151.141 88.1402 150.871 88.2443 150.433L90.0977 143.018C90.2435 142.997 90.3685 142.955 90.4934 142.914L89.7854 146.184C89.6812 146.621 89.6396 147.184 90.2227 147.392C90.9099 147.621 91.3264 146.83 91.3264 146.83C91.3264 146.83 93.4505 143.476 92.7217 138.623L92.7841 138.602Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask28_3666_33194)">
        <path
          d="M85.4121 141.578L83.8711 148.827M86.62 150.347L88.1819 142.995M86.5992 142.703L85.0789 150.035"
          stroke="#DC8D74"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M85.9141 137.539L94.5772 140.725L95.5977 136.955L86.2681 135.289L85.9141 137.539Z" fill="#DC8D74" />
      </g>
      <mask
        id="mask29_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="112"
        y="69"
        width="9"
        height="16">
        <path
          d="M116.294 69.0801C114.024 69.0801 112.191 70.8714 112.191 73.1001V80.2237C112.191 82.4524 114.024 84.2437 116.294 84.2437C118.564 84.2437 120.396 82.4524 120.396 80.2237V73.1001C120.396 70.8714 118.564 69.0801 116.294 69.0801Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask29_3666_33194)">
        <path
          d="M120.376 67.9595C120.376 65.7308 118.543 63.9395 116.273 63.9395V75.9995H120.376V67.9595Z"
          fill="#DC8D74"
        />
        <path
          d="M116.419 54.6686C120.355 54.856 123.25 57.9387 123.25 61.8546C123.25 62.3128 123.291 64.5207 123.25 65.1664C123.208 65.833 122.75 69.8322 122.75 69.8322C122.313 74.1646 119.022 75.5393 116.44 75.6851C116.44 75.6851 116.357 75.6851 116.315 75.6851C116.252 75.6851 116.19 75.6851 116.19 75.6851C113.629 75.5393 110.338 74.1438 109.88 69.8322C109.88 69.8322 109.422 65.8538 109.38 65.1664C109.339 64.5207 109.38 62.292 109.38 61.8546C109.38 57.9387 112.275 54.8352 116.211 54.6686C116.211 54.6686 116.273 54.6686 116.315 54.6686C116.357 54.6686 116.419 54.6686 116.419 54.6686ZM116.19 54.377C116.19 54.377 116.127 54.377 116.107 54.377C112.087 54.5852 109.068 57.7929 109.068 61.8546V62.4587C109.068 63.2918 109.047 64.6874 109.068 65.1873C109.109 65.8538 109.547 69.7072 109.568 69.8738C110.13 75.2269 114.732 75.9143 116.148 75.9976C116.148 75.9976 116.232 75.9976 116.294 75.9976C116.398 75.9976 116.482 75.9976 116.482 75.9976C117.877 75.9143 122.5 75.2269 123.062 69.8738C123.062 69.7072 123.52 65.8746 123.562 65.2081C123.583 64.7082 123.562 63.3126 123.562 62.4795V61.8754C123.562 57.8138 120.542 54.6061 116.502 54.3978C116.482 54.3978 116.44 54.3978 116.419 54.3978H116.294H116.211L116.19 54.377Z"
          fill="#DC8D74"
        />
      </g>
      <path
        d="M123.251 61.8501C123.251 57.9342 120.357 54.8307 116.421 54.6641C116.421 54.6641 116.358 54.6641 116.317 54.6641C116.275 54.6641 116.212 54.6641 116.212 54.6641C112.276 54.8515 109.382 57.9342 109.382 61.8501C109.382 62.3083 109.34 64.5162 109.382 65.1619C109.423 65.8285 109.882 69.8277 109.882 69.8277C110.319 74.1601 113.609 75.5348 116.192 75.6806C116.192 75.6806 116.296 75.6806 116.337 75.6806C116.379 75.6806 116.483 75.6806 116.483 75.6806C119.045 75.5348 122.335 74.1393 122.793 69.8277C122.793 69.8277 123.251 65.8493 123.293 65.1619C123.335 64.5162 123.293 62.2875 123.293 61.8501H123.251Z"
        fill="#EAAF97"
      />
      <path
        d="M109.879 70.0772C109.879 70.0772 108.151 69.3482 107.734 67.6193C107.443 66.3696 108.068 65.3906 109.421 65.3906L109.879 70.0772ZM122.708 70.0772C122.708 70.0772 124.436 69.3482 124.853 67.6193C125.144 66.3696 124.519 65.3906 123.166 65.3906L122.708 70.0772Z"
        fill="#EAAF97"
      />
      <mask
        id="mask30_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="107"
        y="54"
        width="18"
        height="22">
        <path
          d="M123.229 65.3898C123.229 65.3898 123.229 65.2231 123.229 65.1815C123.271 64.5358 123.229 62.3071 123.229 61.8697C123.229 57.9538 120.335 54.8502 116.399 54.6836C116.399 54.6836 116.336 54.6836 116.295 54.6836C116.253 54.6836 116.19 54.6836 116.19 54.6836C112.255 54.8711 109.36 57.9538 109.36 61.8697C109.36 62.3279 109.318 64.5358 109.36 65.1815C109.36 65.244 109.36 65.3065 109.36 65.3898C108.048 65.4106 107.423 66.3896 107.736 67.6185C108.131 69.264 109.735 70.0138 109.881 70.0763C110.422 74.2213 113.629 75.5544 116.149 75.7002C116.149 75.7002 116.253 75.7002 116.295 75.7002C116.336 75.7002 116.399 75.7002 116.44 75.7002C118.96 75.5336 122.167 74.2005 122.709 70.0555C122.854 69.993 124.458 69.2432 124.854 67.5977C125.145 66.3687 124.541 65.4106 123.229 65.3689V65.3898Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask30_3666_33194)">
        <path
          d="M109.84 70.8875L109.027 64.8887"
          stroke="#DC8D74"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M122.77 70.8875L123.582 64.8887"
          stroke="#DC8D74"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M115.523 65.1582C115.523 65.1582 115.836 66.5954 115.336 68.5533C115.003 69.8864 116.419 69.7406 116.419 69.7406"
          stroke="#DC8D74"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M117.044 69.8873C117.125 69.8873 117.19 69.822 117.19 69.7415C117.19 69.661 117.125 69.5957 117.044 69.5957C116.964 69.5957 116.898 69.661 116.898 69.7415C116.898 69.822 116.964 69.8873 117.044 69.8873Z"
          fill="#C47657"
        />
        <path
          d="M114.484 66.0767C114.484 66.0767 113.276 64.5562 111.09 65.6393C111.09 65.6393 112.256 67.9514 114.484 66.0767Z"
          fill="white"
        />
        <path
          d="M111.09 65.6585C113.276 64.5754 114.443 66.0751 114.443 66.0751"
          stroke="#335437"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M113.692 65.4719C113.796 65.5344 113.775 65.701 113.775 65.826C113.796 66.3467 113.4 66.7841 112.859 66.8049C112.318 66.8258 111.88 66.43 111.859 65.9093C111.859 65.6802 111.922 65.4719 112.047 65.3053C112.047 65.3053 112.88 65.0345 113.692 65.4511V65.4719Z"
          fill="#335437"
        />
        <path
          d="M118.105 66.0767C118.105 66.0767 119.313 64.5562 121.5 65.6393C121.5 65.6393 120.334 67.9514 118.105 66.0767Z"
          fill="white"
        />
        <path
          d="M121.501 65.639C119.315 64.5559 118.148 66.0556 118.148 66.0556"
          stroke="#335437"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M118.898 65.4524C118.793 65.5148 118.814 65.6815 118.814 65.8065C118.793 66.3272 119.189 66.7646 119.731 66.7854C120.272 66.8063 120.709 66.4105 120.73 65.8898C120.73 65.6607 120.668 65.4524 120.543 65.2857C120.543 65.2857 119.71 65.0149 118.898 65.4315V65.4524Z"
          fill="#335437"
        />
        <path
          d="M114.379 64.243C113.817 64.243 112.609 64.243 111.276 64.2846C111.088 64.2846 110.943 64.1597 110.922 63.993C110.922 63.8472 111.026 63.7014 111.193 63.6806C112.775 63.3682 113.9 63.4306 114.42 63.4723C114.587 63.4723 114.712 63.6181 114.712 63.7847V63.9514C114.712 64.118 114.566 64.2638 114.379 64.2638V64.243Z"
          fill="#CD6148"
        />
        <path
          d="M118.212 64.243C118.774 64.243 119.982 64.243 121.315 64.2846C121.502 64.2846 121.648 64.1597 121.669 63.993C121.669 63.8472 121.565 63.7014 121.398 63.6806C119.816 63.3682 118.691 63.4306 118.17 63.4723C118.004 63.4723 117.879 63.6181 117.879 63.7847V63.9514C117.879 64.118 118.025 64.2638 118.212 64.2638V64.243Z"
          fill="#CD6148"
        />
        <path
          d="M116.297 71.0352C115.506 71.0352 114.777 71.3684 114.34 71.5351C114.34 71.5351 115.298 71.8683 116.297 71.8475C117.318 71.8475 118.255 71.5351 118.255 71.5351C117.818 71.3476 117.089 71.0352 116.297 71.0352Z"
          fill="#E77453"
        />
        <path
          d="M118.879 71.2852C118.38 71.5351 117.359 71.8267 116.297 71.8267C115.235 71.8267 114.215 71.5143 113.715 71.2852"
          stroke="#CD6148"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M117.651 72.7441C117.235 72.8483 116.777 72.9316 116.298 72.9316C115.819 72.9316 115.361 72.8483 114.965 72.7441"
          stroke="#DC8D74"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M116.256 92.6153L123.337 79.0138L121.587 78.3265L120.713 76.5977C120.713 76.5977 118.422 77.3267 116.194 77.3475C113.965 77.3475 111.675 76.5977 111.675 76.5977L110.8 78.3265L109.051 79.0138L116.131 92.6153V92.8235L116.194 92.7194L116.256 92.8235V92.6153Z"
        fill="#D4D5F7"
      />
      <path
        d="M111.631 216.924H102.53C99.198 219.861 93.4712 220.819 91.5553 222.923C90.2641 224.318 90.3058 227.026 90.4099 227.984C90.4307 228.276 90.7014 228.505 90.993 228.505H93.4295C93.7002 227.922 94.2833 227.526 94.9497 227.526C95.6161 227.526 96.1992 227.922 96.47 228.505H100.26C100.531 227.922 101.114 227.526 101.78 227.526C102.447 227.526 103.03 227.922 103.301 228.505H107.091C107.361 227.922 107.944 227.526 108.611 227.526C109.277 227.526 109.86 227.922 110.131 228.505H112.88C113.192 228.505 113.463 228.255 113.463 227.942C113.546 225.964 114.192 218.694 111.61 216.924H111.631Z"
        fill="#D6D7F9"
      />
      <mask
        id="mask31_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="90"
        y="216"
        width="24"
        height="13">
        <path
          d="M90.9735 228.505H112.881C113.194 228.505 113.464 228.255 113.464 227.942C113.548 225.964 114.193 218.694 111.611 216.924H102.51C99.1785 219.861 93.4516 220.819 91.5357 222.923C90.2446 224.318 90.2862 227.026 90.3904 227.984C90.4112 228.276 90.6819 228.505 90.9735 228.505Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask31_3666_33194)">
        <path
          d="M89.9961 224.823H114.757M97.2223 219.012L99.1174 221.261M98.8259 217.887L100.721 220.136"
          stroke="#AFADF2"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M98.5352 218.197L115.008 221.488V217.822L98.5352 218.197Z" fill="#AFADF2" />
      </g>
      <path
        d="M141.081 222.987C139.145 220.904 133.438 219.925 130.106 216.988H121.006C118.445 218.759 119.09 226.049 119.153 228.007C119.153 228.319 119.423 228.569 119.736 228.569H122.464C122.714 227.965 123.318 227.528 124.026 227.528C124.734 227.528 125.338 227.965 125.587 228.569H129.315C129.565 227.965 130.169 227.528 130.877 227.528C131.585 227.528 132.189 227.965 132.439 228.569H136.167C136.416 227.965 137.02 227.528 137.728 227.528C138.436 227.528 139.04 227.965 139.29 228.569H141.706C142.018 228.569 142.268 228.34 142.289 228.049C142.393 227.07 142.435 224.383 141.144 222.987H141.081Z"
        fill="#D6D7F9"
      />
      <mask
        id="mask32_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="119"
        y="216"
        width="24"
        height="13">
        <path
          d="M141.642 228.569H119.734C119.422 228.569 119.151 228.319 119.151 228.007C119.068 226.028 118.422 218.759 121.005 216.988H130.105C133.437 219.925 139.164 220.883 141.08 222.987C142.371 224.383 142.329 227.09 142.225 228.049C142.204 228.34 141.934 228.569 141.642 228.569Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask32_3666_33194)">
        <path
          d="M142.62 224.906H117.859"
          stroke="#AFADF2"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M135.395 219.096L133.5 221.345"
          stroke="#AFADF2"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M133.792 217.969L131.918 220.218"
          stroke="#AFADF2"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M134.082 218.262L117.609 221.553V217.887L134.082 218.262Z" fill="#AFADF2" />
      </g>
      <mask
        id="mask33_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="109"
        y="76"
        width="15"
        height="17">
        <path
          d="M116.256 92.6153L123.337 79.0138L121.587 78.3265L120.713 76.5977C120.713 76.5977 118.422 77.3267 116.194 77.3475C113.965 77.3475 111.675 76.5977 111.675 76.5977L110.8 78.3265L109.051 79.0138L116.131 92.6153V92.8235L116.194 92.7194L116.256 92.8235V92.6153Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask33_3666_33194)">
        <path
          d="M116.193 79.7429C120.794 79.7429 124.523 76.8706 124.523 73.3275C124.523 69.7844 120.794 66.9121 116.193 66.9121C111.593 66.9121 107.863 69.7844 107.863 73.3275C107.863 76.8706 111.593 79.7429 116.193 79.7429Z"
          stroke="#A9AEF3"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M100.054 218.087L97.8047 138.479H115.256L115.131 218.087H100.054ZM132.374 218.192L134.623 138.479H117.172L117.297 218.192H132.374Z"
        fill="#8FAE92"
      />
      <mask
        id="mask34_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="97"
        y="138"
        width="38"
        height="81">
        <path
          d="M100.054 217.796L97.8047 138.479H115.256L115.131 217.796H100.054ZM132.374 218.087L134.623 138.479H117.172L117.297 218.087H132.374Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask34_3666_33194)">
        <path
          d="M142.641 155.642H73.2734M142.641 192.677H73.2734M107.968 80.2617C107.968 155.642 73.2734 155.663 73.2734 155.663M125.294 117.962C125.294 192.697 73.2734 192.656 73.2734 192.656M142.641 155.663C142.641 155.663 142.641 221.462 73.2734 221.462H142.641M142.641 89.8639H73.2734M107.968 231.044V80.2825M125.315 231.044V80.2825"
          stroke="#B3CDB1"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M93.8281 143.746L136.29 147.183L135.228 142.143L93.8281 142.642V143.746Z" fill="#67876B" />
      </g>
      <path
        d="M137.787 110.154L143.597 104.926L136.184 85.5963C135.892 84.3257 134.997 83.2843 133.789 82.826L123.147 78.7852L116.213 91.845L109.278 78.7852L98.6364 82.826C97.4285 83.2843 96.5122 84.3257 96.2415 85.5963L84.8711 136.648L94.6796 138.731L101.635 108.175L102.302 111.841C99.3236 121.11 95.2419 143.293 95.2419 143.293H137.163C137.163 143.293 133.081 121.11 130.103 111.841L131.977 101.426L137.787 110.133V110.154Z"
        fill="#8FAE92"
      />
      <mask
        id="mask35_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="84"
        y="78"
        width="60"
        height="66">
        <path
          d="M138.308 110.903L143.597 105.529L136.184 85.6373C135.892 84.3667 134.997 83.3253 133.789 82.867L123.147 78.8262L116.213 91.886L109.278 78.8262L98.6364 82.867C97.4285 83.3253 96.5122 84.3667 96.2415 85.6373L84.8711 136.689L94.6796 138.772L101.635 108.216L102.302 111.882C99.3236 121.151 95.2419 143.334 95.2419 143.334H137.163C137.163 143.334 133.081 121.151 130.103 111.882L131.977 101.467L138.287 110.903H138.308Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask35_3666_33194)">
        <path
          d="M102.469 81.0586L103.885 84.2454H92.6602L102.469 81.0586ZM130.312 81.0586L128.937 84.2246H139.87L130.312 81.0586Z"
          fill="#8A80EC"
        />
        <path
          d="M102.384 80.4505C102.384 80.4505 103.821 83.7415 106.008 88.3031H108.798L107.132 90.636C110.61 97.8012 115.4 106.945 119.294 111.986V144.042M115.379 105.925C118.586 101.821 123.501 95.2392 125.75 90.636L124.084 88.2823H126.874C129.061 83.7207 130.498 80.4297 130.498 80.4297M101.468 111.861H131.268M116.233 91.4483L111.276 98.801M135.975 135.544L149.157 132.857M83.2461 132.857L96.4283 135.544M122.022 105.675C121.189 105.675 120.523 106.341 120.523 107.174C120.523 108.007 121.189 108.674 122.022 108.674C122.855 108.674 123.522 108.007 123.522 107.174C123.522 106.341 122.855 105.675 122.022 105.675Z"
          stroke="#B3CDB1"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M132.309 96.4258L130.601 110.819M100.113 96.4258L101.821 110.819"
          stroke="#6F8A71"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M124.168 60.9753C123.148 55.3098 117.483 54.6641 116.171 54.6641C114.755 54.6641 109.403 55.2264 108.445 60.9753C108.195 62.4333 108.32 65.8076 108.32 65.8076C109.008 65.9118 109.424 67.0574 109.424 67.0574C110.319 66.495 110.007 63.7872 110.153 62.0584C110.278 60.5587 111.59 60.2254 113.714 60.2879H115.672C115.672 60.2879 115.859 60.3088 115.921 60.3712L116.171 60.5795C116.171 60.5795 116.255 60.6212 116.296 60.6212C116.338 60.6212 116.38 60.6212 116.421 60.5795L116.671 60.3712C116.671 60.3712 116.817 60.2879 116.921 60.2879H118.879C121.003 60.2254 122.315 60.5587 122.44 62.0584C122.585 63.7872 122.273 66.495 123.168 67.0574C123.168 67.0574 123.585 65.9118 124.272 65.8076C124.272 65.8076 124.418 62.4333 124.147 60.9753H124.168Z"
        fill="#D06148"
      />
      <path
        d="M111.985 55.4974C111.86 55.4974 111.735 55.6016 111.672 55.7057C111.672 55.7474 111.631 55.7682 111.631 55.8098C111.631 55.8932 111.547 55.9348 111.464 55.914C111.402 55.914 111.339 55.914 111.277 55.914C111.173 55.9348 111.089 56.0181 111.048 56.1014C111.027 56.1431 111.006 56.1848 111.006 56.2472C111.006 56.3306 110.923 56.3722 110.86 56.3514C110.798 56.3514 110.756 56.3514 110.694 56.3514C110.548 56.3931 110.444 56.518 110.423 56.6638C110.381 56.9346 110.61 57.1429 110.86 57.1012C110.985 57.1012 111.11 56.9971 111.152 56.8721C111.193 56.768 111.193 56.6638 111.152 56.5805C111.235 56.643 111.339 56.6847 111.443 56.6638C111.568 56.6638 111.672 56.5597 111.735 56.4556C111.797 56.3306 111.797 56.2264 111.735 56.1431C111.818 56.2473 111.964 56.2889 112.11 56.2472C112.255 56.2056 112.36 56.1014 112.38 55.9556C112.422 55.7057 112.214 55.4766 111.964 55.4974H111.985Z"
        fill="#CD6148"
      />
      <path
        d="M123.77 59.5174C123.77 59.5174 123.854 59.33 123.833 59.2675C123.833 59.1633 123.77 59.0592 123.687 58.9967C123.645 58.955 123.604 58.9342 123.562 58.9342C123.5 58.9134 123.458 58.8301 123.479 58.7676C123.479 58.7259 123.5 58.6634 123.5 58.6009C123.5 58.4551 123.396 58.3093 123.271 58.2677C123.021 58.1635 122.75 58.3302 122.75 58.6009C122.75 58.7259 122.812 58.8717 122.917 58.955C123.021 59.0175 123.104 59.0384 123.208 59.0175C123.125 59.08 123.083 59.1842 123.062 59.2883C123.062 59.4133 123.104 59.5383 123.208 59.6216C123.312 59.7049 123.416 59.7257 123.5 59.7049L123.75 59.5591L123.77 59.5174Z"
        fill="#CD6148"
      />
      <path
        d="M109.047 66.3477V63.265C109.047 59.6407 111.983 56.7246 115.586 56.7246H116.294H117.002C120.605 56.7246 123.541 59.6407 123.541 63.265V66.3477M123.853 67.0559C123.249 69.7636 120.98 71.8466 118.168 72.159"
        stroke="#8A80EC"
        strokeWidth="0.14"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M109.464 66.9106C109.61 67.6396 109.464 68.2853 109.11 68.3686C108.756 68.4519 108.36 67.9104 108.194 67.1813C108.027 66.4523 108.194 65.8066 108.548 65.7233C108.902 65.64 109.298 66.1815 109.464 66.9106ZM123.146 66.9106C123 67.6396 123.146 68.2853 123.5 68.3686C123.854 68.4519 124.25 67.9104 124.416 67.1813C124.583 66.4523 124.416 65.8066 124.062 65.7233C123.708 65.64 123.313 66.1815 123.146 66.9106Z"
        fill="#8A80EC"
      />
      <path
        d="M118.066 72.723C118.722 72.723 119.253 72.3779 119.253 71.9523C119.253 71.5267 118.722 71.1816 118.066 71.1816C117.41 71.1816 116.879 71.5267 116.879 71.9523C116.879 72.3779 117.41 72.723 118.066 72.723Z"
        fill="#8A80EC"
      />
      <path
        d="M129.604 89.2819C129.479 89.3235 129.354 89.3652 129.229 89.4277C129.458 89.6985 129.896 90.3025 130.125 91.1982C130.208 91.5523 130.271 91.9688 130.271 92.4063C130.271 92.4896 130.271 92.5729 130.25 92.6562C130.25 92.5729 130.25 92.4896 130.25 92.3854C130.229 91.8231 130.021 91.3231 129.771 90.9274C129.438 90.3858 129 89.9901 128.688 89.7401C128.584 89.8234 128.48 89.9068 128.396 89.9901C128.605 90.1567 128.896 90.4067 129.188 90.7399C129.542 91.1773 129.854 91.7397 129.896 92.4063C129.896 92.6562 129.896 92.8437 129.833 93.0103C129.854 92.8228 129.833 92.5937 129.792 92.3646C129.646 91.6356 129.125 91.1357 128.584 90.8024C128.376 90.6774 128.167 90.5733 127.98 90.49C127.897 90.5941 127.834 90.6983 127.772 90.8233C127.876 90.8649 128.001 90.9274 128.147 91.0107C128.667 91.3023 129.271 91.7606 129.396 92.4479C129.458 92.7395 129.438 92.9895 129.396 93.1769C129.396 92.5937 129.021 92.1147 128.396 91.7606C128.126 91.6148 127.876 91.5106 127.688 91.469C127.626 91.469 127.584 91.4481 127.543 91.4273C127.501 91.5523 127.48 91.6772 127.459 91.8022C127.459 91.8022 127.501 91.8022 127.522 91.8022C127.938 91.9272 129.042 92.3229 129.042 93.2186C129.042 93.5727 128.792 93.6768 128.23 93.6768H126.605V94.0518H129.042C129.937 94.0518 130.687 93.3019 130.687 92.3854C130.687 90.8024 130.042 89.7401 129.646 89.2402L129.604 89.2819Z"
        fill="#6455E4"
      />
      <path
        d="M131.061 93.3223C130.832 93.3223 130.645 93.4889 130.645 93.6972C130.645 93.9055 130.811 94.0721 131.061 94.0721C131.311 94.0721 131.457 93.9055 131.457 93.6972C131.457 93.4889 131.29 93.3223 131.061 93.3223Z"
        fill="#6455E4"
      />
      <path
        d="M142.724 79.6379C142.724 79.6379 142.745 80.971 142.787 81.6167C142.787 81.6167 142.849 83.1372 145.161 83.8246C146.598 84.2411 148.118 82.679 148.118 82.679C148.118 82.679 149.95 81.4709 150.783 76.3469L152.241 70.119C152.449 69.3691 152.22 68.9734 151.929 68.8068C151.596 68.5985 151.325 68.7443 151.262 68.7651L151.325 68.5152C151.408 68.0777 151.137 67.6612 150.7 67.5778C150.45 67.5362 150.221 67.5778 150.055 67.7445C150.055 67.3904 149.805 67.0779 149.451 66.9946C148.701 66.7863 148.513 67.5987 148.347 67.9319C148.305 67.6195 148.076 67.3487 147.743 67.2654H147.576C147.181 67.2654 146.847 67.557 146.743 67.9319C146.264 69.869 145.244 74.5348 145.244 74.5348H144.932L145.473 71.5562C145.577 71.1188 145.598 70.5356 144.994 70.3481C144.307 70.1398 143.911 70.9313 143.911 70.9313C143.911 70.9313 142.016 77.305 142.745 79.6587L142.724 79.6379Z"
        fill="#EAAF97"
      />
      <mask
        id="mask36_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="142"
        y="66"
        width="11"
        height="18">
        <path
          d="M142.724 79.6379C142.724 79.6379 142.745 80.971 142.787 81.6167C142.787 81.6167 142.849 83.1372 145.161 83.8246C146.598 84.2411 148.118 82.679 148.118 82.679C148.118 82.679 149.95 81.4709 150.783 76.3469L152.241 70.119C152.449 69.3691 152.22 68.9734 151.929 68.8068C151.596 68.5985 151.325 68.7443 151.262 68.7651L151.325 68.5152C151.408 68.0777 151.137 67.6612 150.7 67.5778C150.45 67.5362 150.221 67.5778 150.055 67.7445C150.055 67.3904 149.805 67.0779 149.451 66.9946C148.701 66.7863 148.513 67.5987 148.347 67.9319C148.305 67.6195 148.076 67.3487 147.743 67.2654H147.576C147.181 67.2654 146.847 67.557 146.743 67.9319C146.264 69.869 145.244 74.5348 145.244 74.5348H144.932L145.473 71.5562C145.577 71.1188 145.598 70.5356 144.994 70.3481C144.307 70.1398 143.911 70.9313 143.911 70.9313C143.911 70.9313 142.016 77.305 142.745 79.6587L142.724 79.6379Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask36_3666_33194)">
        <path
          d="M149.453 75.4043L151.161 68.8848"
          stroke="#DC8D74"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M146.828 74.5728L148.494 67.3867"
          stroke="#DC8D74"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M148.223 74.8651L149.993 67.7207"
          stroke="#DC8D74"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M146.203 79.069C146.203 79.069 146.287 77.1943 143.309 75.6113"
          stroke="#DC8D74"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M149.889 75.8031C149.889 75.8031 148.598 74.6159 145.766 74.5742"
          stroke="#DC8D74"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M141.994 108.883C139.807 108.57 138.287 106.55 138.599 104.363L142.494 81.4089C142.806 79.2219 143.452 77.9513 145.638 78.2637C147.825 78.5761 148.387 79.8884 148.179 82.0963C148.012 83.8251 146.638 105.092 146.638 105.092C146.325 107.279 144.18 109.195 141.994 108.903V108.883Z"
        fill="#EAAF97"
      />
      <path
        d="M136.266 105.365L140.764 79.9531L150.385 81.3695C150.385 81.3695 147.115 107.635 147.074 107.843C146.491 110.739 143.763 112.447 140.222 111.738C136.682 111.03 136.266 105.365 136.266 105.365Z"
        fill="#8FAE92"
      />
      <path d="M140.328 82.7617L149.97 84.1781" stroke="#B3CDB1" strokeWidth="0.14" strokeLinejoin="round" />
      <path
        d="M204.761 78.51L205.907 77.8851C193.724 66.325 190.579 56.7227 190.579 56.7227C189.163 50.9114 185.561 50.6406 182.999 50.6406C178.001 50.6406 176.189 55.3897 175.96 58.0558C174.336 77.3227 189.163 86.9874 189.163 86.9874L203.158 79.3848L200.846 74.7399L204.74 78.5308L204.761 78.51Z"
        fill="#6A3221"
      />
      <path
        d="M177.292 65.3037C177.292 65.3037 176.147 64.6163 175.605 63.0125C175.251 61.971 175.564 60.8463 176.792 60.9087L177.271 65.3037H177.292Z"
        fill="#DC8D74"
      />
      <path
        d="M190.183 60.9087C191.412 60.8463 191.724 61.971 191.37 63.0125C190.829 64.6163 189.684 65.3037 189.684 65.3037L190.163 60.9087H190.183Z"
        fill="#DC8D74"
      />
      <path
        d="M171.252 217.066C170.752 220.377 161.11 223.981 159.652 224.543C159.319 224.668 159.069 224.981 159.027 225.356C159.027 225.397 159.027 225.46 159.027 225.501C159.027 226.085 159.444 226.543 159.985 226.543H171.356H175.625C176.749 226.543 177.645 225.543 177.645 224.335V214.504C177.645 214.504 177.811 213.316 174.5 213.316C171.543 213.316 171.272 217.066 171.272 217.066H171.252Z"
        fill="#DC8D74"
      />
      <path
        d="M180.496 168.096C180.33 164.201 177.331 161.202 173.77 161.389C170.209 161.577 167.481 164.868 167.627 168.742C167.627 168.909 167.627 169.054 167.668 169.2L171.25 216.92C171.25 216.92 171.25 217.024 171.25 217.065C171.334 218.961 172.812 220.44 174.541 220.356C176.269 220.273 177.623 218.648 177.539 216.753C177.539 216.753 180.496 168.617 180.476 168.075L180.496 168.096Z"
        fill="#DC8D74"
      />
      <path
        d="M183.391 125.022C183.183 120.044 179.33 116.191 174.79 116.42C170.771 116.628 167.543 119.94 167.002 124.147C167.002 124.147 165.148 132.896 167.626 168.555C167.918 172.45 170.792 175.616 174.353 175.429C177.914 175.241 180.371 172.179 180.496 168.076L183.433 125.814H183.391C183.391 125.543 183.391 125.272 183.391 125.001V125.022Z"
        fill="#DC8D74"
      />
      <path
        d="M195.762 216.775C196.262 220.087 205.904 224.002 207.341 224.565C207.674 224.69 207.924 225.002 207.966 225.377C207.966 225.419 207.966 225.481 207.966 225.523C207.966 226.106 207.549 226.564 207.008 226.564H195.637H191.368C190.244 226.564 189.348 225.565 189.348 224.356L189.286 214.525C189.286 214.525 189.161 213.338 192.493 213.338C195.45 213.338 195.741 216.775 195.741 216.775H195.762Z"
        fill="#DC8D74"
      />
      <path
        d="M186.516 168.096C186.682 164.201 189.681 161.202 193.242 161.389C196.803 161.577 199.531 164.868 199.385 168.742C199.385 168.909 199.385 169.054 199.344 169.2L195.762 216.92C195.762 216.92 195.762 217.024 195.762 217.065C195.679 218.961 194.2 220.44 192.472 220.356C190.743 220.273 189.389 218.648 189.473 216.753C189.473 216.753 186.516 168.617 186.536 168.075L186.516 168.096Z"
        fill="#DC8D74"
      />
      <path
        d="M195.556 107.317C194.952 105.255 195.869 103.11 196.202 101.006L200.034 78.0521L183.499 71.8242L166.943 78.0105L170.816 101.006C171.149 103.11 171.878 105.276 171.274 107.317C171.274 107.317 167.213 120.856 166.922 125.438H199.95C199.305 118.773 195.556 107.338 195.556 107.338V107.317Z"
        fill="#DC8D74"
      />
      <path
        d="M183.436 64.5352C181.374 64.5352 179.688 66.3056 179.688 68.4927V76.6161C179.688 78.8031 181.374 80.5736 183.436 80.5736C185.498 80.5736 187.184 78.8031 187.184 76.6161V68.4927C187.184 66.3056 185.498 64.5352 183.436 64.5352Z"
        fill="#DC8D74"
      />
      <path
        d="M159.612 129.538C159.654 131.392 160.716 136.558 156.447 136.828C154.614 136.953 152.74 135.391 153.011 133.579C153.281 131.767 154.01 128.705 154.01 128.705L159.612 129.559V129.538Z"
        fill="#DC8D74"
      />
      <path
        d="M163.463 102.234C161.339 101.755 159.215 103.088 158.715 105.213L154.175 127.875C153.696 129.999 153.842 131.416 155.966 131.916C158.09 132.416 159.111 131.374 159.673 129.27C160.131 127.604 166.441 106.962 166.441 106.962C166.92 104.838 165.587 102.713 163.463 102.213V102.234Z"
        fill="#DC8D74"
      />
      <path
        d="M168.793 77.739C166.648 77.2599 164.544 78.6138 164.066 80.7592L158.651 105.442C158.172 107.587 159.526 109.691 161.671 110.17C163.816 110.649 165.919 109.295 166.398 107.15L171.812 82.4672C172.291 80.3218 170.938 78.218 168.793 77.739Z"
        fill="#DC8D74"
      />
      <path
        d="M159.757 132.312C159.757 131.229 159.632 130.187 159.611 129.541L154.009 128.688C154.009 128.688 153.364 131.479 153.072 133.249L152.593 135.29L150.24 141.935C150.136 142.247 150.323 142.601 150.636 142.705C150.719 142.726 150.802 142.747 150.885 142.726L150.823 142.976C150.74 143.414 151.031 143.851 151.469 143.934C151.718 143.976 151.947 143.914 152.135 143.768C152.135 144.122 152.385 144.455 152.76 144.538C153.135 144.622 153.509 144.455 153.676 144.122C153.718 144.434 153.968 144.705 154.28 144.788C154.717 144.893 155.155 144.622 155.279 144.184L157.112 136.728C157.258 136.707 157.383 136.665 157.508 136.623L156.821 139.894C156.716 140.331 156.675 140.893 157.258 141.102C157.924 141.331 158.362 140.539 158.362 140.539C158.362 140.539 160.444 137.165 159.757 132.291V132.312Z"
        fill="#DC8D74"
      />
      <mask
        id="mask37_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="150"
        y="128"
        width="10"
        height="17">
        <path
          d="M159.757 132.312C159.757 131.229 159.632 130.187 159.611 129.541L154.009 128.688C154.009 128.688 153.364 131.479 153.072 133.249L152.593 135.29L150.24 141.935C150.136 142.247 150.323 142.601 150.636 142.705C150.719 142.726 150.802 142.747 150.885 142.726L150.823 142.976C150.74 143.414 151.031 143.851 151.469 143.934C151.718 143.976 151.947 143.914 152.135 143.768C152.135 144.122 152.385 144.455 152.76 144.538C153.135 144.622 153.509 144.455 153.676 144.122C153.718 144.434 153.968 144.705 154.28 144.788C154.717 144.893 155.155 144.622 155.279 144.184L157.112 136.728C157.258 136.707 157.383 136.665 157.508 136.623L156.821 139.894C156.716 140.331 156.675 140.893 157.258 141.102C157.924 141.331 158.362 140.539 158.362 140.539C158.362 140.539 160.444 137.165 159.757 132.291V132.312Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask37_3666_33194)">
        <path
          d="M152.508 135.309L150.988 142.599M153.716 144.119L155.257 136.725M153.696 136.413L152.196 143.786"
          stroke="#BF623F"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M153.008 129.416L161.546 132.602L162.566 128.832L153.341 127.166L153.008 129.416Z" fill="#BF623F" />
      </g>
      <mask
        id="mask38_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="179"
        y="64"
        width="9"
        height="17">
        <path
          d="M183.644 64.5332C181.458 64.5332 179.688 66.3037 179.688 68.4907V76.6141C179.688 78.8012 181.458 80.5716 183.644 80.5716C185.831 80.5716 187.184 78.8012 187.184 76.6141V68.4907C187.184 66.3037 185.831 64.5332 183.644 64.5332Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask38_3666_33194)">
        <path
          d="M187.496 63.1392C187.496 60.9521 185.726 59.1816 183.539 59.1816V71.0751H187.496V63.16V63.1392Z"
          fill="#BF623F"
        />
      </g>
      <path
        d="M190.224 57.4107C190.224 53.5574 187.433 50.7662 183.602 50.5996H183.331C179.52 50.7662 176.708 53.5574 176.708 57.4107C176.708 57.8482 176.688 60.0352 176.708 60.6809C176.75 61.3474 177.25 65.2633 177.25 65.2633C177.562 69.6583 182.498 70.908 183.456 70.908C184.414 70.908 189.37 69.6583 189.662 65.2633C189.662 65.2633 190.161 61.3266 190.203 60.6809C190.224 60.0352 190.203 57.8482 190.203 57.4107H190.224Z"
        fill="#DC8D74"
      />
      <mask
        id="mask39_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="179"
        y="64"
        width="9"
        height="17">
        <path
          d="M183.541 64.5352C181.355 64.5352 179.668 66.3056 179.668 68.4927V76.6161C179.668 78.8031 181.355 80.5736 183.541 80.5736C185.728 80.5736 187.082 78.8031 187.082 76.6161V68.4927C187.082 66.3056 185.728 64.5352 183.541 64.5352Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask39_3666_33194)">
        <path
          d="M176.898 65.2852C177.211 69.6801 182.521 70.9298 183.5 70.9298C184.479 70.9298 189.789 69.6801 190.101 65.2852"
          stroke="#BF623F"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <mask
        id="mask40_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="175"
        y="50"
        width="17"
        height="21">
        <path
          d="M190.225 60.6809C190.183 61.3474 189.683 65.2633 189.683 65.2633C189.371 69.6583 184.477 70.908 183.477 70.908C182.478 70.908 177.563 69.6583 177.271 65.2633C177.271 65.2633 176.772 61.3266 176.73 60.6809C176.709 60.0352 176.73 57.8482 176.73 57.4107C176.73 53.5574 179.521 50.7662 183.352 50.5996H183.623C187.434 50.7662 190.245 53.5574 190.245 57.4107C190.245 57.8482 190.266 60.0352 190.245 60.6809H190.225ZM176.792 60.8892C175.564 60.8267 175.251 61.9515 175.605 62.993C176.147 64.5968 177.292 65.2842 177.292 65.2842L176.813 60.8892H176.792ZM189.662 65.2842C189.662 65.2842 190.808 64.5968 191.349 62.993C191.703 61.9515 191.391 60.8267 190.162 60.8892L189.683 65.2842H189.662Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask40_3666_33194)">
        <path
          d="M177.189 66.2221L176.605 60.3066M189.808 66.2221L190.392 60.3066"
          stroke="#BF623F"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M182.644 60.7422C182.769 61.2629 182.935 62.4918 182.435 64.0124C182.019 65.2829 183.643 65.0955 183.643 65.0955"
        stroke="#BF623F"
        strokeWidth="0.14"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M184.103 65.2389C184.183 65.2389 184.249 65.1736 184.249 65.0931C184.249 65.0125 184.183 64.9473 184.103 64.9473C184.022 64.9473 183.957 65.0125 183.957 65.0931C183.957 65.1736 184.022 65.2389 184.103 65.2389Z"
        fill="#BF623F"
      />
      <path
        d="M185.02 61.5747C185.02 61.5747 186.54 60.0125 188.622 61.1581C188.622 61.1581 187.31 63.2618 185.02 61.5747Z"
        fill="white"
      />
      <path
        d="M187.643 61.4097C187.643 61.8887 187.227 62.2637 186.748 62.2428C186.269 62.222 185.894 61.8262 185.915 61.3472C185.936 60.8681 186.311 60.7848 186.79 60.8056C187.269 60.8264 187.643 60.9306 187.623 61.4097H187.643Z"
        fill="#6A3221"
      />
      <path
        d="M188.56 61.2018C186.623 60.202 185.082 61.5143 185.082 61.5143"
        stroke="#6A3221"
        strokeWidth="0.14"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M181.853 61.6375C181.853 61.6375 180.374 60.0337 178.25 61.096C178.25 61.096 179.479 63.2414 181.853 61.6375Z"
        fill="white"
      />
      <path
        d="M179.25 61.3664C179.25 61.8455 179.625 62.2204 180.104 62.2204C180.583 62.2204 180.958 61.8455 180.958 61.3664C180.958 60.8874 180.583 60.7832 180.104 60.7832C179.625 60.7832 179.25 60.8874 179.25 61.3664Z"
        fill="#6A3221"
      />
      <path
        d="M178.332 61.1377C180.352 60.2004 181.81 61.5751 181.81 61.5751"
        stroke="#6A3221"
        strokeWidth="0.14"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M181.312 66.8887H185.561C185.561 66.8887 183.562 69.6798 181.312 66.8887Z" fill="#D74F25" />
      <path
        d="M183.438 66.3262C182.584 66.3262 181.772 66.6803 181.293 66.8886C181.293 66.8886 182.334 67.2635 183.438 67.2427C184.542 67.2427 185.583 66.8886 185.583 66.8886C185.104 66.6803 184.292 66.3262 183.438 66.3262Z"
        fill="#D74F25"
      />
      <path
        d="M185.935 66.6191C185.457 66.8483 184.457 67.0566 183.436 67.0566C182.416 67.0566 181.416 66.8483 180.938 66.6191"
        stroke="#D23C02"
        strokeWidth="0.14"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M184.977 59.6403C184.977 59.6403 187.142 58.828 189.183 59.6403"
        stroke="#6A3221"
        strokeWidth="0.23"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M181.914 59.6403C181.914 59.6403 179.748 58.828 177.707 59.6403"
        stroke="#6A3221"
        strokeWidth="0.23"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M177.627 215.068V219.505H168.984C170.151 218.609 170.984 217.672 171.129 216.734C171.129 216.693 171.129 216.63 171.129 216.589L170.9 213.631H177.71C177.668 214.193 177.648 214.672 177.627 215.068ZM189.309 215.068V219.505H197.952C196.786 218.609 195.953 217.672 195.807 216.734C195.807 216.693 195.807 216.63 195.807 216.589L196.036 213.631H189.226C189.268 214.193 189.289 214.672 189.309 215.068Z"
        fill="#D6D7F9"
      />
      <mask
        id="mask41_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="168"
        y="213"
        width="30"
        height="7">
        <path
          d="M177.627 215.068V219.505H168.984C170.151 218.609 170.984 217.672 171.129 216.734C171.129 216.693 171.129 216.63 171.129 216.589L170.9 213.631H177.71C177.668 214.193 177.648 214.672 177.627 215.068ZM189.309 215.068V219.505H197.952C196.786 218.609 195.953 217.672 195.807 216.734C195.807 216.693 195.807 216.63 195.807 216.589L196.036 213.631H189.226C189.268 214.193 189.289 214.672 189.309 215.068Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask41_3666_33194)">
        <path
          d="M179.77 216.295L167.316 214.503L179.77 210.941V216.274V216.295ZM187.246 216.295L199.699 214.503L187.246 210.941V216.274V216.295Z"
          fill="#AFADF2"
        />
      </g>
      <path
        d="M200.098 124.356C200.035 123.877 199.931 123.419 199.806 122.981C198.661 117.128 195.87 107.859 195.87 107.859H183.542L170.839 107.672C170.839 107.672 168.444 117.128 167.278 122.981C167.153 123.419 167.049 123.877 166.986 124.356C166.986 124.356 165.133 133.104 167.611 168.764C167.611 168.764 167.611 168.868 167.611 168.93C167.611 169.097 167.611 169.243 167.652 169.389L170.089 214.525H178.606C178.606 214.525 181.376 168.826 181.355 168.285L183.396 126.293C183.396 126.293 183.459 126.168 183.521 126.168C183.521 126.168 183.646 126.231 183.646 126.293L185.687 168.285C185.666 168.826 188.436 214.525 188.436 214.525H196.953L199.39 169.389C199.39 169.243 199.41 169.076 199.431 168.93C199.431 168.868 199.431 168.826 199.431 168.764C201.889 133.104 200.056 124.356 200.056 124.356H200.098Z"
        fill="#5046B5"
      />
      <mask
        id="mask42_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="166"
        y="107"
        width="35"
        height="108">
        <path
          d="M200.098 124.358C200.035 123.879 199.931 123.421 199.806 122.983C198.661 117.13 195.87 107.861 195.87 107.861H183.542H171.214C171.214 107.861 168.444 117.13 167.278 122.983C167.153 123.421 167.049 123.879 166.986 124.358C166.986 124.358 165.133 133.106 167.611 168.766C167.611 168.766 167.611 168.87 167.611 168.932C167.611 169.099 167.611 169.245 167.652 169.391L170.089 214.527H178.606C178.606 214.527 181.376 168.828 181.355 168.287L183.396 126.295C183.396 126.295 183.459 126.17 183.521 126.17C183.521 126.17 183.646 126.233 183.646 126.295L185.687 168.287C185.666 168.828 188.436 214.527 188.436 214.527H196.953L199.39 169.391C199.39 169.245 199.41 169.078 199.431 168.932C199.431 168.87 199.431 168.828 199.431 168.766C201.889 133.106 200.056 124.358 200.056 124.358H200.098Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask42_3666_33194)">
        <path d="M161.594 110.481L204.202 113.939L203.14 108.898L161.594 109.398V110.481Z" fill="#3A3988" />
        <path
          d="M167.632 210.692H203.451M176.92 107.858C176.92 113.92 172.005 118.815 165.966 118.815C159.926 118.815 155.012 113.899 155.012 107.858C155.012 101.818 159.926 96.9023 165.966 96.9023C172.005 96.9023 176.92 101.818 176.92 107.858ZM201.056 96.9023C194.996 96.9023 190.102 101.818 190.102 107.858C190.102 113.899 195.016 118.815 201.056 118.815C207.095 118.815 212.01 113.899 212.01 107.858C212.01 101.818 207.095 96.9023 201.056 96.9023ZM183.792 109.421H179.898V117.273C179.898 119.314 181.564 120.981 183.604 120.981H183.792V109.421Z"
          stroke="#3A3988"
          strokeWidth="0.14"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M203.533 81.0525C203.158 79.407 201.95 78.074 200.305 77.5116L188.706 73.5957L183.52 82.7814L178.335 73.5957L166.735 77.5116C165.09 78.074 163.861 79.407 163.507 81.0525L152.949 128.335L161.238 129.897L169.068 94.9664L169.88 109.901H197.14L198.098 93.4875L206.053 102.007L207.198 88.9468L203.554 81.0734L203.533 81.0525Z"
        fill="#8A80EC"
      />
      <mask
        id="mask43_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="152"
        y="73"
        width="60"
        height="57">
        <path
          d="M203.533 81.0525C203.158 79.407 201.95 78.074 200.305 77.5116L188.706 73.5957L183.52 82.7814L178.335 73.5957L166.735 77.5116C165.09 78.074 163.861 79.407 163.507 81.0525L152.949 128.335L161.238 129.897L169.068 94.9664L169.88 109.901H197.14L197.952 94.9664L207.74 103.131L211.717 100.299L203.533 81.0734V81.0525Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask43_3666_33194)">
        <path
          d="M168.691 90.1738L169.045 98.1931M198.367 93.7564L198.304 90.1738"
          stroke="#6455E4"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M172.046 75.7617L172.713 77.9279C172.962 78.7403 172.359 79.5735 171.505 79.5735H160.551L172.067 75.7826L172.046 75.7617ZM194.954 75.7617L194.287 77.9279C194.037 78.7403 194.641 79.5735 195.495 79.5735H206.449L194.933 75.7826L194.954 75.7617Z"
          fill="#B3CDB1"
        />
        <path
          d="M168.109 106.568H197.972M192.974 73.3451C192.974 78.5732 188.747 82.8015 183.52 82.8015C178.293 82.8015 174.065 78.5732 174.065 73.3451C174.065 68.117 178.293 63.8887 183.52 63.8887C188.747 63.8887 192.974 68.117 192.974 73.3451ZM171.233 87.1131C171.233 89.6751 173.295 91.7372 175.856 91.7372C178.418 91.7372 180.479 89.6751 180.479 87.1131H171.233Z"
          stroke="#AFADF2"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M144.348 123.582L166.297 127.29"
          stroke="#A9AEF3"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M222.671 123.582L200.742 127.29"
          stroke="#A9AEF3"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M158.341 228.564H178.604C178.895 228.564 179.145 228.335 179.145 228.043C179.208 226.356 179.687 220.649 178.083 218.274C177.812 217.879 177.25 217.774 176.875 218.087C175.959 218.795 174.085 219.941 172.523 218.774C171.315 217.879 170.586 217.066 170.045 217.379C164.901 220.566 160.903 221.274 158.841 223.273C157.571 224.523 157.695 227.148 157.779 228.085C157.8 228.356 158.049 228.564 158.32 228.564H158.341Z"
        fill="#B3CDB1"
      />
      <mask
        id="mask44_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="157"
        y="217"
        width="23"
        height="12">
        <path
          d="M158.341 228.564H178.604C178.895 228.564 179.145 228.335 179.145 228.043C179.208 226.356 179.687 220.649 178.083 218.274C177.812 217.879 177.25 217.774 176.875 218.087C175.959 218.795 174.085 219.941 172.523 218.774C171.315 217.879 170.586 217.066 170.045 217.379C164.901 220.566 160.903 221.274 158.841 223.273C157.571 224.523 157.695 227.148 157.779 228.085C157.8 228.356 158.049 228.564 158.32 228.564H158.341Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask44_3666_33194)">
        <path
          d="M157.84 225.088H180.747M164.525 219.589L166.274 221.714M166.003 218.506L167.753 220.63"
          stroke="#8FAE92"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M208.696 228.564H188.434C188.142 228.564 187.892 228.335 187.892 228.043C187.83 226.356 187.351 220.649 188.954 218.274C189.225 217.879 189.787 217.774 190.162 218.087C191.079 218.795 192.953 219.941 194.515 218.774C195.722 217.879 196.451 217.066 196.993 217.379C202.137 220.566 206.135 221.274 208.197 223.273C209.467 224.523 209.342 227.148 209.259 228.085C209.238 228.356 208.988 228.564 208.717 228.564H208.696Z"
        fill="#B3CDB1"
      />
      <mask
        id="mask45_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="187"
        y="217"
        width="23"
        height="12">
        <path
          d="M208.696 228.564H188.434C188.142 228.564 187.892 228.335 187.892 228.043C187.83 226.356 187.351 220.649 188.954 218.274C189.225 217.879 189.787 217.774 190.162 218.087C191.079 218.795 192.953 219.941 194.515 218.774C195.722 217.879 196.451 217.066 196.993 217.379C202.137 220.566 206.135 221.274 208.197 223.273C209.467 224.523 209.342 227.148 209.259 228.085C209.238 228.356 208.988 228.564 208.717 228.564H208.696Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask45_3666_33194)">
        <path
          d="M186.289 225.083H209.196M200.762 221.708L202.512 219.584M199.284 220.646L201.033 218.521"
          stroke="#8FAE92"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M176.813 60.9103L181.54 54.7241L190.182 60.9103C190.182 60.9103 192.702 52.662 181.811 53.266C175.188 53.6409 176.813 60.9103 176.813 60.9103Z"
        fill="#6A3221"
      />
      <path
        d="M191.119 56.0989C191.119 56.0989 193.43 54.3701 190.14 52.4747C187.391 50.9125 184.934 50.6417 183.913 50.6001V50.0377C183.913 49.7669 183.705 49.5586 183.434 49.5586C183.164 49.5586 182.955 49.7669 182.955 50.0377V50.6001C181.935 50.6417 179.478 50.9125 176.729 52.4747C173.438 54.3701 175.75 56.0989 175.75 56.0989L175.021 57.6403C174.854 57.9944 175.208 58.3693 175.562 58.2235C179.144 56.7655 182.664 56.6197 183.413 56.5988C184.163 56.5988 187.683 56.7655 191.264 58.2235C191.618 58.3693 191.973 57.9944 191.806 57.6403L191.077 56.0989H191.119Z"
        fill="#8A80EC"
      />
      <mask
        id="mask46_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="174"
        y="49"
        width="18"
        height="10">
        <path
          d="M191.119 56.0989C191.119 56.0989 193.43 54.3701 190.14 52.4747C187.391 50.9125 184.934 50.6417 183.913 50.6001V50.0377C183.913 49.7669 183.705 49.5586 183.434 49.5586C183.164 49.5586 182.955 49.7669 182.955 50.0377V50.6001C181.935 50.6417 179.478 50.9125 176.729 52.4747C173.438 54.3701 175.75 56.0989 175.75 56.0989L175.021 57.6403C174.854 57.9944 175.208 58.3693 175.562 58.2235C179.144 56.7655 182.664 56.6197 183.413 56.5988C184.163 56.5988 187.683 56.7655 191.264 58.2235C191.618 58.3693 191.973 57.9944 191.806 57.6403L191.077 56.0989H191.119Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask46_3666_33194)">
        <path
          d="M183.787 66.094C189.883 66.094 194.824 63.4269 194.824 60.1368C194.824 56.8468 189.883 54.1797 183.787 54.1797C177.692 54.1797 172.75 56.8468 172.75 60.1368C172.75 63.4269 177.692 66.094 183.787 66.094Z"
          stroke="#AFADF2"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M192.973 87.1543C192.848 87.196 192.723 87.2376 192.598 87.3001C192.827 87.5709 193.264 88.1749 193.493 89.0706C193.577 89.4247 193.639 89.8413 193.639 90.2787C193.639 90.362 193.639 90.4453 193.618 90.5286C193.618 90.4453 193.618 90.362 193.618 90.2578C193.597 89.6954 193.389 89.2164 193.139 88.7998C192.806 88.2582 192.369 87.8625 192.056 87.6334C191.952 87.7167 191.848 87.8 191.765 87.8833C191.973 88.0499 192.265 88.2999 192.535 88.6332C192.889 89.0706 193.202 89.633 193.243 90.2995C193.243 90.5494 193.243 90.7369 193.181 90.9035C193.202 90.7161 193.181 90.487 193.139 90.2578C192.994 89.5288 192.473 89.0289 191.931 88.6956C191.723 88.5707 191.515 88.4665 191.328 88.3832C191.244 88.4874 191.182 88.5915 191.119 88.7165C191.223 88.7581 191.348 88.8206 191.494 88.9039C192.015 89.1955 192.619 89.6538 192.744 90.3412C192.806 90.6328 192.785 90.8827 192.744 91.0702C192.744 90.487 192.369 90.0079 191.744 89.6538C191.473 89.508 191.223 89.4038 191.036 89.3622C190.974 89.3622 190.932 89.3414 190.89 89.3205C190.849 89.4455 190.828 89.5705 190.807 89.6955C190.807 89.6955 190.849 89.6955 190.869 89.6955C191.286 89.8204 192.39 90.2162 192.39 91.1118C192.39 91.4659 192.14 91.5701 191.577 91.5701H189.953V91.945H192.39C193.285 91.945 194.014 91.1952 194.035 90.2995C194.035 88.7165 193.389 87.6542 192.994 87.1543H192.973Z"
        fill="#464EBA"
      />
      <path
        d="M194.409 91.1738C194.18 91.1738 193.992 91.3405 193.992 91.5488C193.992 91.757 194.159 91.9237 194.409 91.9237C194.659 91.9237 194.804 91.757 194.804 91.5488C194.804 91.3405 194.638 91.1738 194.409 91.1738Z"
        fill="#464EBA"
      />
      <path
        d="M211.15 71.6991C211.15 71.6991 211.087 72.9697 211.066 73.5945C211.066 73.5945 211.025 75.0526 213.191 75.8649C214.544 76.3648 216.106 74.9901 216.106 74.9901C216.106 74.9901 217.939 73.9695 219.105 69.0955L220.937 63.2217C221.187 62.5343 220.979 62.1177 220.729 61.9511C220.417 61.7428 220.167 61.8469 220.084 61.8469L220.146 61.6178C220.25 61.2012 220.021 60.7846 219.605 60.6805C219.376 60.618 219.147 60.6805 218.959 60.7846C218.959 60.4514 218.772 60.1389 218.438 60.014C217.73 59.764 217.481 60.5347 217.314 60.8263C217.293 60.5347 217.085 60.2639 216.793 60.1598H216.648C216.273 60.1389 215.919 60.3681 215.794 60.743C215.19 62.5759 213.899 66.9501 213.899 66.9501H213.607L214.336 64.1173C214.461 63.7007 214.523 63.1592 213.961 62.93C213.316 62.6801 212.878 63.4091 212.878 63.4091C212.878 63.4091 210.629 69.3871 211.171 71.6991H211.15Z"
        fill="#DC8D74"
      />
      <mask
        id="mask47_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="211"
        y="59"
        width="11"
        height="17">
        <path
          d="M211.15 71.6991C211.15 71.6991 211.087 72.9697 211.066 73.5945C211.066 73.5945 211.025 75.0526 213.191 75.8649C214.544 76.3648 216.106 74.9901 216.106 74.9901C216.106 74.9901 217.939 73.9695 219.105 69.0955L220.937 63.2217C221.187 62.5343 220.979 62.1177 220.729 61.9511C220.417 61.7428 220.167 61.8469 220.084 61.8469L220.146 61.6178C220.25 61.2012 220.021 60.7846 219.605 60.6805C219.376 60.618 219.147 60.6805 218.959 60.7846C218.959 60.4514 218.772 60.1389 218.438 60.014C217.73 59.764 217.481 60.5347 217.314 60.8263C217.293 60.5347 217.085 60.2639 216.793 60.1598H216.648C216.273 60.1389 215.919 60.3681 215.794 60.743C215.19 62.5759 213.899 66.9501 213.899 66.9501H213.607L214.336 64.1173C214.461 63.7007 214.523 63.1592 213.961 62.93C213.316 62.6801 212.878 63.4091 212.878 63.4091C212.878 63.4091 210.629 69.3871 211.171 71.6991H211.15Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask47_3666_33194)">
        <path
          d="M217.875 68.1173L219.957 61.9727"
          stroke="#BF623F"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M215.418 67.1171L217.521 60.3477"
          stroke="#BF623F"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M216.73 67.4915L218.938 60.7637"
          stroke="#BF623F"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M214.524 71.3893C214.524 71.3893 214.732 69.598 212.004 67.8691"
          stroke="#BF623F"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M218.272 68.5127C218.272 68.5127 217.106 67.2838 214.398 67.0547"
          stroke="#DC8D74"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M208.425 99.671C206.363 99.2336 205.031 97.1923 205.489 95.1094L210.799 73.3846C211.236 71.3225 211.965 70.1353 214.027 70.5727C216.089 71.0101 216.547 72.3223 216.193 74.4052C215.922 76.0507 213.131 96.3383 213.131 96.3383C212.694 98.4004 210.487 100.108 208.404 99.671H208.425Z"
        fill="#DC8D74"
      />
      <path
        d="M204.987 95.7777L209.819 71.8867L218.378 73.8655C218.378 73.8655 213.421 98.798 213.359 99.0271C212.609 101.777 210.652 103.714 207.299 102.797C203.946 101.881 204.966 95.7986 204.966 95.7986L204.987 95.7777Z"
        fill="#8A80EC"
      />
      <path d="M209.215 74.7598L217.94 76.5719" stroke="#A9AEF3" strokeWidth="0.14" strokeLinejoin="round" />
      <path
        d="M276.023 216.753C276.564 219.939 286.789 223.689 288.309 224.23C288.642 224.355 288.913 224.647 288.976 225.001C288.976 225.043 288.976 225.105 288.976 225.147C288.976 225.709 288.517 226.147 287.976 226.147H276.023H271.524C270.337 226.147 269.4 225.188 269.4 224.022V216.732C269.4 216.732 269.213 213.42 272.711 213.42C275.835 213.42 276.023 216.732 276.023 216.732V216.753Z"
        fill="#F8C2A9"
      />
      <path
        d="M264.172 170.137C264.172 166.387 267.212 163.367 270.94 163.367C274.668 163.367 277.708 166.408 277.708 170.137C277.708 170.282 277.708 170.428 277.708 170.595L276.021 216.606C276.021 216.606 276.021 216.711 276.021 216.752C276.021 218.585 274.543 220.064 272.71 220.064C270.878 220.064 269.399 218.585 269.399 216.752C269.399 216.752 264.193 170.657 264.193 170.137H264.172Z"
        fill="#F8C2A9"
      />
      <path
        d="M259.238 128.915C259.238 124.124 263.112 120.25 267.901 120.25C272.129 120.25 275.669 123.291 276.419 127.311C276.419 127.311 279.98 142.412 277.71 169.99C277.585 173.739 274.69 176.926 270.942 176.926C267.193 176.926 264.486 174.093 264.174 170.157L259.238 129.706H259.28C259.259 129.436 259.238 129.186 259.238 128.915Z"
        fill="#F8C2A9"
      />
      <path
        d="M242.453 216.753C241.912 219.939 231.687 223.689 230.166 224.23C229.833 224.355 229.562 224.647 229.5 225.001C229.5 225.043 229.5 225.105 229.5 225.147C229.5 225.709 229.958 226.147 230.5 226.147H242.453H246.951C248.138 226.147 249.075 225.188 249.075 224.022V216.732C249.075 216.732 249.263 213.42 245.764 213.42C242.641 213.42 242.453 216.732 242.453 216.732V216.753Z"
        fill="#F8C2A9"
      />
      <path
        d="M254.302 170.137C254.302 166.387 251.261 163.367 247.534 163.367C243.806 163.367 240.766 166.408 240.766 170.137C240.766 170.282 240.766 170.428 240.766 170.595L242.452 216.606C242.452 216.606 242.452 216.711 242.452 216.752C242.452 218.585 243.931 220.064 245.764 220.064C247.596 220.064 249.075 218.585 249.075 216.752C249.075 216.752 254.281 170.657 254.281 170.137H254.302Z"
        fill="#F8C2A9"
      />
      <path
        d="M259.24 128.915C259.24 124.124 255.366 120.25 250.576 120.25C246.349 120.25 242.809 123.291 242.059 127.311C242.059 127.311 239.747 135.622 240.768 169.99C240.893 173.739 243.788 176.926 247.536 176.926C251.284 176.926 253.992 174.093 254.304 170.157L259.24 129.706H259.198C259.219 129.436 259.24 129.186 259.24 128.915Z"
        fill="#F8C2A9"
      />
      <path
        d="M284.354 132.538C284.354 134.35 283.438 139.474 287.644 139.641C289.456 139.703 291.268 138.141 290.935 136.35C290.601 134.559 289.831 131.58 289.831 131.58L284.354 132.559V132.538Z"
        fill="#F8C2A9"
      />
      <path
        d="M286.936 143.87C287.519 143.662 287.457 143.099 287.332 142.662L286.582 139.454L284.271 135.268C283.708 140.079 285.832 143.349 285.832 143.349C285.832 143.349 286.27 144.12 286.915 143.87H286.936Z"
        fill="#F8C2A9"
      />
      <path
        d="M291.467 147.117C291.045 147.232 290.59 146.99 290.469 146.548L288.09 137.849L289.637 137.425L292.016 146.125C292.132 146.547 291.889 147.002 291.447 147.123L291.467 147.117Z"
        fill="#F8C2A9"
      />
      <path
        d="M292.704 146.519C293.142 146.415 293.412 145.998 293.308 145.561L290.872 136.062L289.414 136.458L291.746 145.915C291.851 146.352 292.267 146.623 292.704 146.519Z"
        fill="#F8C2A9"
      />
      <path
        d="M279.878 105.775C281.96 105.234 284.084 106.504 284.626 108.587L289.665 130.77C290.207 132.853 290.082 134.249 287.999 134.79C285.917 135.332 284.896 134.353 284.272 132.291C283.772 130.666 277.066 110.524 277.066 110.524C276.525 108.441 277.795 106.317 279.878 105.775Z"
        fill="#F8C2A9"
      />
      <path
        d="M274.023 81.8205C276.106 81.2998 278.23 82.5912 278.75 84.6741L284.706 108.836C285.227 110.919 283.936 113.043 281.853 113.564C279.771 114.085 277.647 112.793 277.126 110.711L271.17 86.5487C270.649 84.4658 271.941 82.3413 274.023 81.8205Z"
        fill="#F8C2A9"
      />
      <path
        d="M271.962 111.4C271.379 109.317 271.233 107.151 271.566 105.026L276.46 82.0098L259.238 75.5527L242.036 82.0098L246.93 105.026C247.263 107.151 247.118 109.338 246.534 111.4C246.534 111.4 241.932 125.064 241.641 129.688H276.897C276.272 122.96 271.983 111.4 271.983 111.4H271.962Z"
        fill="#F8C2A9"
      />
      <path
        d="M259.241 68.2832C257.033 68.2832 255.242 70.0745 255.242 72.2824V80.4891C255.242 82.697 257.033 84.4883 259.241 84.4883C261.448 84.4883 263.239 82.697 263.239 80.4891V72.2824C263.239 70.0745 261.448 68.2832 259.241 68.2832Z"
        fill="#F8C2A9"
      />
      <mask
        id="mask48_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="255"
        y="68"
        width="9"
        height="17">
        <path
          d="M259.241 68.2832C257.033 68.2832 255.242 70.0745 255.242 72.2824V80.4891C255.242 82.697 257.033 84.4883 259.241 84.4883C261.448 84.4883 263.239 82.697 263.239 80.4891V72.2824C263.239 70.0745 261.448 68.2832 259.241 68.2832Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask48_3666_33194)">
        <path
          d="M263.26 66.8468C263.26 64.639 261.469 62.8477 259.262 62.8477V74.8452H263.26V66.8468Z"
          fill="#E89B7F"
        />
        <path
          d="M259.429 54.0352C259.429 54.0352 259.345 54.0352 259.283 54.0352H259.241H259.2C259.2 54.0352 259.116 54.0352 259.054 54.0352C255.16 54.1601 252.286 57.2637 252.286 61.2004C252.286 61.6378 252.286 63.8457 252.286 64.5122C252.14 71.3025 255.597 74.656 259.179 74.7185H259.22H259.262C262.844 74.6352 266.155 70.2402 266.155 64.5122V61.2004C266.155 57.2637 263.281 54.1601 259.387 54.0352H259.429Z"
          stroke="#E89B7F"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <path
        d="M284.271 135.268C284.229 134.206 284.354 133.164 284.354 132.54L289.831 131.561C289.831 131.561 290.539 134.289 290.873 136.039L291.393 138.038L293.871 144.516C293.975 144.829 293.809 145.183 293.497 145.287C293.413 145.308 293.33 145.329 293.247 145.308L293.309 145.558C293.413 145.995 293.122 146.412 292.705 146.516C292.455 146.578 292.226 146.516 292.039 146.37C292.039 146.724 291.81 147.057 291.456 147.141C291.081 147.245 290.706 147.078 290.539 146.745C290.498 147.057 290.269 147.328 289.956 147.412C289.519 147.536 289.082 147.287 288.978 146.849L286.978 139.559C286.833 139.538 286.708 139.496 286.583 139.455L287.332 142.662C287.457 143.1 287.499 143.641 286.937 143.871C286.291 144.121 285.854 143.35 285.854 143.35C285.854 143.35 283.709 140.08 284.292 135.268H284.271Z"
        fill="#F8C2A9"
      />
      <mask
        id="mask49_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="284"
        y="131"
        width="10"
        height="17">
        <path
          d="M284.271 135.268C284.229 134.206 284.354 133.164 284.354 132.54L289.831 131.561C289.831 131.561 290.539 134.289 290.873 136.039L291.393 138.038L293.871 144.516C293.975 144.829 293.809 145.183 293.497 145.287C293.413 145.308 293.33 145.329 293.247 145.308L293.309 145.558C293.413 145.995 293.122 146.412 292.705 146.516C292.455 146.578 292.226 146.516 292.039 146.37C292.039 146.724 291.81 147.057 291.456 147.141C291.081 147.245 290.706 147.078 290.539 146.745C290.498 147.057 290.269 147.328 289.956 147.412C289.519 147.536 289.082 147.287 288.978 146.849L286.978 139.559C286.833 139.538 286.708 139.496 286.583 139.455L287.332 142.662C287.457 143.1 287.499 143.641 286.937 143.871C286.291 144.121 285.854 143.35 285.854 143.35C285.854 143.35 283.709 140.08 284.292 135.268H284.271Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask49_3666_33194)">
        <path
          d="M291.496 138.037L293.183 145.182"
          stroke="#E89B7F"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M288.852 139.516L290.538 146.743"
          stroke="#E89B7F"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M290.371 139.18L292.037 146.387"
          stroke="#E89B7F"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path d="M290.871 131.911L282.52 135.264L281.438 131.578L290.455 129.703L290.871 131.911Z" fill="#E89B7F" />
      </g>
      <path
        d="M259.426 53.929C259.426 53.929 259.342 53.929 259.28 53.929H259.238H259.197C259.197 53.929 259.113 53.929 259.051 53.929C255.157 54.054 252.283 57.1575 252.283 61.0942C252.283 61.5317 252.262 63.7396 252.283 64.4061C252.304 65.0726 253.012 68.9052 253.012 68.9052C253.949 72.6336 256.635 74.5707 259.176 74.6123H259.217H259.259C261.737 74.5499 264.174 73.1335 265.423 68.9052C265.423 68.9052 266.048 65.7808 266.173 64.3853C266.215 63.7395 266.173 61.5317 266.173 61.0734C266.173 57.1367 263.299 54.0332 259.405 53.9082L259.426 53.929Z"
        fill="#FBC5AC"
      />
      <path
        d="M253.094 68.8455C253.094 68.8455 251.657 68.0332 251.178 66.9501C250.678 65.7836 251.136 64.6172 252.448 64.6172L253.094 68.8247V68.8455Z"
        fill="#F8C2A9"
      />
      <path
        d="M259.198 74.5095H259.24H259.282C261.843 74.447 264.259 72.1766 265.446 68.8023C265.737 68.6357 266.883 67.8858 267.278 66.9485C267.757 65.8238 267.341 64.7198 266.175 64.6365C266.175 64.5323 266.175 64.4074 266.175 64.3032V60.9914C266.175 57.0547 263.301 53.9511 259.407 53.8262C259.365 53.8262 259.323 53.8262 259.261 53.8262H259.219H259.177C259.177 53.8262 259.094 53.8262 259.032 53.8262C255.137 53.9511 252.264 57.0547 252.264 60.9914V64.3032C252.264 64.4074 252.264 64.5323 252.264 64.6365C251.097 64.7198 250.681 65.8446 251.16 66.9485C251.556 67.8858 252.701 68.6149 252.992 68.8023"
        fill="#F8C2A9"
      />
      <mask
        id="mask50_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="250"
        y="53"
        width="18"
        height="22">
        <path
          d="M259.198 74.5095H259.24H259.282C261.843 74.447 264.259 72.1766 265.446 68.8023C265.737 68.6357 266.883 67.8858 267.278 66.9485C267.757 65.8238 267.341 64.7198 266.175 64.6365C266.175 64.5323 266.175 64.4074 266.175 64.3032V60.9914C266.175 57.0547 263.301 53.9511 259.407 53.8262C259.365 53.8262 259.323 53.8262 259.261 53.8262H259.219H259.177C259.177 53.8262 259.094 53.8262 259.032 53.8262C255.137 53.9511 252.264 57.0547 252.264 60.9914V64.3032C252.264 64.4074 252.264 64.5323 252.264 64.6365C251.097 64.7198 250.681 65.8446 251.16 66.9485C251.556 67.8858 252.701 68.6149 252.992 68.8023"
          fill="white"
        />
      </mask>
      <g mask="url(#mask50_3666_33194)">
        <path
          d="M252.203 64.5312C252.203 64.5312 252.578 66.9058 252.953 68.947"
          stroke="#E89B7F"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M266.28 64.5508C266.28 64.5508 265.946 67.0711 265.488 69.0499"
          stroke="#E89B7F"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <path
        d="M258.467 64.9121C258.571 65.3912 258.654 66.3077 258.342 67.5574C258.009 68.8696 259.362 68.8905 259.362 68.8905"
        stroke="#E89B7F"
        strokeWidth="0.14"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M259.884 69.0572C259.965 69.0572 260.03 68.992 260.03 68.9114C260.03 68.8309 259.965 68.7656 259.884 68.7656C259.804 68.7656 259.738 68.8309 259.738 68.9114C259.738 68.992 259.804 69.0572 259.884 69.0572Z"
        fill="#E89B7F"
      />
      <path
        d="M259.239 109.652C259.423 109.652 259.573 109.456 259.573 109.215C259.573 108.973 259.423 108.777 259.239 108.777C259.055 108.777 258.906 108.973 258.906 109.215C258.906 109.456 259.055 109.652 259.239 109.652Z"
        fill="#E89B7F"
      />
      <path
        d="M259.24 70.0742C258.47 70.0742 257.762 70.3867 257.324 70.5741C257.324 70.5741 258.261 70.9074 259.24 70.8866C260.219 70.8866 261.156 70.5741 261.156 70.5741C260.719 70.3867 260.011 70.0742 259.24 70.0742Z"
        fill="#E77453"
      />
      <path
        d="M259.24 70.9062L257.324 70.5938C257.324 70.5938 257.574 72.0101 259.24 72.0101C260.906 72.0101 261.156 70.5938 261.156 70.5938L259.24 70.9062Z"
        fill="#E77453"
      />
      <path
        d="M261.531 70.4082C261.093 70.6165 260.177 70.9081 259.24 70.9081C258.303 70.9081 257.407 70.6373 256.949 70.4082"
        stroke="#D74F25"
        strokeWidth="0.14"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M257.822 62.8895C257.822 62.8895 257.802 63.0561 257.739 63.1394C257.739 63.1394 257.614 63.2436 257.552 63.2436C257.073 63.1394 255.365 62.7853 253.678 63.2436C253.616 63.2436 253.533 63.2436 253.512 63.1603C253.512 63.1603 253.512 62.9936 253.595 62.9728C254.074 62.7853 255.823 62.2021 257.718 62.7229C257.802 62.7437 257.843 62.827 257.843 62.9103L257.822 62.8895Z"
        fill="#A95B46"
      />
      <path
        d="M260.654 62.8895C260.654 62.8895 260.674 63.0561 260.737 63.1394C260.737 63.1394 260.862 63.2436 260.924 63.2436C261.403 63.1394 263.111 62.7853 264.798 63.2436C264.86 63.2436 264.944 63.2436 264.964 63.1603C264.964 63.1603 264.964 62.9936 264.881 62.9728C264.402 62.7853 262.653 62.2021 260.758 62.7229C260.674 62.7437 260.633 62.827 260.633 62.9103L260.654 62.8895Z"
        fill="#A95B46"
      />
      <path
        d="M257.574 65.2575C257.574 65.2575 256.325 63.6537 254.055 64.7993C254.055 64.7993 255.263 67.2363 257.574 65.2575Z"
        fill="white"
      />
      <path
        d="M254.074 64.8009C256.344 63.6553 257.531 65.2383 257.531 65.2383"
        stroke="#672F20"
        strokeWidth="0.14"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M256.761 64.6132C256.865 64.6757 256.844 64.8631 256.865 64.9881C256.886 65.5297 256.469 66.0087 255.928 66.0296C255.387 66.0504 254.908 65.6338 254.887 65.0922C254.887 64.8631 254.949 64.634 255.074 64.4674C255.074 64.4674 255.949 64.1966 256.782 64.6132H256.761Z"
        fill="#672F20"
      />
      <path
        d="M260.906 65.2399C260.906 65.2399 262.156 63.6361 264.426 64.7817C264.426 64.7817 263.218 67.2187 260.906 65.2399Z"
        fill="white"
      />
      <path
        d="M264.406 64.8009C262.136 63.6553 260.949 65.2383 260.949 65.2383"
        stroke="#672F20"
        strokeWidth="0.14"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M261.718 64.5936C261.614 64.6561 261.635 64.8436 261.614 64.9686C261.593 65.5101 262.01 65.9892 262.551 66.01C263.093 66.0308 263.572 65.6143 263.592 65.0727C263.592 64.8436 263.53 64.6145 263.405 64.4478C263.405 64.4478 262.53 64.1771 261.697 64.5936H261.718Z"
        fill="#672F20"
      />
      <path
        d="M261.863 54.5605C261.863 54.5605 269.214 56.9559 273.942 54.8522V58.3098C273.942 58.3098 266.84 60.2886 261.863 54.5605Z"
        fill="#6455E4"
      />
      <path
        d="M261.758 54.2676C261.758 54.2676 267.485 59.4749 272.649 59.4957L271.233 62.6617C271.233 62.6617 263.944 61.5369 261.779 54.2676H261.758Z"
        fill="#6455E4"
      />
      <path
        d="M259.238 56.8268C261.975 56.8268 264.194 54.6073 264.194 51.8694C264.194 49.1316 261.975 46.9121 259.238 46.9121C256.5 46.9121 254.281 49.1316 254.281 51.8694C254.281 54.6073 256.5 56.8268 259.238 56.8268Z"
        fill="#AD5B46"
      />
      <mask
        id="mask51_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="254"
        y="46"
        width="11"
        height="11">
        <path
          d="M259.238 56.8268C261.975 56.8268 264.194 54.6073 264.194 51.8694C264.194 49.1316 261.975 46.9121 259.238 46.9121C256.5 46.9121 254.281 49.1316 254.281 51.8694C254.281 54.6073 256.5 56.8268 259.238 56.8268Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask51_3666_33194)">
        <path
          d="M259.215 69.178C254.259 69.178 250.219 65.1372 250.219 60.1798C250.219 55.2225 254.259 51.1816 259.215 51.1816C264.171 51.1816 268.212 55.2225 268.212 60.1798C268.212 65.1372 264.171 69.178 259.215 69.178ZM259.215 56.0765C256.945 56.0765 255.113 57.9095 255.113 60.1798C255.113 62.4502 256.945 64.2832 259.215 64.2832C261.485 64.2832 263.318 62.4502 263.318 60.1798C263.318 57.9095 261.485 56.0765 259.215 56.0765Z"
          fill="#6455E4"
        />
      </g>
      <path
        d="M259.113 53.7246C251.179 53.7246 251.345 62.0563 251.907 64.7016L252.282 64.6391L255.989 58.6403L259.217 60.5566L266.173 64.6599L266.547 64.7224C267.11 62.0979 267.047 53.7454 259.113 53.7454V53.7246Z"
        fill="#AD5B46"
      />
      <mask
        id="mask52_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="251"
        y="53"
        width="16"
        height="12">
        <path
          d="M259.113 53.7246C251.179 53.7246 251.345 62.0563 251.907 64.7016L252.282 64.6391L255.989 58.6403L259.217 60.5566L266.173 64.6599L266.547 64.7224C267.11 62.0979 267.047 53.7454 259.113 53.7454V53.7246Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask52_3666_33194)">
        <path
          d="M255.863 53.9355V59.5177"
          stroke="#672F20"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <path
        d="M229.71 228.564H253.347C253.68 228.564 253.971 228.294 253.971 227.96C254.055 225.773 254.742 217.733 251.993 215.775H242.164C238.561 219.025 232.397 220.087 230.314 222.399C228.919 223.94 228.961 226.919 229.065 228.002C229.106 228.335 229.377 228.564 229.69 228.564H229.71Z"
        fill="#8FAE92"
      />
      <mask
        id="mask53_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="229"
        y="215"
        width="26"
        height="14">
        <path
          d="M229.71 228.564H253.347C253.68 228.564 253.971 228.294 253.971 227.96C254.055 225.773 254.742 217.733 251.993 215.775H242.164C238.561 219.025 232.397 220.087 230.314 222.399C228.919 223.94 228.961 226.919 229.065 228.002C229.106 228.335 229.377 228.564 229.69 228.564H229.71Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask53_3666_33194)">
        <path
          d="M228.629 224.5H255.347M236.438 218.084L238.479 220.584M238.167 216.855L240.208 219.355"
          stroke="#B3CDB1"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M237.855 217.17L255.619 220.795V216.754L237.855 217.17Z" fill="#7D9C80" />
      </g>
      <path
        d="M288.768 228.564H265.132C264.799 228.564 264.507 228.294 264.507 227.96C264.424 225.773 263.737 217.733 266.486 215.775H276.315C279.918 219.025 286.082 220.087 288.165 222.399C289.56 223.94 289.518 226.919 289.414 228.002C289.372 228.335 289.102 228.564 288.789 228.564H288.768Z"
        fill="#8FAE92"
      />
      <mask
        id="mask54_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="264"
        y="215"
        width="26"
        height="14">
        <path
          d="M288.768 228.564H265.132C264.799 228.564 264.507 228.294 264.507 227.96C264.424 225.773 263.737 217.733 266.486 215.775H276.315C279.918 219.025 286.082 220.087 288.165 222.399C289.56 223.94 289.518 226.919 289.414 228.002C289.372 228.335 289.102 228.564 288.789 228.564H288.768Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask54_3666_33194)">
        <path
          d="M289.832 224.5H263.113M282.022 218.084L279.981 220.584M280.294 216.855L278.253 219.355"
          stroke="#B3CDB1"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M280.627 217.17L262.863 220.795V216.754L280.627 217.17Z" fill="#7D9C80" />
      </g>
      <path d="M259.239 94.176L263.467 82.5117H255.012L259.239 94.176Z" fill="#D4D5F7" />
      <path
        d="M278.857 81.8851C278.69 81.1769 278.149 80.6354 277.441 80.4687L264.029 77.1152L259.24 90.071L254.45 77.1152L241.039 80.4687C240.331 80.6354 239.789 81.1977 239.623 81.8851L230.418 102.089L237.644 104.631L244.558 95.5907C245.891 100.423 246.849 109.213 246.849 109.213H271.547C271.547 109.213 270.964 106.276 272.297 101.444L280.19 133.645L290.581 131.563L278.815 81.8643L278.857 81.8851Z"
        fill="#6455E4"
      />
      <path
        d="M278.083 134.479C277.292 128.272 271.628 109.213 271.628 109.213H246.846C246.846 109.213 241.182 128.272 240.39 134.479C237.787 155.058 233.164 217.149 233.164 217.149H256.613L259.112 130.542C259.112 130.375 259.362 130.375 259.362 130.542L261.861 217.149H285.31C285.31 217.149 280.666 155.058 278.083 134.479Z"
        fill="#3A3988"
      />
      <mask
        id="mask55_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="233"
        y="109"
        width="53"
        height="109">
        <path
          d="M278.083 134.479C277.292 128.272 271.628 109.213 271.628 109.213H246.846C246.846 109.213 241.182 128.272 240.39 134.479C237.787 155.058 233.164 217.149 233.164 217.149H256.613L259.112 130.542C259.112 130.375 259.362 130.375 259.362 130.542L261.861 217.149H285.31C285.31 217.149 280.666 155.058 278.083 134.479Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask55_3666_33194)">
        <path d="M285.31 152.598H215.734" stroke="#5046B5" strokeWidth="0.14" strokeMiterlimit="10" />
        <path d="M285.31 189.738H215.734" stroke="#5046B5" strokeWidth="0.14" strokeMiterlimit="10" />
        <path
          d="M250.532 77.0098C250.532 152.599 215.754 152.62 215.754 152.62"
          stroke="#5046B5"
          strokeWidth="0.14"
          strokeMiterlimit="10"
        />
        <path
          d="M267.922 114.814C267.922 189.758 215.734 189.737 215.734 189.737"
          stroke="#5046B5"
          strokeWidth="0.14"
          strokeMiterlimit="10"
        />
        <path
          d="M285.31 152.621C285.31 152.621 285.31 218.608 215.734 218.608"
          stroke="#5046B5"
          strokeWidth="0.14"
          strokeMiterlimit="10"
        />
        <path d="M250.531 228.208V77.0098" stroke="#5046B5" strokeWidth="0.14" strokeMiterlimit="10" />
        <path d="M267.922 228.208V77.0098" stroke="#5046B5" strokeWidth="0.14" strokeMiterlimit="10" />
        <path
          d="M247.762 118.609H254.53"
          stroke="#6455E4"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M263.941 118.609H270.71"
          stroke="#6455E4"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <mask
        id="mask56_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="227"
        y="77"
        width="64"
        height="57">
        <path
          d="M278.856 81.8851C278.689 81.1769 278.148 80.6354 277.44 80.4687L264.028 77.1152L259.239 90.071L254.449 77.1152L241.038 80.4687C240.33 80.6354 239.788 81.1977 239.622 81.8851L227.855 131.583L238.247 133.666L246.14 101.464C247.473 106.297 246.889 109.234 246.889 109.234H271.588C271.588 109.234 271.005 106.297 272.338 101.464L280.23 133.666L290.622 131.583L278.856 81.8851Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask56_3666_33194)">
        <path
          d="M247.304 78.1758L247.97 80.342C248.22 81.1543 247.616 81.9667 246.763 81.9667H235.809L247.304 78.1758ZM271.19 78.1758L270.524 80.342C270.274 81.1543 270.878 81.9667 271.732 81.9667H282.686L271.19 78.1758Z"
          fill="#3A3988"
        />
        <path
          d="M246.139 102.068C244.181 96.34 245.368 90.6953 245.368 90.6953M272.316 102.068C274.273 96.34 273.086 90.6953 273.086 90.6953"
          stroke="#3A3988"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M262.382 98.0894C264.11 95.1733 265.818 91.6948 267.068 88.9037L265.527 86.2376L268.463 85.6128C270.171 81.3844 271.087 78.3434 271.087 78.3434L264.152 76.5312L259.3 89.0912M290.6 127.875L278.625 130.291M266.401 109.212C260.903 106.025 254.948 96.673 251.511 88.9037L253.052 86.2376L250.116 85.6128C248.408 81.3844 247.492 78.3434 247.492 78.3434L254.427 76.5312L266.38 109.233L266.401 109.212ZM254.968 103.547C254.135 103.547 253.448 104.234 253.448 105.067C253.448 105.9 254.135 106.588 254.968 106.588C255.801 106.588 256.489 105.9 256.489 105.067C256.489 104.234 255.801 103.547 254.968 103.547Z"
          stroke="#8A80EC"
          strokeWidth="0.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M269.775 89.5488C269.65 89.5905 269.525 89.6321 269.4 89.6946C269.629 89.9654 270.066 90.5695 270.275 91.4651C270.358 91.8192 270.42 92.2358 270.42 92.6732C270.42 92.7565 270.42 92.8398 270.4 92.9231C270.4 92.8398 270.4 92.7565 270.4 92.6524C270.379 92.09 270.17 91.6109 269.921 91.1943C269.587 90.6528 269.15 90.257 268.838 90.0279C268.734 90.1112 268.629 90.1945 268.546 90.2778C268.754 90.4445 269.046 90.6944 269.317 91.0277C269.671 91.4651 269.983 92.0275 270.025 92.694C270.025 92.944 270.025 93.1314 269.962 93.2981C269.983 93.1106 269.962 92.8815 269.921 92.6524C269.775 91.9233 269.254 91.4234 268.713 91.0902C268.504 90.9652 268.296 90.8611 268.109 90.7777C268.026 90.8819 267.963 90.986 267.901 91.111C268.005 91.1527 268.13 91.2152 268.275 91.2985C268.796 91.5901 269.4 92.0483 269.525 92.7357C269.587 93.0273 269.567 93.2772 269.525 93.4647C269.525 92.8815 269.15 92.4024 268.525 92.0483C268.255 91.9025 268.005 91.7984 267.817 91.7567C267.755 91.7567 267.713 91.7359 267.671 91.7151C267.63 91.84 267.609 91.965 267.588 92.09C267.588 92.09 267.63 92.09 267.651 92.09C268.067 92.215 269.171 92.6107 269.171 93.5064C269.171 93.8605 268.921 93.9646 268.359 93.9646H266.734V94.3395H269.171C270.066 94.3395 270.795 93.5897 270.816 92.694C270.816 91.111 270.171 90.0487 269.775 89.5488Z"
        fill="#3A3988"
      />
      <path
        d="M271.213 93.5684C270.984 93.5684 270.797 93.735 270.797 93.9433C270.797 94.1516 270.963 94.3182 271.213 94.3182C271.463 94.3182 271.609 94.1516 271.609 93.9433C271.609 93.735 271.442 93.5684 271.213 93.5684Z"
        fill="#3A3988"
      />
      <path
        d="M230.917 76.7796C230.917 76.7796 231.001 78.0502 231.022 78.6543C231.022 78.6543 231.084 80.1123 228.939 80.9455C227.606 81.4662 226.044 80.0915 226.044 80.0915C226.044 80.0915 224.212 79.0917 223.004 74.2801L221.13 68.4688C220.88 67.7815 221.067 67.3857 221.317 67.1982C221.63 66.9899 221.879 67.0941 221.963 67.0941L221.879 66.865C221.754 66.4692 222.004 66.0318 222.4 65.9277C222.629 65.8652 222.858 65.9277 223.025 66.0318C223.004 65.6985 223.212 65.3861 223.545 65.2611C224.253 65.0112 224.483 65.761 224.67 66.0526C224.67 65.761 224.878 65.4903 225.191 65.3861H225.336C225.711 65.3445 226.065 65.5944 226.19 65.9485C226.794 67.7606 228.148 72.0931 228.148 72.0931H228.439L227.69 69.2812C227.565 68.8646 227.481 68.323 228.044 68.0939C228.668 67.8439 229.126 68.573 229.126 68.573C229.126 68.573 231.438 74.4884 230.917 76.7796Z"
        fill="#F8C2A9"
      />
      <mask
        id="mask57_3666_33194"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="221"
        y="65"
        width="11"
        height="17">
        <path
          d="M230.917 76.7796C230.917 76.7796 231.001 78.0502 231.022 78.6543C231.022 78.6543 231.084 80.1123 228.939 80.9455C227.606 81.4662 226.044 80.0915 226.044 80.0915C226.044 80.0915 224.212 79.0917 223.004 74.2801L221.13 68.4688C220.88 67.7815 221.067 67.3857 221.317 67.1982C221.63 66.9899 221.879 67.0941 221.963 67.0941L221.879 66.865C221.754 66.4692 222.004 66.0318 222.4 65.9277C222.629 65.8652 222.858 65.9277 223.025 66.0318C223.004 65.6985 223.212 65.3861 223.545 65.2611C224.253 65.0112 224.483 65.761 224.67 66.0526C224.67 65.761 224.878 65.4903 225.191 65.3861H225.336C225.711 65.3445 226.065 65.5944 226.19 65.9485C226.794 67.7606 228.148 72.0931 228.148 72.0931H228.439L227.69 69.2812C227.565 68.8646 227.481 68.323 228.044 68.0939C228.668 67.8439 229.126 68.573 229.126 68.573C229.126 68.573 231.438 74.4884 230.917 76.7796Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask57_3666_33194)">
        <path
          d="M224.211 73.3015L222.066 67.2402"
          stroke="#E89B7F"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M226.627 72.3027L224.461 65.5957"
          stroke="#E89B7F"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M225.315 72.6985L223.066 66.0332"
          stroke="#E89B7F"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M227.563 76.5279C227.563 76.5279 227.334 74.7575 230.042 73.0078"
          stroke="#E89B7F"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M223.816 73.7204C223.816 73.7204 224.962 72.4707 227.648 72.2207"
          stroke="#E89B7F"
          strokeWidth="0.14"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <path
        d="M235.601 104.106C237.601 103.46 238.704 101.315 238.059 99.3152L230.687 78.3611C230.041 76.3615 229.229 75.2575 227.23 75.9032C225.231 76.5489 224.897 77.882 225.46 79.9024C225.897 81.5063 230.624 101.273 230.624 101.273C231.27 103.273 233.602 104.752 235.601 104.106Z"
        fill="#F8C2A9"
      />
      <path
        d="M238.892 100.152L232.52 77.7402L223.961 80.2397C223.961 80.2397 229.604 102.464 229.667 102.652C229.667 102.652 232.291 108.047 236.227 105.964C239.08 104.485 238.872 100.152 238.872 100.152H238.892Z"
        fill="#6455E4"
      />
      <path d="M224.523 82.4018L233.166 79.9648" stroke="#8A80EC" strokeWidth="0.14" strokeLinejoin="round" />
    </SvgLogoIcon>
  )
}
